const tile_sets = [
    { name: "Triangle 2",
      num_sides: 3,
      num_ends: 2,
      num_sets: 7
    },
    { name: "Square 1",
      num_sides: 4,
      num_ends: 1,
      num_sets: 2
    },
    { name: "Square 2",
      num_sides: 4,
      num_ends: 2,
      num_sets: 12
    },
    { name: "Square 3",
      num_sides: 4,
      num_ends: 3,
      num_sets: 2688
    },
    { name: "Pentagon 2",
      num_sides: 5,
      num_ends: 2,
      num_sets: 193
    },
    { name: "Hexagon 1",
      num_sides: 6,
      num_ends: 1,
      num_sets: 5
    },
    { name: "Hexagon 2",
      num_sides: 6,
      num_ends: 2,
      num_sets: 1799
    },
    { name: "Octagon 1",
      num_sides: 8,
      num_ends: 1,
      num_sets: 18
    },
];

const t2_data = [[1, 2, 3, 4, 5, 6],
                 [1, 2, 3, 6, 4, 5],
                 [1, 6, 2, 3, 4, 5],
                 [1, 2, 3, 5, 6, 4],
                 [1, 5, 2, 3, 6, 4],
                 [5, 1, 2, 4, 6, 3],
                 [1, 4, 2, 5, 6, 3]];

const s1_data = [[1, 2, 3, 4],
                 [1, 3, 4, 2]];

const s2_data = [[6, 1, 2, 7, 3, 5, 8, 4],
                 [7, 1, 6, 2, 3, 5, 8, 4],
                 [1, 7, 8, 2, 3, 5, 6, 4],
                 [1, 6, 2, 5, 3, 8, 4, 7],
                 [1, 6, 2, 5, 3, 7, 8, 4],
                 [1, 5, 6, 2, 3, 7, 8, 4],
                 [1, 5, 7, 2, 6, 3, 8, 4],
                 [1, 5, 2, 8, 6, 3, 7, 4],
                 [1, 5, 2, 8, 3, 7, 6, 4],
                 [5, 8, 1, 7, 2, 4, 6, 3],
                 [1, 7, 2, 4, 5, 3, 8, 6],
                 [1, 4, 7, 2, 3, 6, 8, 5]];

const s3_data = [[1,2,3,4,5,6,7,8,9,10,11,12],
                 [1,2,3,4,5,6,7,8,9,12,10,11],
                 [1,2,3,4,5,6,7,12,8,9,10,11],
                 [1,2,3,4,5,12,6,7,8,9,10,11],
                 [1,2,3,4,5,6,7,8,9,11,12,10],
                 [1,2,3,4,5,6,7,12,8,11,9,10],
                 [1,2,3,4,5,12,6,7,8,11,9,10],
                 [1,2,3,12,4,5,6,7,8,11,9,10],
                 [1,12,2,3,4,5,6,7,8,11,9,10],
                 [1,2,3,4,5,6,7,11,12,8,9,10],
                 [1,2,3,4,5,6,7,11,8,9,12,10],
                 [1,2,3,4,5,12,6,11,7,8,9,10],
                 [1,2,3,12,4,5,6,11,7,8,9,10],
                 [1,2,3,4,5,11,12,6,7,8,9,10],
                 [1,2,3,4,5,11,6,7,12,8,9,10],
                 [1,2,3,4,5,11,6,7,8,9,12,10],
                 [1,2,3,12,4,11,5,6,7,8,9,10],
                 [1,12,2,3,4,11,5,6,7,8,9,10],
                 [1,2,3,11,12,4,5,6,7,8,9,10],
                 [1,2,3,11,4,5,12,6,7,8,9,10],
                 [1,2,3,11,4,5,6,7,12,8,9,10],
                 [1,2,3,11,4,5,6,7,8,9,12,10],
                 [1,11,12,2,3,4,5,6,7,8,9,10],
                 [1,11,2,3,12,4,5,6,7,8,9,10],
                 [1,11,2,3,4,5,12,6,7,8,9,10],
                 [1,11,2,3,4,5,6,7,12,8,9,10],
                 [1,11,2,3,4,5,6,7,8,9,12,10],
                 [11,1,2,3,4,5,6,7,8,10,12,9],
                 [1,2,11,3,4,5,6,7,8,10,12,9],
                 [1,2,3,4,11,5,6,7,8,10,12,9],
                 [1,2,3,4,5,6,11,7,8,10,12,9],
                 [1,2,3,4,5,6,7,12,8,10,11,9],
                 [1,2,3,4,5,12,6,7,8,10,11,9],
                 [1,2,3,12,4,5,6,7,8,10,11,9],
                 [1,2,3,4,5,6,7,10,8,9,11,12],
                 [1,2,3,4,5,6,7,10,8,12,9,11],
                 [1,2,3,4,5,6,7,10,8,11,12,9],
                 [1,2,3,4,5,12,6,11,7,10,8,9],
                 [1,2,3,12,4,5,6,11,7,10,8,9],
                 [1,12,2,3,4,5,6,11,7,10,8,9],
                 [1,2,3,4,5,11,12,6,7,10,8,9],
                 [1,2,3,12,4,11,5,6,7,10,8,9],
                 [1,12,2,3,4,11,5,6,7,10,8,9],
                 [1,2,3,11,12,4,5,6,7,10,8,9],
                 [1,2,3,11,4,5,12,6,7,10,8,9],
                 [1,12,2,11,3,4,5,6,7,10,8,9],
                 [1,11,12,2,3,4,5,6,7,10,8,9],
                 [1,11,2,3,12,4,5,6,7,10,8,9],
                 [1,11,2,3,4,5,12,6,7,10,8,9],
                 [11,1,2,3,4,5,6,10,12,7,8,9],
                 [11,1,2,3,4,5,6,10,7,8,12,9],
                 [1,2,11,3,4,5,6,10,12,7,8,9],
                 [1,2,11,3,4,5,6,10,7,8,12,9],
                 [1,2,3,4,11,5,6,10,12,7,8,9],
                 [1,2,3,4,11,5,6,10,7,8,12,9],
                 [1,2,3,4,5,12,6,10,11,7,8,9],
                 [1,2,3,12,4,5,6,10,11,7,8,9],
                 [1,12,2,3,4,5,6,10,11,7,8,9],
                 [1,2,3,4,5,12,6,10,7,8,11,9],
                 [1,2,3,12,4,5,6,10,7,8,11,9],
                 [1,12,2,3,4,5,6,10,7,8,11,9],
                 [1,2,3,4,5,10,6,7,8,12,9,11],
                 [1,2,3,4,5,10,6,12,7,8,9,11],
                 [1,2,3,4,5,10,6,7,8,11,12,9],
                 [1,2,3,4,5,10,6,12,7,11,8,9],
                 [1,2,3,4,5,10,6,11,12,7,8,9],
                 [1,2,3,4,5,10,6,11,7,8,12,9],
                 [1,2,3,12,4,11,5,10,6,7,8,9],
                 [1,12,2,3,4,11,5,10,6,7,8,9],
                 [1,2,3,11,12,4,5,10,6,7,8,9],
                 [1,12,2,11,3,4,5,10,6,7,8,9],
                 [1,11,12,2,3,4,5,10,6,7,8,9],
                 [1,11,2,3,12,4,5,10,6,7,8,9],
                 [11,1,2,3,4,10,12,5,6,7,8,9],
                 [11,1,2,3,4,10,5,6,12,7,8,9],
                 [11,1,2,3,4,10,5,6,7,8,12,9],
                 [1,2,11,3,4,10,12,5,6,7,8,9],
                 [1,2,11,3,4,10,5,6,12,7,8,9],
                 [1,2,11,3,4,10,5,6,7,8,12,9],
                 [1,2,3,12,4,10,11,5,6,7,8,9],
                 [1,12,2,3,4,10,11,5,6,7,8,9],
                 [1,2,3,12,4,10,5,6,11,7,8,9],
                 [1,12,2,3,4,10,5,6,11,7,8,9],
                 [1,2,3,12,4,10,5,6,7,8,11,9],
                 [1,12,2,3,4,10,5,6,7,8,11,9],
                 [1,2,3,10,4,5,6,7,8,12,9,11],
                 [1,2,3,10,4,5,6,12,7,8,9,11],
                 [1,2,3,10,4,12,5,6,7,8,9,11],
                 [1,2,3,10,4,5,6,7,8,11,12,9],
                 [1,2,3,10,4,5,6,12,7,11,8,9],
                 [1,2,3,10,4,12,5,6,7,11,8,9],
                 [1,2,3,10,4,5,6,11,12,7,8,9],
                 [1,2,3,10,4,5,6,11,7,8,12,9],
                 [1,2,3,10,4,12,5,11,6,7,8,9],
                 [1,2,3,10,4,11,12,5,6,7,8,9],
                 [1,2,3,10,4,11,5,6,12,7,8,9],
                 [1,2,3,10,4,11,5,6,7,8,12,9],
                 [11,1,2,10,3,4,12,5,6,7,8,9],
                 [11,1,2,10,3,4,5,6,12,7,8,9],
                 [11,1,2,10,3,4,5,6,7,8,12,9],
                 [1,12,2,10,3,4,11,5,6,7,8,9],
                 [1,12,2,10,3,4,5,6,11,7,8,9],
                 [1,12,2,10,3,4,5,6,7,8,11,9],
                 [1,10,2,3,4,5,6,7,8,12,9,11],
                 [1,10,2,3,4,5,6,12,7,8,9,11],
                 [1,10,2,3,4,12,5,6,7,8,9,11],
                 [1,10,2,12,3,4,5,6,7,8,9,11],
                 [1,10,2,3,4,5,6,7,8,11,12,9],
                 [1,10,2,3,4,5,6,12,7,11,8,9],
                 [1,10,2,3,4,12,5,6,7,11,8,9],
                 [1,10,2,12,3,4,5,6,7,11,8,9],
                 [1,10,2,3,4,5,6,11,12,7,8,9],
                 [1,10,2,3,4,5,6,11,7,8,12,9],
                 [1,10,2,3,4,12,5,11,6,7,8,9],
                 [1,10,2,12,3,4,5,11,6,7,8,9],
                 [1,10,2,3,4,11,12,5,6,7,8,9],
                 [1,10,2,3,4,11,5,6,12,7,8,9],
                 [1,10,2,3,4,11,5,6,7,8,12,9],
                 [1,10,2,11,3,4,12,5,6,7,8,9],
                 [1,10,2,11,3,4,5,6,12,7,8,9],
                 [1,10,2,11,3,4,5,6,7,8,12,9],
                 [10,1,2,3,4,5,6,12,7,9,8,11],
                 [10,1,2,3,4,12,5,6,7,9,8,11],
                 [10,1,2,12,3,4,5,6,7,9,8,11],
                 [10,12,1,2,3,4,5,6,7,9,8,11],
                 [10,1,2,3,4,5,6,11,7,9,12,8],
                 [10,1,2,3,4,11,5,6,7,9,12,8],
                 [10,1,2,11,3,4,5,6,7,9,12,8],
                 [11,1,10,2,3,4,5,6,7,9,12,8],
                 [1,12,10,2,3,4,5,6,7,9,11,8],
                 [1,2,10,3,4,5,6,12,7,9,8,11],
                 [1,2,10,3,4,12,5,6,7,9,8,11],
                 [1,2,10,3,4,5,6,11,7,9,12,8],
                 [1,2,10,3,4,11,5,6,7,9,12,8],
                 [11,1,2,3,10,4,5,6,7,9,12,8],
                 [1,2,11,3,10,4,5,6,7,9,12,8],
                 [1,2,3,12,10,4,5,6,7,9,11,8],
                 [1,12,2,3,10,4,5,6,7,9,11,8],
                 [1,2,3,4,10,5,6,12,7,9,8,11],
                 [1,2,3,4,10,5,6,11,7,9,12,8],
                 [11,1,2,3,4,5,10,6,7,9,12,8],
                 [1,2,11,3,4,5,10,6,7,9,12,8],
                 [1,2,3,4,11,5,10,6,7,9,12,8],
                 [1,2,3,4,5,12,10,6,7,9,11,8],
                 [1,2,3,12,4,5,10,6,7,9,11,8],
                 [1,12,2,3,4,5,10,6,7,9,11,8],
                 [1,2,3,4,5,12,6,11,7,9,10,8],
                 [1,2,3,12,4,5,6,11,7,9,10,8],
                 [1,12,2,3,4,5,6,11,7,9,10,8],
                 [1,2,3,4,5,11,12,6,7,9,10,8],
                 [1,2,3,12,4,11,5,6,7,9,10,8],
                 [1,12,2,3,4,11,5,6,7,9,10,8],
                 [1,2,3,11,12,4,5,6,7,9,10,8],
                 [1,2,3,11,4,5,12,6,7,9,10,8],
                 [1,12,2,11,3,4,5,6,7,9,10,8],
                 [1,11,12,2,3,4,5,6,7,9,10,8],
                 [1,11,2,3,12,4,5,6,7,9,10,8],
                 [1,11,2,3,4,5,12,6,7,9,10,8],
                 [1,2,3,12,4,5,6,9,7,8,10,11],
                 [1,2,3,4,5,12,6,9,7,11,8,10],
                 [1,2,3,12,4,5,6,9,7,11,8,10],
                 [1,2,3,4,5,11,6,9,12,7,8,10],
                 [1,2,3,4,5,11,6,9,7,8,12,10],
                 [1,2,3,11,4,5,6,9,12,7,8,10],
                 [1,2,3,11,4,5,6,9,7,8,12,10],
                 [1,11,2,3,4,5,6,9,12,7,8,10],
                 [1,11,2,3,4,5,6,9,7,8,12,10],
                 [11,1,2,3,4,5,6,9,7,10,12,8],
                 [1,2,11,3,4,5,6,9,7,10,12,8],
                 [1,2,3,4,11,5,6,9,7,10,12,8],
                 [1,2,3,4,5,12,6,9,7,10,11,8],
                 [1,2,3,12,4,5,6,9,7,10,11,8],
                 [1,2,3,4,5,10,6,9,7,12,8,11],
                 [1,2,3,4,5,10,6,9,7,11,12,8],
                 [1,2,3,12,4,11,5,10,6,9,7,8],
                 [1,2,3,11,12,4,5,10,6,9,7,8],
                 [1,12,2,11,3,4,5,10,6,9,7,8],
                 [1,11,12,2,3,4,5,10,6,9,7,8],
                 [1,11,2,3,12,4,5,10,6,9,7,8],
                 [11,1,2,3,4,10,12,5,6,9,7,8],
                 [1,2,11,3,4,10,12,5,6,9,7,8],
                 [1,2,3,12,4,10,11,5,6,9,7,8],
                 [1,2,3,10,4,5,6,9,7,8,11,12],
                 [1,2,3,10,4,5,6,9,7,12,8,11],
                 [1,2,3,10,4,5,6,9,7,11,12,8],
                 [1,2,3,10,4,12,5,11,6,9,7,8],
                 [1,2,3,10,4,11,12,5,6,9,7,8],
                 [1,12,2,11,3,10,4,5,6,9,7,8],
                 [1,11,12,2,3,10,4,5,6,9,7,8],
                 [11,1,2,10,12,3,4,5,6,9,7,8],
                 [11,1,2,10,3,4,12,5,6,9,7,8],
                 [1,12,2,10,11,3,4,5,6,9,7,8],
                 [1,12,2,10,3,4,11,5,6,9,7,8],
                 [1,10,2,3,4,5,6,9,7,8,11,12],
                 [1,10,2,3,4,5,6,9,7,12,8,11],
                 [1,10,2,3,4,5,6,9,7,11,12,8],
                 [1,10,2,3,4,12,5,11,6,9,7,8],
                 [1,10,2,12,3,4,5,11,6,9,7,8],
                 [1,10,2,3,4,11,12,5,6,9,7,8],
                 [1,10,2,12,3,11,4,5,6,9,7,8],
                 [1,10,2,11,12,3,4,5,6,9,7,8],
                 [1,10,2,11,3,4,12,5,6,9,7,8],
                 [10,1,2,3,4,12,5,9,6,7,8,11],
                 [10,1,2,12,3,4,5,9,6,7,8,11],
                 [10,12,1,2,3,4,5,9,6,7,8,11],
                 [10,1,2,3,4,12,5,9,6,11,7,8],
                 [10,1,2,12,3,4,5,9,6,11,7,8],
                 [10,12,1,2,3,4,5,9,6,11,7,8],
                 [10,1,2,3,4,11,5,9,12,6,7,8],
                 [10,1,2,3,4,11,5,9,6,7,12,8],
                 [10,1,2,11,3,4,5,9,12,6,7,8],
                 [10,1,2,11,3,4,5,9,6,7,12,8],
                 [11,1,10,2,3,4,5,9,12,6,7,8],
                 [11,1,10,2,3,4,5,9,6,7,12,8],
                 [1,12,10,2,3,4,5,9,11,6,7,8],
                 [1,12,10,2,3,4,5,9,6,7,11,8],
                 [1,2,10,3,4,12,5,9,6,7,8,11],
                 [1,2,10,3,4,12,5,9,6,11,7,8],
                 [1,2,10,3,4,11,5,9,12,6,7,8],
                 [1,2,10,3,4,11,5,9,6,7,12,8],
                 [11,1,2,3,10,4,5,9,12,6,7,8],
                 [11,1,2,3,10,4,5,9,6,7,12,8],
                 [1,2,11,3,10,4,5,9,12,6,7,8],
                 [1,2,11,3,10,4,5,9,6,7,12,8],
                 [1,2,3,12,10,4,5,9,6,7,11,8],
                 [1,12,2,3,10,4,5,9,6,7,11,8],
                 [1,2,3,4,5,9,10,6,7,12,8,11],
                 [1,2,3,4,5,9,10,6,7,11,12,8],
                 [1,2,3,11,12,4,5,9,10,6,7,8],
                 [1,12,2,11,3,4,5,9,10,6,7,8],
                 [1,11,12,2,3,4,5,9,10,6,7,8],
                 [1,11,2,3,12,4,5,9,10,6,7,8],
                 [1,2,3,4,5,9,11,6,10,7,12,8],
                 [1,2,3,4,5,9,6,12,10,7,11,8],
                 [1,2,3,4,5,9,6,12,7,11,10,8],
                 [1,2,3,4,5,9,6,11,12,7,10,8],
                 [1,2,3,12,4,11,5,9,6,7,10,8],
                 [1,12,2,3,4,11,5,9,6,7,10,8],
                 [1,2,3,11,12,4,5,9,6,7,10,8],
                 [1,12,2,11,3,4,5,9,6,7,10,8],
                 [1,11,12,2,3,4,5,9,6,7,10,8],
                 [1,11,2,3,12,4,5,9,6,7,10,8],
                 [1,2,3,12,4,9,5,6,7,11,8,10],
                 [1,2,3,12,4,9,5,11,6,7,8,10],
                 [1,12,2,3,4,9,5,11,6,7,8,10],
                 [1,2,3,11,4,9,12,5,6,7,8,10],
                 [1,2,3,11,4,9,5,6,12,7,8,10],
                 [1,2,3,11,4,9,5,6,7,8,12,10],
                 [1,11,2,3,4,9,12,5,6,7,8,10],
                 [1,11,2,3,4,9,5,6,12,7,8,10],
                 [1,11,2,3,4,9,5,6,7,8,12,10],
                 [11,1,2,3,4,9,5,6,7,10,12,8],
                 [1,2,11,3,4,9,5,6,7,10,12,8],
                 [1,2,3,12,4,9,5,6,7,10,11,8],
                 [1,11,2,3,4,9,12,5,6,10,7,8],
                 [11,1,2,3,4,9,5,10,12,6,7,8],
                 [11,1,2,3,4,9,5,10,6,7,12,8],
                 [1,2,11,3,4,9,5,10,6,7,12,8],
                 [1,2,3,12,4,9,5,10,6,7,11,8],
                 [1,12,2,3,4,9,5,10,6,7,11,8],
                 [1,2,3,10,4,9,5,6,7,8,11,12],
                 [1,2,3,10,4,9,5,6,7,12,8,11],
                 [1,2,3,10,4,9,5,12,6,7,8,11],
                 [1,2,3,10,4,9,5,6,7,11,12,8],
                 [1,2,3,10,4,9,5,12,6,11,7,8],
                 [1,2,3,10,4,9,5,11,12,6,7,8],
                 [1,2,3,10,4,9,5,11,6,7,12,8],
                 [1,12,2,11,3,10,4,9,5,6,7,8],
                 [1,11,12,2,3,10,4,9,5,6,7,8],
                 [11,1,2,10,12,3,4,9,5,6,7,8],
                 [1,12,2,10,11,3,4,9,5,6,7,8],
                 [1,10,2,3,4,9,5,6,7,8,11,12],
                 [1,10,2,3,4,9,5,6,7,12,8,11],
                 [1,10,2,3,4,9,5,12,6,7,8,11],
                 [1,10,2,3,4,9,5,6,7,11,12,8],
                 [1,10,2,3,4,9,5,12,6,11,7,8],
                 [1,10,2,3,4,9,5,11,12,6,7,8],
                 [1,10,2,3,4,9,5,11,6,7,12,8],
                 [1,10,2,12,3,11,4,9,5,6,7,8],
                 [1,10,2,11,12,3,4,9,5,6,7,8],
                 [10,1,2,12,3,9,4,5,6,7,8,11],
                 [10,12,1,2,3,9,4,5,6,7,8,11],
                 [10,1,2,12,3,9,4,5,6,11,7,8],
                 [10,12,1,2,3,9,4,5,6,11,7,8],
                 [10,1,2,12,3,9,4,11,5,6,7,8],
                 [10,12,1,2,3,9,4,11,5,6,7,8],
                 [10,1,2,11,3,9,12,4,5,6,7,8],
                 [10,1,2,11,3,9,4,5,12,6,7,8],
                 [10,11,1,2,3,9,12,4,5,6,7,8],
                 [10,11,1,2,3,9,4,5,12,6,7,8],
                 [11,1,10,2,3,9,12,4,5,6,7,8],
                 [11,1,10,2,3,9,4,5,12,6,7,8],
                 [1,12,10,2,3,9,11,4,5,6,7,8],
                 [1,12,10,2,3,9,4,5,11,6,7,8],
                 [1,12,10,2,3,9,4,5,6,7,11,8],
                 [1,2,3,9,10,4,5,6,7,8,11,12],
                 [1,2,3,9,10,4,5,6,7,12,8,11],
                 [1,2,3,9,10,4,5,12,6,7,8,11],
                 [1,2,3,9,10,4,5,6,7,11,12,8],
                 [1,2,3,9,10,4,5,12,6,11,7,8],
                 [1,2,3,9,10,4,5,11,12,6,7,8],
                 [1,2,3,9,10,4,5,11,6,7,12,8],
                 [1,12,2,11,3,9,10,4,5,6,7,8],
                 [1,11,12,2,3,9,10,4,5,6,7,8],
                 [1,2,3,9,11,4,10,5,12,6,7,8],
                 [1,2,3,9,11,4,10,5,6,7,12,8],
                 [1,2,3,9,4,12,10,5,11,6,7,8],
                 [1,2,3,9,4,12,10,5,6,7,11,8],
                 [1,2,3,9,4,5,10,6,7,12,8,11],
                 [1,2,3,9,4,5,10,6,7,11,12,8],
                 [1,2,3,9,4,12,5,11,10,6,7,8],
                 [1,12,2,11,3,9,4,5,10,6,7,8],
                 [1,11,12,2,3,9,4,5,10,6,7,8],
                 [1,2,3,9,11,4,5,6,10,7,12,8],
                 [1,2,3,9,4,5,11,6,10,7,12,8],
                 [1,2,3,9,4,12,5,6,10,7,11,8],
                 [1,2,3,9,4,12,5,6,7,11,10,8],
                 [1,2,3,9,4,5,6,11,12,7,10,8],
                 [1,2,3,9,4,12,5,11,6,7,10,8],
                 [1,2,3,9,4,11,12,5,6,7,10,8],
                 [1,2,3,9,4,11,5,6,12,7,10,8],
                 [1,12,2,11,3,9,4,5,6,7,10,8],
                 [1,11,12,2,3,9,4,5,6,7,10,8],
                 [1,12,2,9,3,4,5,11,6,7,8,10],
                 [1,12,2,9,3,11,4,5,6,7,8,10],
                 [1,11,2,9,12,3,4,5,6,7,8,10],
                 [1,11,2,9,3,4,12,5,6,7,8,10],
                 [1,11,2,9,3,4,5,6,12,7,8,10],
                 [11,1,2,9,3,4,5,6,7,10,12,8],
                 [1,12,2,9,3,4,5,11,6,10,7,8],
                 [1,12,2,9,3,11,4,5,6,10,7,8],
                 [1,11,2,9,12,3,4,5,6,10,7,8],
                 [1,11,2,9,3,4,12,5,6,10,7,8],
                 [11,1,2,9,3,4,5,10,12,6,7,8],
                 [11,1,2,9,3,4,5,10,6,7,12,8],
                 [1,12,2,9,3,4,5,10,11,6,7,8],
                 [1,12,2,9,3,4,5,10,6,7,11,8],
                 [1,12,2,9,3,11,4,10,5,6,7,8],
                 [1,11,2,9,12,3,4,10,5,6,7,8],
                 [11,1,2,9,3,10,12,4,5,6,7,8],
                 [1,12,2,9,3,10,11,4,5,6,7,8],
                 [1,12,2,9,3,10,4,5,11,6,7,8],
                 [1,12,2,9,3,10,4,5,6,7,11,8],
                 [1,10,2,9,3,4,5,6,7,12,8,11],
                 [1,10,2,9,3,4,5,12,6,7,8,11],
                 [1,10,2,9,3,12,4,5,6,7,8,11],
                 [1,10,2,9,3,4,5,6,7,11,12,8],
                 [1,10,2,9,3,4,5,12,6,11,7,8],
                 [1,10,2,9,3,12,4,5,6,11,7,8],
                 [1,10,2,9,3,4,5,11,12,6,7,8],
                 [1,10,2,9,3,4,5,11,6,7,12,8],
                 [1,10,2,9,3,12,4,11,5,6,7,8],
                 [1,10,2,9,3,11,12,4,5,6,7,8],
                 [10,12,1,9,2,3,4,5,6,7,8,11],
                 [10,12,1,9,2,3,4,5,6,11,7,8],
                 [10,12,1,9,2,3,4,11,5,6,7,8],
                 [10,11,1,9,2,3,12,4,5,6,7,8],
                 [1,9,10,2,3,4,5,6,7,12,8,11],
                 [1,9,10,2,3,4,5,12,6,7,8,11],
                 [1,9,10,2,3,12,4,5,6,7,8,11],
                 [1,9,10,2,3,4,5,6,7,11,12,8],
                 [1,9,10,2,3,4,5,12,6,11,7,8],
                 [1,9,10,2,3,12,4,5,6,11,7,8],
                 [1,9,10,2,3,4,5,11,12,6,7,8],
                 [1,9,10,2,3,4,5,11,6,7,12,8],
                 [1,9,10,2,3,12,4,11,5,6,7,8],
                 [1,9,10,2,3,11,12,4,5,6,7,8],
                 [1,9,11,2,10,3,12,4,5,6,7,8],
                 [1,9,2,12,10,3,11,4,5,6,7,8],
                 [1,9,2,12,10,3,4,5,11,6,7,8],
                 [1,9,2,12,10,3,4,5,6,7,11,8],
                 [1,9,2,3,10,4,5,6,7,8,11,12],
                 [1,9,2,3,10,4,5,6,7,12,8,11],
                 [1,9,2,3,10,4,5,12,6,7,8,11],
                 [1,9,2,3,10,4,5,6,7,11,12,8],
                 [1,9,2,3,10,4,5,12,6,11,7,8],
                 [1,9,2,3,10,4,5,11,12,6,7,8],
                 [1,9,2,3,10,4,5,11,6,7,12,8],
                 [1,9,2,12,3,11,10,4,5,6,7,8],
                 [1,9,2,11,12,3,10,4,5,6,7,8],
                 [1,9,11,2,3,4,10,5,12,6,7,8],
                 [1,9,11,2,3,4,10,5,6,7,12,8],
                 [1,9,2,3,11,4,10,5,12,6,7,8],
                 [1,9,2,3,11,4,10,5,6,7,12,8],
                 [1,9,2,3,4,12,10,5,11,6,7,8],
                 [1,9,2,12,3,4,10,5,11,6,7,8],
                 [1,9,2,3,4,12,10,5,6,7,11,8],
                 [1,9,2,12,3,4,10,5,6,7,11,8],
                 [1,9,2,3,4,12,5,11,10,6,7,8],
                 [1,9,2,12,3,4,5,11,10,6,7,8],
                 [1,9,2,3,4,11,12,5,10,6,7,8],
                 [1,9,2,12,3,11,4,5,10,6,7,8],
                 [1,9,2,11,12,3,4,5,10,6,7,8],
                 [1,9,2,11,3,4,12,5,10,6,7,8],
                 [1,9,11,2,3,4,5,6,10,7,12,8],
                 [1,9,2,3,11,4,5,6,10,7,12,8],
                 [1,9,2,3,4,12,5,6,10,7,11,8],
                 [1,9,2,12,3,4,5,6,10,7,11,8],
                 [1,9,2,3,4,12,5,6,7,11,10,8],
                 [1,9,2,12,3,4,5,6,7,11,10,8],
                 [1,9,2,3,4,12,5,11,6,7,10,8],
                 [1,9,2,12,3,4,5,11,6,7,10,8],
                 [1,9,2,3,4,11,12,5,6,7,10,8],
                 [1,9,2,3,4,11,5,6,12,7,10,8],
                 [1,9,2,12,3,11,4,5,6,7,10,8],
                 [1,9,2,11,12,3,4,5,6,7,10,8],
                 [1,9,2,11,3,4,12,5,6,7,10,8],
                 [1,9,2,11,3,4,5,6,12,7,10,8],
                 [10,9,1,2,3,4,5,12,6,8,7,11],
                 [10,9,1,2,3,12,4,5,6,8,7,11],
                 [10,12,9,1,2,3,4,5,6,8,7,11],
                 [10,9,1,2,3,4,5,11,6,8,12,7],
                 [10,9,1,2,3,11,4,5,6,8,12,7],
                 [10,9,1,11,2,3,4,5,6,8,12,7],
                 [11,9,10,1,2,3,4,5,6,8,12,7],
                 [9,12,10,1,2,3,4,5,6,8,11,7],
                 [9,1,10,2,3,4,5,12,6,8,7,11],
                 [9,1,10,2,3,12,4,5,6,8,7,11],
                 [9,1,10,2,3,4,5,11,6,8,12,7],
                 [9,1,10,2,3,11,4,5,6,8,12,7],
                 [11,9,1,2,10,3,4,5,6,8,12,7],
                 [9,1,11,2,10,3,4,5,6,8,12,7],
                 [9,1,2,12,10,3,4,5,6,8,11,7],
                 [9,12,1,2,10,3,4,5,6,8,11,7],
                 [9,1,2,3,10,4,5,12,6,8,7,11],
                 [9,1,2,3,10,4,5,11,6,8,12,7],
                 [11,9,1,2,3,4,10,5,6,8,12,7],
                 [9,1,11,2,3,4,10,5,6,8,12,7],
                 [9,1,2,3,11,4,10,5,6,8,12,7],
                 [9,1,2,3,4,12,10,5,6,8,11,7],
                 [9,1,2,12,3,4,10,5,6,8,11,7],
                 [9,12,1,2,3,4,10,5,6,8,11,7],
                 [9,1,2,3,4,12,5,11,6,8,10,7],
                 [9,1,2,12,3,4,5,11,6,8,10,7],
                 [9,12,1,2,3,4,5,11,6,8,10,7],
                 [9,1,2,3,4,11,12,5,6,8,10,7],
                 [9,1,2,12,3,11,4,5,6,8,10,7],
                 [9,12,1,2,3,11,4,5,6,8,10,7],
                 [9,1,2,11,12,3,4,5,6,8,10,7],
                 [9,1,2,11,3,4,12,5,6,8,10,7],
                 [9,12,1,11,2,3,4,5,6,8,10,7],
                 [9,11,1,2,12,3,4,5,6,8,10,7],
                 [9,11,1,2,3,4,12,5,6,8,10,7],
                 [1,12,9,2,3,4,5,11,6,8,7,10],
                 [1,12,9,2,3,11,4,5,6,8,7,10],
                 [1,11,9,2,12,3,4,5,6,8,7,10],
                 [1,11,9,2,3,4,12,5,6,8,7,10],
                 [11,1,9,2,3,4,5,10,6,8,12,7],
                 [1,12,9,2,3,4,5,10,6,8,11,7],
                 [11,1,9,2,3,10,4,5,6,8,12,7],
                 [1,12,9,2,3,10,4,5,6,8,11,7],
                 [1,10,9,2,3,4,5,12,6,8,7,11],
                 [1,10,9,2,3,12,4,5,6,8,7,11],
                 [1,10,9,2,3,4,5,11,6,8,12,7],
                 [1,10,9,2,3,11,4,5,6,8,12,7],
                 [10,1,2,12,9,3,4,5,6,8,7,11],
                 [10,12,1,2,9,3,4,5,6,8,7,11],
                 [10,1,2,11,9,3,4,5,6,8,12,7],
                 [11,1,10,2,9,3,4,5,6,8,12,7],
                 [1,12,10,2,9,3,4,5,6,8,11,7],
                 [1,2,9,3,10,4,5,12,6,8,7,11],
                 [1,2,9,3,10,4,5,11,6,8,12,7],
                 [1,2,9,3,11,4,10,5,6,8,12,7],
                 [1,2,9,3,4,12,10,5,6,8,11,7],
                 [1,2,9,3,4,12,5,11,6,8,10,7],
                 [1,2,9,3,4,11,12,5,6,8,10,7],
                 [1,12,2,11,9,3,4,5,6,8,10,7],
                 [1,11,12,2,9,3,4,5,6,8,10,7],
                 [1,2,3,12,9,4,5,11,6,8,7,10],
                 [1,12,2,3,9,4,5,11,6,8,7,10],
                 [1,2,3,11,9,4,12,5,6,8,7,10],
                 [1,11,2,3,9,4,12,5,6,8,7,10],
                 [11,1,2,3,9,4,5,10,6,8,12,7],
                 [1,2,11,3,9,4,5,10,6,8,12,7],
                 [1,2,3,12,9,4,5,10,6,8,11,7],
                 [1,12,2,3,9,4,5,10,6,8,11,7],
                 [1,2,3,10,9,4,5,12,6,8,7,11],
                 [1,2,3,10,9,4,5,11,6,8,12,7],
                 [1,10,2,3,9,4,5,12,6,8,7,11],
                 [1,10,2,3,9,4,5,11,6,8,12,7],
                 [10,1,2,3,4,12,9,5,6,8,7,11],
                 [10,1,2,12,3,4,9,5,6,8,7,11],
                 [10,12,1,2,3,4,9,5,6,8,7,11],
                 [10,1,2,3,4,11,9,5,6,8,12,7],
                 [10,1,2,11,3,4,9,5,6,8,12,7],
                 [11,1,10,2,3,4,9,5,6,8,12,7],
                 [1,12,10,2,3,4,9,5,6,8,11,7],
                 [1,2,10,3,4,12,9,5,6,8,7,11],
                 [1,2,10,3,4,11,9,5,6,8,12,7],
                 [11,1,2,3,10,4,9,5,6,8,12,7],
                 [1,2,11,3,10,4,9,5,6,8,12,7],
                 [1,2,3,12,10,4,9,5,6,8,11,7],
                 [1,12,2,3,10,4,9,5,6,8,11,7],
                 [1,2,3,12,4,11,9,5,6,8,10,7],
                 [1,12,2,3,4,11,9,5,6,8,10,7],
                 [1,2,3,11,12,4,9,5,6,8,10,7],
                 [1,12,2,11,3,4,9,5,6,8,10,7],
                 [1,11,12,2,3,4,9,5,6,8,10,7],
                 [1,11,2,3,12,4,9,5,6,8,10,7],
                 [1,2,3,4,5,12,6,8,9,7,10,11],
                 [1,2,3,12,4,5,6,8,9,7,10,11],
                 [1,2,3,4,5,11,6,8,9,7,12,10],
                 [1,2,3,11,4,5,6,8,9,7,12,10],
                 [1,11,2,3,4,5,6,8,9,7,12,10],
                 [1,2,3,4,5,10,6,8,9,7,11,12],
                 [1,2,3,12,4,11,5,10,6,8,9,7],
                 [1,12,2,3,4,11,5,10,6,8,9,7],
                 [1,2,3,11,12,4,5,10,6,8,9,7],
                 [1,12,2,11,3,4,5,10,6,8,9,7],
                 [1,11,12,2,3,4,5,10,6,8,9,7],
                 [1,11,2,3,12,4,5,10,6,8,9,7],
                 [11,1,2,3,4,10,12,5,6,8,9,7],
                 [1,2,11,3,4,10,12,5,6,8,9,7],
                 [1,2,3,12,4,10,11,5,6,8,9,7],
                 [1,12,2,3,4,10,11,5,6,8,9,7],
                 [1,2,3,10,4,5,6,8,9,7,11,12],
                 [1,2,3,10,4,12,5,11,6,8,9,7],
                 [1,2,3,10,4,11,12,5,6,8,9,7],
                 [1,12,2,11,3,10,4,5,6,8,9,7],
                 [1,11,12,2,3,10,4,5,6,8,9,7],
                 [11,1,2,10,12,3,4,5,6,8,9,7],
                 [11,1,2,10,3,4,12,5,6,8,9,7],
                 [1,12,2,10,11,3,4,5,6,8,9,7],
                 [1,12,2,10,3,4,11,5,6,8,9,7],
                 [1,10,2,3,4,5,6,8,9,7,11,12],
                 [1,10,2,3,4,12,5,11,6,8,9,7],
                 [1,10,2,12,3,4,5,11,6,8,9,7],
                 [1,10,2,3,4,11,12,5,6,8,9,7],
                 [1,10,2,12,3,11,4,5,6,8,9,7],
                 [1,10,2,11,12,3,4,5,6,8,9,7],
                 [1,10,2,11,3,4,12,5,6,8,9,7],
                 [1,2,3,4,5,8,6,7,9,11,12,10],
                 [1,2,3,4,5,8,6,11,7,9,12,10],
                 [1,12,2,11,3,4,5,8,6,7,9,10],
                 [1,11,12,2,3,4,5,8,6,7,9,10],
                 [1,11,2,3,12,4,5,8,6,7,9,10],
                 [1,2,3,12,4,11,5,8,6,10,7,9],
                 [1,12,2,3,4,11,5,8,6,10,7,9],
                 [1,2,3,11,12,4,5,8,6,10,7,9],
                 [1,12,2,11,3,4,5,8,6,10,7,9],
                 [1,11,12,2,3,4,5,8,6,10,7,9],
                 [1,11,2,3,12,4,5,8,6,10,7,9],
                 [11,1,2,3,4,10,5,8,12,6,7,9],
                 [11,1,2,3,4,10,5,8,6,7,12,9],
                 [1,2,11,3,4,10,5,8,12,6,7,9],
                 [1,2,11,3,4,10,5,8,6,7,12,9],
                 [1,2,3,12,4,10,5,8,11,6,7,9],
                 [1,12,2,3,4,10,5,8,11,6,7,9],
                 [1,2,3,12,4,10,5,8,6,7,11,9],
                 [1,12,2,3,4,10,5,8,6,7,11,9],
                 [1,2,3,10,4,12,5,8,6,7,9,11],
                 [1,2,3,10,4,12,5,8,6,11,7,9],
                 [1,2,3,10,4,11,5,8,12,6,7,9],
                 [1,2,3,10,4,11,5,8,6,7,12,9],
                 [11,1,2,10,3,4,5,8,12,6,7,9],
                 [11,1,2,10,3,4,5,8,6,7,12,9],
                 [1,12,2,10,3,4,5,8,11,6,7,9],
                 [1,12,2,10,3,4,5,8,6,7,11,9],
                 [1,10,2,3,4,12,5,8,6,7,9,11],
                 [1,10,2,12,3,4,5,8,6,7,9,11],
                 [1,10,2,3,4,12,5,8,6,11,7,9],
                 [1,10,2,12,3,4,5,8,6,11,7,9],
                 [1,10,2,3,4,11,5,8,12,6,7,9],
                 [1,10,2,3,4,11,5,8,6,7,12,9],
                 [1,10,2,11,3,4,5,8,12,6,7,9],
                 [1,10,2,11,3,4,5,8,6,7,12,9],
                 [10,1,2,3,4,12,5,8,6,9,7,11],
                 [10,1,2,12,3,4,5,8,6,9,7,11],
                 [10,12,1,2,3,4,5,8,6,9,7,11],
                 [10,1,2,3,4,11,5,8,6,9,12,7],
                 [10,1,2,11,3,4,5,8,6,9,12,7],
                 [11,1,10,2,3,4,5,8,6,9,12,7],
                 [1,12,10,2,3,4,5,8,6,9,11,7],
                 [1,2,10,3,4,12,5,8,6,9,7,11],
                 [1,2,10,3,4,11,5,8,6,9,12,7],
                 [11,1,2,3,10,4,5,8,6,9,12,7],
                 [1,2,11,3,10,4,5,8,6,9,12,7],
                 [1,2,3,12,10,4,5,8,6,9,11,7],
                 [1,12,2,3,10,4,5,8,6,9,11,7],
                 [1,2,3,12,4,11,5,8,6,9,10,7],
                 [1,12,2,3,4,11,5,8,6,9,10,7],
                 [1,2,3,11,12,4,5,8,6,9,10,7],
                 [1,12,2,11,3,4,5,8,6,9,10,7],
                 [1,11,12,2,3,4,5,8,6,9,10,7],
                 [1,11,2,3,12,4,5,8,6,9,10,7],
                 [1,2,3,12,4,9,5,8,6,11,7,10],
                 [1,2,3,11,4,9,5,8,12,6,7,10],
                 [1,2,3,11,4,9,5,8,6,7,12,10],
                 [1,11,2,3,4,9,5,8,12,6,7,10],
                 [1,11,2,3,4,9,5,8,6,7,12,10],
                 [11,1,2,3,4,9,5,8,6,10,12,7],
                 [1,2,11,3,4,9,5,8,6,10,12,7],
                 [1,2,3,12,4,9,5,8,6,10,11,7],
                 [1,2,3,10,4,9,5,8,6,12,7,11],
                 [1,2,3,10,4,9,5,8,6,11,12,7],
                 [1,12,2,11,3,10,4,9,5,8,6,7],
                 [1,11,12,2,3,10,4,9,5,8,6,7],
                 [11,1,2,10,12,3,4,9,5,8,6,7],
                 [1,12,2,10,11,3,4,9,5,8,6,7],
                 [1,10,2,3,4,9,5,8,6,7,11,12],
                 [1,10,2,3,4,9,5,8,6,12,7,11],
                 [1,10,2,3,4,9,5,8,6,11,12,7],
                 [1,10,2,12,3,11,4,9,5,8,6,7],
                 [1,10,2,11,12,3,4,9,5,8,6,7],
                 [10,1,2,12,3,9,4,11,5,8,6,7],
                 [10,12,1,2,3,9,4,11,5,8,6,7],
                 [10,1,2,11,3,9,12,4,5,8,6,7],
                 [11,1,10,2,3,9,12,4,5,8,6,7],
                 [1,12,10,2,3,9,11,4,5,8,6,7],
                 [1,2,3,9,10,4,5,8,6,12,7,11],
                 [1,2,3,9,10,4,5,8,6,11,12,7],
                 [1,12,2,11,3,9,10,4,5,8,6,7],
                 [1,11,12,2,3,9,10,4,5,8,6,7],
                 [1,2,3,9,11,4,5,8,10,6,12,7],
                 [1,2,3,9,4,12,5,8,10,6,11,7],
                 [1,2,3,9,4,12,5,8,6,11,10,7],
                 [1,2,3,9,4,11,5,8,12,6,10,7],
                 [1,11,2,9,3,4,5,8,12,6,7,10],
                 [1,11,2,9,3,4,5,8,6,7,12,10],
                 [11,1,2,9,3,4,5,8,6,10,12,7],
                 [1,12,2,9,3,11,4,10,5,8,6,7],
                 [1,11,2,9,12,3,4,10,5,8,6,7],
                 [11,1,2,9,3,10,12,4,5,8,6,7],
                 [1,12,2,9,3,10,11,4,5,8,6,7],
                 [1,10,2,9,3,4,5,8,6,7,11,12],
                 [1,10,2,9,3,4,5,8,6,12,7,11],
                 [1,10,2,9,3,4,5,8,6,11,12,7],
                 [1,10,2,9,3,12,4,11,5,8,6,7],
                 [1,10,2,9,3,11,12,4,5,8,6,7],
                 [10,12,1,9,2,3,4,11,5,8,6,7],
                 [10,12,1,9,2,11,3,4,5,8,6,7],
                 [10,11,1,9,12,2,3,4,5,8,6,7],
                 [10,11,1,9,2,3,12,4,5,8,6,7],
                 [1,9,10,2,3,4,5,8,6,7,11,12],
                 [1,9,10,2,3,4,5,8,6,12,7,11],
                 [1,9,10,2,3,4,5,8,6,11,12,7],
                 [1,9,10,2,3,12,4,11,5,8,6,7],
                 [1,9,10,2,3,11,12,4,5,8,6,7],
                 [1,9,11,2,10,3,12,4,5,8,6,7],
                 [1,9,2,12,10,3,11,4,5,8,6,7],
                 [1,9,2,3,10,4,5,8,6,7,11,12],
                 [1,9,2,3,10,4,5,8,6,12,7,11],
                 [1,9,2,3,10,4,5,8,6,11,12,7],
                 [1,9,2,12,3,11,10,4,5,8,6,7],
                 [1,9,2,11,12,3,10,4,5,8,6,7],
                 [1,9,11,2,3,4,5,8,10,6,12,7],
                 [1,9,2,3,11,4,5,8,10,6,12,7],
                 [1,9,2,3,4,12,5,8,10,6,11,7],
                 [1,9,2,12,3,4,5,8,10,6,11,7],
                 [1,9,2,3,4,12,5,8,6,11,10,7],
                 [1,9,2,12,3,4,5,8,6,11,10,7],
                 [1,9,2,3,4,11,5,8,12,6,10,7],
                 [1,9,2,11,3,4,5,8,12,6,10,7],
                 [10,9,1,2,3,12,4,8,5,6,7,11],
                 [10,12,9,1,2,3,4,8,5,6,7,11],
                 [10,12,9,1,2,3,4,8,5,11,6,7],
                 [10,9,1,2,3,11,4,8,5,6,12,7],
                 [10,9,1,11,2,3,4,8,12,5,6,7],
                 [10,9,1,11,2,3,4,8,5,6,12,7],
                 [10,11,9,1,2,3,4,8,12,5,6,7],
                 [11,9,10,1,2,3,4,8,12,5,6,7],
                 [11,9,10,1,2,3,4,8,5,6,12,7],
                 [9,12,10,1,2,3,4,8,11,5,6,7],
                 [9,12,10,1,2,3,4,8,5,6,11,7],
                 [9,1,10,2,3,12,4,8,5,6,7,11],
                 [9,1,10,2,3,12,4,8,5,11,6,7],
                 [9,1,10,2,3,11,4,8,12,5,6,7],
                 [9,1,10,2,3,11,4,8,5,6,12,7],
                 [11,9,1,2,10,3,4,8,12,5,6,7],
                 [11,9,1,2,10,3,4,8,5,6,12,7],
                 [9,1,11,2,10,3,4,8,12,5,6,7],
                 [9,1,11,2,10,3,4,8,5,6,12,7],
                 [9,1,2,12,10,3,4,8,11,5,6,7],
                 [9,12,1,2,10,3,4,8,11,5,6,7],
                 [9,1,2,12,10,3,4,8,5,6,11,7],
                 [9,12,1,2,10,3,4,8,5,6,11,7],
                 [9,1,2,3,4,8,10,5,6,7,11,12],
                 [9,1,2,3,4,8,10,5,6,12,7,11],
                 [9,1,2,3,4,8,10,5,6,11,12,7],
                 [9,1,2,12,3,11,4,8,10,5,6,7],
                 [9,12,1,2,3,11,4,8,10,5,6,7],
                 [9,1,2,11,12,3,4,8,10,5,6,7],
                 [9,12,1,11,2,3,4,8,10,5,6,7],
                 [9,11,12,1,2,3,4,8,10,5,6,7],
                 [9,11,1,2,12,3,4,8,10,5,6,7],
                 [9,1,2,3,4,8,11,5,10,6,12,7],
                 [9,1,2,3,4,8,5,12,10,6,11,7],
                 [9,1,2,3,4,8,5,12,6,11,10,7],
                 [9,1,2,3,4,8,5,11,12,6,10,7],
                 [9,1,2,12,3,11,4,8,5,6,10,7],
                 [9,12,1,2,3,11,4,8,5,6,10,7],
                 [9,1,2,11,12,3,4,8,5,6,10,7],
                 [9,12,1,11,2,3,4,8,5,6,10,7],
                 [9,11,1,2,12,3,4,8,5,6,10,7],
                 [1,12,9,2,3,11,4,8,5,6,7,10],
                 [1,11,9,2,12,3,4,8,5,6,7,10],
                 [1,12,9,2,3,11,4,8,5,10,6,7],
                 [1,11,9,2,12,3,4,8,5,10,6,7],
                 [11,1,9,2,3,10,4,8,12,5,6,7],
                 [11,1,9,2,3,10,4,8,5,6,12,7],
                 [1,12,9,2,3,10,4,8,11,5,6,7],
                 [1,12,9,2,3,10,4,8,5,6,11,7],
                 [1,10,9,2,3,12,4,8,5,6,7,11],
                 [1,10,9,2,3,12,4,8,5,11,6,7],
                 [1,10,9,2,3,11,4,8,12,5,6,7],
                 [1,10,9,2,3,11,4,8,5,6,12,7],
                 [10,1,2,12,9,3,4,8,5,6,7,11],
                 [10,12,1,2,9,3,4,8,5,6,7,11],
                 [10,1,2,12,9,3,4,8,5,11,6,7],
                 [10,12,1,2,9,3,4,8,5,11,6,7],
                 [10,1,2,11,9,3,4,8,12,5,6,7],
                 [10,1,2,11,9,3,4,8,5,6,12,7],
                 [11,1,10,2,9,3,4,8,12,5,6,7],
                 [11,1,10,2,9,3,4,8,5,6,12,7],
                 [1,12,10,2,9,3,4,8,11,5,6,7],
                 [1,12,10,2,9,3,4,8,5,6,11,7],
                 [1,2,9,3,4,8,10,5,6,12,7,11],
                 [1,2,9,3,4,8,10,5,6,11,12,7],
                 [1,11,12,2,9,3,4,8,10,5,6,7],
                 [1,2,9,3,4,8,11,5,10,6,12,7],
                 [1,2,9,3,4,8,5,12,10,6,11,7],
                 [1,2,9,3,4,8,5,12,6,11,10,7],
                 [1,2,9,3,4,8,5,11,12,6,10,7],
                 [1,12,2,11,9,3,4,8,5,6,10,7],
                 [1,11,12,2,9,3,4,8,5,6,10,7],
                 [1,2,3,12,4,8,9,5,6,11,7,10],
                 [1,2,3,11,4,8,9,5,12,6,7,10],
                 [1,2,3,11,4,8,9,5,6,7,12,10],
                 [1,11,2,3,4,8,9,5,12,6,7,10],
                 [1,11,2,3,4,8,9,5,6,7,12,10],
                 [11,1,2,3,4,8,9,5,6,10,12,7],
                 [1,2,11,3,4,8,9,5,6,10,12,7],
                 [1,2,3,12,4,8,9,5,6,10,11,7],
                 [1,2,3,10,4,8,9,5,6,12,7,11],
                 [1,2,3,10,4,8,9,5,6,11,12,7],
                 [1,11,12,2,3,10,4,8,9,5,6,7],
                 [11,1,2,10,12,3,4,8,9,5,6,7],
                 [1,12,2,10,11,3,4,8,9,5,6,7],
                 [1,10,2,3,4,8,9,5,6,7,11,12],
                 [1,10,2,3,4,8,9,5,6,12,7,11],
                 [1,10,2,3,4,8,9,5,6,11,12,7],
                 [1,10,2,12,3,11,4,8,9,5,6,7],
                 [1,10,2,11,12,3,4,8,9,5,6,7],
                 [10,1,2,3,4,8,5,12,9,6,7,11],
                 [10,1,2,3,4,8,5,11,9,6,12,7],
                 [1,2,10,3,4,8,5,12,9,6,7,11],
                 [1,2,10,3,4,8,5,11,9,6,12,7],
                 [11,1,2,3,4,8,10,5,9,6,12,7],
                 [1,2,11,3,4,8,10,5,9,6,12,7],
                 [1,2,3,12,4,8,10,5,9,6,11,7],
                 [1,12,2,3,4,8,10,5,9,6,11,7],
                 [1,2,3,12,4,8,5,11,9,6,10,7],
                 [1,12,2,3,4,8,5,11,9,6,10,7],
                 [1,2,3,11,4,8,12,5,9,6,10,7],
                 [1,11,2,3,4,8,12,5,9,6,10,7],
                 [1,2,3,12,4,8,5,6,9,7,10,11],
                 [1,2,3,11,4,8,5,6,9,7,12,10],
                 [1,11,2,3,4,8,5,6,9,7,12,10],
                 [1,2,3,12,4,8,5,11,6,10,9,7],
                 [1,12,2,3,4,8,5,11,6,10,9,7],
                 [1,2,3,11,4,8,12,5,6,10,9,7],
                 [1,11,2,3,4,8,12,5,6,10,9,7],
                 [11,1,2,3,4,8,5,10,12,6,9,7],
                 [1,2,11,3,4,8,5,10,12,6,9,7],
                 [1,2,3,12,4,8,5,10,11,6,9,7],
                 [1,12,2,3,4,8,5,10,11,6,9,7],
                 [1,2,3,10,4,8,5,6,9,7,11,12],
                 [1,2,3,10,4,8,5,12,6,11,9,7],
                 [1,2,3,10,4,8,5,11,12,6,9,7],
                 [1,12,2,11,3,10,4,8,5,6,9,7],
                 [1,11,12,2,3,10,4,8,5,6,9,7],
                 [11,1,2,10,12,3,4,8,5,6,9,7],
                 [1,12,2,10,11,3,4,8,5,6,9,7],
                 [1,10,2,3,4,8,5,6,9,7,11,12],
                 [1,10,2,3,4,8,5,12,6,11,9,7],
                 [1,10,2,3,4,8,5,11,12,6,9,7],
                 [1,10,2,12,3,11,4,8,5,6,9,7],
                 [1,10,2,11,12,3,4,8,5,6,9,7],
                 [1,2,3,8,4,12,5,6,7,9,10,11],
                 [1,2,3,8,4,5,6,11,7,9,12,10],
                 [1,2,3,8,4,11,5,6,12,7,9,10],
                 [1,2,3,8,4,11,5,6,7,9,12,10],
                 [1,2,3,8,11,4,5,6,7,10,12,9],
                 [1,2,3,8,4,12,5,6,7,10,11,9],
                 [1,2,3,8,4,12,5,11,6,10,7,9],
                 [1,2,3,8,4,11,12,5,6,10,7,9],
                 [1,12,2,11,3,8,4,5,6,10,7,9],
                 [1,11,12,2,3,8,4,5,6,10,7,9],
                 [1,2,3,8,11,4,5,10,12,6,7,9],
                 [1,2,3,8,11,4,5,10,6,7,12,9],
                 [1,2,3,8,4,12,5,10,11,6,7,9],
                 [1,2,3,8,4,12,5,10,6,7,11,9],
                 [1,2,3,8,4,10,5,6,7,9,11,12],
                 [1,2,3,8,4,10,5,6,7,12,9,11],
                 [1,2,3,8,4,10,5,12,6,7,9,11],
                 [1,2,3,8,4,10,5,6,7,11,12,9],
                 [1,2,3,8,4,10,5,12,6,11,7,9],
                 [1,2,3,8,4,10,5,11,12,6,7,9],
                 [1,2,3,8,4,10,5,11,6,7,12,9],
                 [1,12,2,11,3,8,4,10,5,6,7,9],
                 [1,11,12,2,3,8,4,10,5,6,7,9],
                 [11,1,2,10,3,8,12,4,5,6,7,9],
                 [11,1,2,10,3,8,4,5,12,6,7,9],
                 [1,12,2,10,3,8,11,4,5,6,7,9],
                 [1,12,2,10,3,8,4,5,11,6,7,9],
                 [1,10,2,12,3,8,4,5,6,11,7,9],
                 [1,10,2,12,3,8,4,11,5,6,7,9],
                 [1,10,2,11,3,8,12,4,5,6,7,9],
                 [1,10,2,11,3,8,4,5,12,6,7,9],
                 [10,1,2,12,3,8,4,5,6,9,7,11],
                 [10,12,1,2,3,8,4,5,6,9,7,11],
                 [10,1,2,11,3,8,4,5,6,9,12,7],
                 [11,1,10,2,3,8,4,5,6,9,12,7],
                 [1,12,10,2,3,8,4,5,6,9,11,7],
                 [1,2,3,8,10,4,5,12,6,9,7,11],
                 [1,2,3,8,10,4,5,11,6,9,12,7],
                 [1,2,3,8,11,4,10,5,6,9,12,7],
                 [1,2,3,8,4,12,10,5,6,9,11,7],
                 [1,2,3,8,4,12,5,11,6,9,10,7],
                 [1,2,3,8,4,11,12,5,6,9,10,7],
                 [1,12,2,11,3,8,4,5,6,9,10,7],
                 [1,11,12,2,3,8,4,5,6,9,10,7],
                 [1,2,3,8,4,12,5,9,6,11,7,10],
                 [1,2,3,8,4,11,5,9,12,6,7,10],
                 [1,2,3,8,4,11,5,9,6,7,12,10],
                 [1,2,3,8,11,4,5,9,6,10,12,7],
                 [1,2,3,8,4,12,5,9,6,10,11,7],
                 [1,2,3,8,4,10,5,9,6,12,7,11],
                 [1,2,3,8,4,10,5,9,6,11,12,7],
                 [1,11,12,2,3,8,4,10,5,9,6,7],
                 [11,1,2,10,3,8,12,4,5,9,6,7],
                 [1,10,2,12,3,8,4,11,5,9,6,7],
                 [1,10,2,11,3,8,12,4,5,9,6,7],
                 [10,1,2,12,3,8,4,9,5,6,7,11],
                 [10,12,1,2,3,8,4,9,5,6,7,11],
                 [10,1,2,12,3,8,4,9,5,11,6,7],
                 [10,12,1,2,3,8,4,9,5,11,6,7],
                 [10,1,2,11,3,8,4,9,12,5,6,7],
                 [10,1,2,11,3,8,4,9,5,6,12,7],
                 [11,1,10,2,3,8,4,9,12,5,6,7],
                 [11,1,10,2,3,8,4,9,5,6,12,7],
                 [1,12,10,2,3,8,4,9,5,6,11,7],
                 [1,2,3,8,4,9,10,5,6,12,7,11],
                 [1,2,3,8,4,9,10,5,6,11,12,7],
                 [1,11,12,2,3,8,4,9,10,5,6,7],
                 [1,2,3,8,4,9,11,5,10,6,12,7],
                 [1,2,3,8,4,9,5,12,10,6,11,7],
                 [1,2,3,8,4,9,5,12,6,11,10,7],
                 [1,2,3,8,4,9,5,11,12,6,10,7],
                 [1,12,2,11,3,8,4,9,5,6,10,7],
                 [1,11,12,2,3,8,4,9,5,6,10,7],
                 [1,12,2,9,3,8,4,11,5,6,7,10],
                 [1,11,2,9,3,8,12,4,5,6,7,10],
                 [1,11,2,9,3,8,4,5,12,6,7,10],
                 [11,1,2,9,3,8,4,5,6,10,12,7],
                 [1,12,2,9,3,8,4,11,5,10,6,7],
                 [1,11,2,9,3,8,12,4,5,10,6,7],
                 [11,1,2,9,3,8,4,10,12,5,6,7],
                 [11,1,2,9,3,8,4,10,5,6,12,7],
                 [1,12,2,9,3,8,4,10,11,5,6,7],
                 [1,12,2,9,3,8,4,10,5,6,11,7],
                 [1,10,2,9,3,8,4,12,5,11,6,7],
                 [1,10,2,9,3,8,4,11,12,5,6,7],
                 [1,10,2,9,3,8,4,11,5,6,12,7],
                 [1,9,10,2,3,8,4,12,5,11,6,7],
                 [1,9,10,2,3,8,4,11,12,5,6,7],
                 [1,9,10,2,3,8,4,11,5,6,12,7],
                 [1,9,11,2,3,8,10,4,12,5,6,7],
                 [1,9,11,2,3,8,10,4,5,6,12,7],
                 [1,9,2,12,3,8,10,4,11,5,6,7],
                 [1,9,2,12,3,8,10,4,5,6,11,7],
                 [1,9,2,12,3,8,4,11,10,5,6,7],
                 [1,9,2,11,3,8,12,4,10,5,6,7],
                 [1,9,11,2,3,8,4,5,10,6,12,7],
                 [1,9,2,12,3,8,4,5,10,6,11,7],
                 [1,9,2,12,3,8,4,5,6,11,10,7],
                 [1,9,2,12,3,8,4,11,5,6,10,7],
                 [1,9,2,11,3,8,12,4,5,6,10,7],
                 [1,9,2,11,3,8,4,5,12,6,10,7],
                 [10,9,1,12,2,8,3,4,5,11,6,7],
                 [10,12,9,1,2,8,3,4,5,11,6,7],
                 [9,12,10,1,2,8,3,4,11,5,6,7],
                 [9,1,2,8,10,3,4,12,5,11,6,7],
                 [9,1,2,8,10,3,4,11,12,5,6,7],
                 [9,1,2,8,10,3,4,11,5,6,12,7],
                 [9,1,2,8,11,3,10,4,12,5,6,7],
                 [9,1,2,8,11,3,10,4,5,6,12,7],
                 [9,1,2,8,3,12,10,4,11,5,6,7],
                 [9,1,2,8,3,12,10,4,5,6,11,7],
                 [9,1,2,8,3,4,10,5,6,7,11,12],
                 [9,1,2,8,3,4,10,5,6,12,7,11],
                 [9,1,2,8,3,4,10,5,6,11,12,7],
                 [9,1,2,8,3,12,4,11,10,5,6,7],
                 [9,1,2,8,3,11,12,4,10,5,6,7],
                 [9,12,1,11,2,8,3,4,10,5,6,7],
                 [9,11,12,1,2,8,3,4,10,5,6,7],
                 [9,1,2,8,11,3,4,5,10,6,12,7],
                 [9,1,2,8,3,12,4,5,10,6,11,7],
                 [9,1,2,8,3,12,4,5,6,11,10,7],
                 [9,1,2,8,3,4,5,11,12,6,10,7],
                 [9,1,2,8,3,12,4,11,5,6,10,7],
                 [9,1,2,8,3,11,12,4,5,6,10,7],
                 [9,1,2,8,3,11,4,5,12,6,10,7],
                 [9,12,1,11,2,8,3,4,5,6,10,7],
                 [1,12,2,8,9,3,4,11,5,6,7,10],
                 [1,11,2,8,9,3,12,4,5,6,7,10],
                 [1,11,2,8,9,3,4,5,12,6,7,10],
                 [11,1,2,8,9,3,4,5,6,10,12,7],
                 [1,12,2,8,9,3,4,11,5,10,6,7],
                 [1,11,2,8,9,3,12,4,5,10,6,7],
                 [11,1,2,8,9,3,4,10,12,5,6,7],
                 [11,1,2,8,9,3,4,10,5,6,12,7],
                 [1,12,2,8,9,3,4,10,11,5,6,7],
                 [1,12,2,8,9,3,4,10,5,6,11,7],
                 [1,10,2,8,9,3,4,11,12,5,6,7],
                 [1,10,2,8,9,3,4,11,5,6,12,7],
                 [10,1,2,8,3,12,9,4,5,6,7,11],
                 [10,1,2,8,3,12,9,4,5,11,6,7],
                 [10,1,2,8,3,11,9,4,12,5,6,7],
                 [10,1,2,8,3,11,9,4,5,6,12,7],
                 [11,1,2,8,10,3,9,4,12,5,6,7],
                 [11,1,2,8,10,3,9,4,5,6,12,7],
                 [1,12,2,8,10,3,9,4,11,5,6,7],
                 [1,12,2,8,10,3,9,4,5,6,11,7],
                 [1,12,2,8,3,11,9,4,10,5,6,7],
                 [1,11,2,8,12,3,9,4,10,5,6,7],
                 [1,12,2,8,3,11,9,4,5,6,10,7],
                 [1,11,2,8,12,3,9,4,5,6,10,7],
                 [1,11,2,8,3,4,9,5,12,6,7,10],
                 [1,11,2,8,3,4,9,5,6,7,12,10],
                 [11,1,2,8,3,4,9,5,6,10,12,7],
                 [1,12,2,8,3,11,4,10,9,5,6,7],
                 [1,11,2,8,12,3,4,10,9,5,6,7],
                 [11,1,2,8,3,10,12,4,9,5,6,7],
                 [1,10,2,8,3,4,9,5,6,7,11,12],
                 [1,10,2,8,3,4,9,5,6,12,7,11],
                 [1,10,2,8,3,4,9,5,6,11,12,7],
                 [1,10,2,8,3,12,4,11,9,5,6,7],
                 [1,10,2,8,3,11,12,4,9,5,6,7],
                 [10,1,2,8,3,4,5,12,9,6,7,11],
                 [10,1,2,8,3,12,4,5,9,6,7,11],
                 [10,1,2,8,3,4,5,11,9,6,12,7],
                 [10,1,2,8,3,11,4,5,9,6,12,7],
                 [11,1,2,8,10,3,4,5,9,6,12,7],
                 [1,12,2,8,10,3,4,5,9,6,11,7],
                 [11,1,2,8,3,4,10,5,9,6,12,7],
                 [1,12,2,8,3,4,10,5,9,6,11,7],
                 [1,12,2,8,3,11,4,5,9,6,10,7],
                 [1,11,2,8,12,3,4,5,9,6,10,7],
                 [1,11,2,8,3,4,12,5,9,6,10,7],
                 [1,11,2,8,3,4,5,6,9,7,12,10],
                 [1,12,2,8,3,11,4,5,6,10,9,7],
                 [1,11,2,8,12,3,4,5,6,10,9,7],
                 [1,11,2,8,3,4,12,5,6,10,9,7],
                 [11,1,2,8,3,4,5,10,12,6,9,7],
                 [1,12,2,8,3,4,5,10,11,6,9,7],
                 [1,12,2,8,3,11,4,10,5,6,9,7],
                 [1,11,2,8,12,3,4,10,5,6,9,7],
                 [11,1,2,8,3,10,12,4,5,6,9,7],
                 [11,1,2,8,3,10,4,5,12,6,9,7],
                 [1,12,2,8,3,10,11,4,5,6,9,7],
                 [1,12,2,8,3,10,4,5,11,6,9,7],
                 [1,10,2,8,3,4,5,6,9,7,11,12],
                 [1,10,2,8,3,4,5,12,6,11,9,7],
                 [1,10,2,8,3,12,4,5,6,11,9,7],
                 [1,10,2,8,3,4,5,11,12,6,9,7],
                 [1,10,2,8,3,12,4,11,5,6,9,7],
                 [1,10,2,8,3,11,12,4,5,6,9,7],
                 [1,10,2,8,3,11,4,5,12,6,9,7],
                 [1,8,2,3,4,12,5,6,7,9,10,11],
                 [1,8,2,12,3,4,5,6,7,9,10,11],
                 [1,8,2,3,4,5,6,11,7,9,12,10],
                 [1,8,2,3,4,11,12,5,6,7,9,10],
                 [1,8,2,3,4,11,5,6,12,7,9,10],
                 [1,8,2,3,4,11,5,6,7,9,12,10],
                 [1,8,2,11,3,4,5,6,7,9,12,10],
                 [1,8,11,2,3,4,5,6,7,10,12,9],
                 [1,8,2,3,11,4,5,6,7,10,12,9],
                 [1,8,2,3,4,12,5,6,7,10,11,9],
                 [1,8,2,12,3,4,5,6,7,10,11,9],
                 [1,8,2,3,4,12,5,11,6,10,7,9],
                 [1,8,2,12,3,4,5,11,6,10,7,9],
                 [1,8,2,3,4,11,12,5,6,10,7,9],
                 [1,8,2,12,3,11,4,5,6,10,7,9],
                 [1,8,2,11,12,3,4,5,6,10,7,9],
                 [1,8,2,11,3,4,12,5,6,10,7,9],
                 [1,8,11,2,3,4,5,10,12,6,7,9],
                 [1,8,11,2,3,4,5,10,6,7,12,9],
                 [1,8,2,3,11,4,5,10,12,6,7,9],
                 [1,8,2,3,11,4,5,10,6,7,12,9],
                 [1,8,2,3,4,12,5,10,11,6,7,9],
                 [1,8,2,12,3,4,5,10,11,6,7,9],
                 [1,8,2,3,4,12,5,10,6,7,11,9],
                 [1,8,2,12,3,4,5,10,6,7,11,9],
                 [1,8,2,3,4,10,5,6,7,9,11,12],
                 [1,8,2,3,4,10,5,6,7,12,9,11],
                 [1,8,2,3,4,10,5,12,6,7,9,11],
                 [1,8,2,3,4,10,5,6,7,11,12,9],
                 [1,8,2,3,4,10,5,12,6,11,7,9],
                 [1,8,2,3,4,10,5,11,12,6,7,9],
                 [1,8,2,3,4,10,5,11,6,7,12,9],
                 [1,8,2,12,3,11,4,10,5,6,7,9],
                 [1,8,2,11,12,3,4,10,5,6,7,9],
                 [1,8,11,2,3,10,12,4,5,6,7,9],
                 [1,8,11,2,3,10,4,5,12,6,7,9],
                 [1,8,2,12,3,10,11,4,5,6,7,9],
                 [1,8,2,12,3,10,4,5,11,6,7,9],
                 [1,8,2,10,3,4,5,6,7,9,11,12],
                 [1,8,2,10,3,4,5,12,6,11,7,9],
                 [1,8,2,10,3,12,4,5,6,11,7,9],
                 [1,8,2,10,3,4,5,11,12,6,7,9],
                 [1,8,2,10,3,12,4,11,5,6,7,9],
                 [1,8,2,10,3,11,12,4,5,6,7,9],
                 [1,8,2,10,3,11,4,5,12,6,7,9],
                 [10,12,1,8,2,3,4,5,6,9,7,11],
                 [1,8,10,2,3,4,5,12,6,9,7,11],
                 [1,8,10,2,3,12,4,5,6,9,7,11],
                 [1,8,10,2,3,4,5,11,6,9,12,7],
                 [1,8,10,2,3,11,4,5,6,9,12,7],
                 [1,8,11,2,10,3,4,5,6,9,12,7],
                 [1,8,2,12,10,3,4,5,6,9,11,7],
                 [1,8,2,3,10,4,5,12,6,9,7,11],
                 [1,8,2,3,10,4,5,11,6,9,12,7],
                 [1,8,11,2,3,4,10,5,6,9,12,7],
                 [1,8,2,3,11,4,10,5,6,9,12,7],
                 [1,8,2,3,4,12,10,5,6,9,11,7],
                 [1,8,2,12,3,4,10,5,6,9,11,7],
                 [1,8,2,3,4,12,5,11,6,9,10,7],
                 [1,8,2,12,3,4,5,11,6,9,10,7],
                 [1,8,2,3,4,11,12,5,6,9,10,7],
                 [1,8,2,12,3,11,4,5,6,9,10,7],
                 [1,8,2,11,12,3,4,5,6,9,10,7],
                 [1,8,2,11,3,4,12,5,6,9,10,7],
                 [1,8,2,3,4,12,5,9,6,7,10,11],
                 [1,8,2,12,3,4,5,9,6,7,10,11],
                 [1,8,2,3,4,12,5,9,6,11,7,10],
                 [1,8,2,12,3,4,5,9,6,11,7,10],
                 [1,8,2,3,4,11,5,9,12,6,7,10],
                 [1,8,2,3,4,11,5,9,6,7,12,10],
                 [1,8,2,11,3,4,5,9,12,6,7,10],
                 [1,8,2,11,3,4,5,9,6,7,12,10],
                 [1,8,11,2,3,4,5,9,6,10,12,7],
                 [1,8,2,3,11,4,5,9,6,10,12,7],
                 [1,8,2,3,4,12,5,9,6,10,11,7],
                 [1,8,2,12,3,4,5,9,6,10,11,7],
                 [1,8,2,3,4,10,5,9,6,7,11,12],
                 [1,8,2,3,4,10,5,9,6,12,7,11],
                 [1,8,2,3,4,10,5,9,6,11,12,7],
                 [1,8,2,12,3,11,4,10,5,9,6,7],
                 [1,8,2,11,12,3,4,10,5,9,6,7],
                 [1,8,11,2,3,10,12,4,5,9,6,7],
                 [1,8,2,12,3,10,11,4,5,9,6,7],
                 [1,8,2,10,3,4,5,9,6,7,11,12],
                 [1,8,2,10,3,4,5,9,6,12,7,11],
                 [1,8,2,10,3,4,5,9,6,11,12,7],
                 [1,8,2,10,3,12,4,11,5,9,6,7],
                 [1,8,2,10,3,11,12,4,5,9,6,7],
                 [10,12,1,8,2,3,4,9,5,6,7,11],
                 [10,12,1,8,2,3,4,9,5,11,6,7],
                 [1,8,10,2,3,12,4,9,5,6,7,11],
                 [1,8,10,2,3,12,4,9,5,11,6,7],
                 [1,8,10,2,3,11,4,9,12,5,6,7],
                 [1,8,10,2,3,11,4,9,5,6,12,7],
                 [1,8,11,2,10,3,4,9,12,5,6,7],
                 [1,8,11,2,10,3,4,9,5,6,12,7],
                 [1,8,2,12,10,3,4,9,11,5,6,7],
                 [1,8,2,12,10,3,4,9,5,6,11,7],
                 [1,8,2,3,4,9,10,5,6,12,7,11],
                 [1,8,2,3,4,9,10,5,6,11,12,7],
                 [1,8,2,12,3,11,4,9,10,5,6,7],
                 [1,8,2,11,12,3,4,9,10,5,6,7],
                 [1,8,2,12,3,11,4,9,5,6,10,7],
                 [1,8,2,11,12,3,4,9,5,6,10,7],
                 [1,8,2,12,3,9,4,5,6,11,7,10],
                 [1,8,2,12,3,9,4,11,5,6,7,10],
                 [1,8,2,11,3,9,12,4,5,6,7,10],
                 [1,8,2,11,3,9,4,5,12,6,7,10],
                 [1,8,11,2,3,9,4,5,6,10,12,7],
                 [1,8,2,12,3,9,4,5,6,10,11,7],
                 [1,8,2,12,3,9,4,11,5,10,6,7],
                 [1,8,2,11,3,9,12,4,5,10,6,7],
                 [1,8,11,2,3,9,4,10,12,5,6,7],
                 [1,8,11,2,3,9,4,10,5,6,12,7],
                 [1,8,2,12,3,9,4,10,11,5,6,7],
                 [1,8,2,12,3,9,4,10,5,6,11,7],
                 [1,8,2,10,3,9,4,11,12,5,6,7],
                 [1,8,2,9,10,3,4,11,12,5,6,7],
                 [1,8,2,9,11,3,10,4,12,5,6,7],
                 [1,8,2,9,11,3,10,4,5,6,12,7],
                 [1,8,2,9,3,12,10,4,11,5,6,7],
                 [1,8,2,9,3,12,10,4,5,6,11,7],
                 [1,8,2,9,3,12,4,11,10,5,6,7],
                 [1,8,2,9,3,11,12,4,10,5,6,7],
                 [1,8,2,9,11,3,4,5,10,6,12,7],
                 [1,8,2,9,3,12,4,5,10,6,11,7],
                 [1,8,2,9,3,12,4,5,6,11,10,7],
                 [1,8,2,9,3,12,4,11,5,6,10,7],
                 [1,8,2,9,3,11,12,4,5,6,10,7],
                 [1,8,2,9,3,11,4,5,12,6,10,7],
                 [8,1,2,3,4,12,5,7,6,9,10,11],
                 [8,1,2,12,3,4,5,7,6,9,10,11],
                 [8,1,2,3,4,12,5,7,6,11,9,10],
                 [8,1,2,12,3,4,5,7,6,11,9,10],
                 [8,1,2,3,4,11,5,7,12,6,9,10],
                 [8,1,2,3,4,11,5,7,6,9,12,10],
                 [8,1,2,11,3,4,5,7,12,6,9,10],
                 [8,1,2,11,3,4,5,7,6,9,12,10],
                 [8,11,1,2,3,4,5,7,6,9,12,10],
                 [8,1,11,2,3,4,5,7,6,10,12,9],
                 [8,1,2,3,11,4,5,7,6,10,12,9],
                 [8,1,2,3,4,12,5,7,6,10,11,9],
                 [8,1,2,12,3,4,5,7,6,10,11,9],
                 [8,1,2,3,4,10,5,7,6,9,11,12],
                 [8,1,2,3,4,10,5,7,6,12,9,11],
                 [8,1,2,3,4,10,5,7,6,11,12,9],
                 [8,1,2,12,3,11,4,10,5,7,6,9],
                 [8,12,1,2,3,11,4,10,5,7,6,9],
                 [8,1,2,11,12,3,4,10,5,7,6,9],
                 [8,12,1,11,2,3,4,10,5,7,6,9],
                 [8,11,12,1,2,3,4,10,5,7,6,9],
                 [8,11,1,2,12,3,4,10,5,7,6,9],
                 [11,8,1,2,3,10,12,4,5,7,6,9],
                 [8,1,11,2,3,10,12,4,5,7,6,9],
                 [8,1,2,12,3,10,11,4,5,7,6,9],
                 [8,12,1,2,3,10,11,4,5,7,6,9],
                 [8,1,2,10,3,4,5,7,6,9,11,12],
                 [8,1,2,10,3,4,5,7,6,12,9,11],
                 [8,1,2,10,3,4,5,7,6,11,12,9],
                 [8,1,2,10,3,12,4,11,5,7,6,9],
                 [8,1,2,10,3,11,12,4,5,7,6,9],
                 [8,12,1,11,2,10,3,4,5,7,6,9],
                 [8,11,12,1,2,10,3,4,5,7,6,9],
                 [11,8,1,10,12,2,3,4,5,7,6,9],
                 [11,8,1,10,2,3,12,4,5,7,6,9],
                 [8,12,1,10,11,2,3,4,5,7,6,9],
                 [8,12,1,10,2,3,11,4,5,7,6,9],
                 [8,10,1,2,3,12,4,11,5,7,6,9],
                 [8,10,1,12,2,3,4,11,5,7,6,9],
                 [8,10,1,2,3,11,12,4,5,7,6,9],
                 [8,10,1,12,2,11,3,4,5,7,6,9],
                 [8,10,1,11,12,2,3,4,5,7,6,9],
                 [8,10,1,11,2,3,12,4,5,7,6,9],
                 [10,8,1,2,3,12,4,9,5,7,6,11],
                 [10,12,8,1,2,3,4,9,5,7,6,11],
                 [10,8,1,2,3,11,4,9,5,7,12,6],
                 [10,8,1,11,2,3,4,9,5,7,12,6],
                 [11,8,10,1,2,3,4,9,5,7,12,6],
                 [8,12,10,1,2,3,4,9,5,7,11,6],
                 [8,1,10,2,3,12,4,9,5,7,6,11],
                 [8,1,10,2,3,11,4,9,5,7,12,6],
                 [11,8,1,2,10,3,4,9,5,7,12,6],
                 [8,1,11,2,10,3,4,9,5,7,12,6],
                 [8,1,2,12,10,3,4,9,5,7,11,6],
                 [8,12,1,2,10,3,4,9,5,7,11,6],
                 [8,1,2,12,3,11,4,9,5,7,10,6],
                 [8,12,1,2,3,11,4,9,5,7,10,6],
                 [8,1,2,11,12,3,4,9,5,7,10,6],
                 [8,12,1,11,2,3,4,9,5,7,10,6],
                 [8,11,1,2,12,3,4,9,5,7,10,6],
                 [8,1,2,12,3,9,4,11,5,7,6,10],
                 [8,12,1,2,3,9,4,11,5,7,6,10],
                 [8,1,2,11,3,9,12,4,5,7,6,10],
                 [8,11,1,2,3,9,12,4,5,7,6,10],
                 [11,8,1,2,3,9,4,10,5,7,12,6],
                 [8,1,11,2,3,9,4,10,5,7,12,6],
                 [8,1,2,12,3,9,4,10,5,7,11,6],
                 [8,12,1,2,3,9,4,10,5,7,11,6],
                 [8,1,2,10,3,9,4,12,5,7,6,11],
                 [8,1,2,10,3,9,4,11,5,7,12,6],
                 [8,10,1,2,3,9,4,12,5,7,6,11],
                 [8,10,1,2,3,9,4,11,5,7,12,6],
                 [10,12,8,1,2,9,3,4,5,7,6,11],
                 [10,8,1,11,2,9,3,4,5,7,12,6],
                 [11,8,10,1,2,9,3,4,5,7,12,6],
                 [8,12,10,1,2,9,3,4,5,7,11,6],
                 [8,1,2,9,10,3,4,12,5,7,6,11],
                 [8,1,2,9,10,3,4,11,5,7,12,6],
                 [8,1,2,9,11,3,10,4,5,7,12,6],
                 [8,1,2,9,3,12,10,4,5,7,11,6],
                 [8,1,2,9,3,12,4,11,5,7,10,6],
                 [8,1,2,9,3,11,12,4,5,7,10,6],
                 [8,12,1,11,2,9,3,4,5,7,10,6],
                 [8,12,1,9,2,3,4,11,5,7,6,10],
                 [8,12,1,9,2,11,3,4,5,7,6,10],
                 [8,11,1,9,12,2,3,4,5,7,6,10],
                 [8,11,1,9,2,3,12,4,5,7,6,10],
                 [11,8,1,9,2,3,4,10,5,7,12,6],
                 [8,12,1,9,2,3,4,10,5,7,11,6],
                 [11,8,1,9,2,10,3,4,5,7,12,6],
                 [8,12,1,9,2,10,3,4,5,7,11,6],
                 [8,10,1,9,2,3,4,12,5,7,6,11],
                 [8,10,1,9,2,12,3,4,5,7,6,11],
                 [8,10,1,9,2,3,4,11,5,7,12,6],
                 [8,10,1,9,2,11,3,4,5,7,12,6],
                 [10,12,8,9,1,2,3,4,5,7,6,11],
                 [8,9,10,1,2,3,4,12,5,7,6,11],
                 [8,9,10,1,2,12,3,4,5,7,6,11],
                 [8,9,10,1,2,3,4,11,5,7,12,6],
                 [8,9,10,1,2,11,3,4,5,7,12,6],
                 [8,9,11,1,10,2,3,4,5,7,12,6],
                 [8,9,11,1,2,3,10,4,5,7,12,6],
                 [8,9,1,11,12,2,3,4,5,7,10,6],
                 [8,9,1,11,2,3,12,4,5,7,10,6],
                 [10,12,9,1,8,2,3,4,5,7,6,11],
                 [10,9,1,11,8,2,3,4,5,7,12,6],
                 [11,9,10,1,8,2,3,4,5,7,12,6],
                 [9,12,10,1,8,2,3,4,5,7,11,6],
                 [9,1,8,2,10,3,4,12,5,7,6,11],
                 [9,1,8,2,10,3,4,11,5,7,12,6],
                 [9,1,8,2,11,3,10,4,5,7,12,6],
                 [9,1,8,2,3,12,10,4,5,7,11,6],
                 [9,1,8,2,3,12,4,11,5,7,10,6],
                 [9,1,8,2,3,11,12,4,5,7,10,6],
                 [9,12,1,11,8,2,3,4,5,7,10,6],
                 [1,11,8,2,9,3,12,4,5,7,6,10],
                 [11,1,8,2,9,3,4,10,5,7,12,6],
                 [1,10,8,2,9,3,4,12,5,7,6,11],
                 [1,10,8,2,9,3,4,11,5,7,12,6],
                 [10,1,8,2,3,12,9,4,5,7,6,11],
                 [10,1,8,2,3,11,9,4,5,7,12,6],
                 [11,1,8,2,10,3,9,4,5,7,12,6],
                 [1,11,8,2,12,3,9,4,5,7,10,6],
                 [1,11,8,2,3,4,5,7,9,6,12,10],
                 [1,11,8,2,12,3,4,10,5,7,9,6],
                 [1,10,8,2,3,4,5,7,9,6,11,12],
                 [1,10,8,2,3,12,4,11,5,7,9,6],
                 [1,10,8,2,3,11,12,4,5,7,9,6],
                 [1,2,8,3,4,11,5,7,6,9,12,10],
                 [1,2,8,3,11,4,5,7,6,10,12,9],
                 [1,2,8,3,4,12,5,7,6,10,11,9],
                 [1,2,8,3,4,10,5,7,6,12,9,11],
                 [1,2,8,3,4,10,5,7,6,11,12,9],
                 [1,11,12,2,8,3,4,10,5,7,6,9],
                 [11,1,2,10,8,3,12,4,5,7,6,9],
                 [1,10,2,12,8,3,4,11,5,7,6,9],
                 [1,10,2,11,8,3,12,4,5,7,6,9],
                 [10,1,2,12,8,3,4,9,5,7,6,11],
                 [10,12,1,2,8,3,4,9,5,7,6,11],
                 [10,1,2,11,8,3,4,9,5,7,12,6],
                 [11,1,10,2,8,3,4,9,5,7,12,6],
                 [1,11,12,2,8,3,4,9,5,7,10,6],
                 [1,11,2,9,8,3,12,4,5,7,6,10],
                 [11,1,2,9,8,3,4,10,5,7,12,6],
                 [1,10,2,9,8,3,4,12,5,7,6,11],
                 [1,10,2,9,8,3,4,11,5,7,12,6],
                 [1,9,10,2,8,3,4,12,5,7,6,11],
                 [1,9,10,2,8,3,4,11,5,7,12,6],
                 [1,9,11,2,8,3,10,4,5,7,12,6],
                 [1,9,2,12,8,3,10,4,5,7,11,6],
                 [1,9,2,12,8,3,4,11,5,7,10,6],
                 [1,9,2,11,8,3,12,4,5,7,10,6],
                 [10,12,9,1,2,3,8,4,5,7,6,11],
                 [11,9,10,1,2,3,8,4,5,7,12,6],
                 [9,12,10,1,2,3,8,4,5,7,11,6],
                 [9,1,10,2,3,12,8,4,5,7,6,11],
                 [9,1,10,2,3,11,8,4,5,7,12,6],
                 [11,9,1,2,10,3,8,4,5,7,12,6],
                 [9,1,11,2,10,3,8,4,5,7,12,6],
                 [9,1,2,12,10,3,8,4,5,7,11,6],
                 [9,12,1,2,10,3,8,4,5,7,11,6],
                 [9,1,2,12,3,11,8,4,5,7,10,6],
                 [9,12,1,2,3,11,8,4,5,7,10,6],
                 [9,1,2,11,12,3,8,4,5,7,10,6],
                 [9,12,1,11,2,3,8,4,5,7,10,6],
                 [9,11,1,2,12,3,8,4,5,7,10,6],
                 [1,10,9,2,3,12,8,4,5,7,6,11],
                 [1,10,9,2,3,11,8,4,5,7,12,6],
                 [10,1,2,12,9,3,8,4,5,7,6,11],
                 [10,12,1,2,9,3,8,4,5,7,6,11],
                 [10,1,2,11,9,3,8,4,5,7,12,6],
                 [11,1,10,2,9,3,8,4,5,7,12,6],
                 [1,11,12,2,9,3,8,4,5,7,10,6],
                 [1,2,3,11,8,4,5,7,9,6,12,10],
                 [1,11,2,3,8,4,5,7,9,6,12,10],
                 [1,11,12,2,3,10,8,4,5,7,9,6],
                 [11,1,2,10,12,3,8,4,5,7,9,6],
                 [1,10,2,3,8,4,5,7,9,6,11,12],
                 [1,10,2,12,3,11,8,4,5,7,9,6],
                 [1,10,2,11,12,3,8,4,5,7,9,6],
                 [1,2,3,4,5,7,8,6,9,11,12,10],
                 [1,11,12,2,3,4,5,7,8,6,9,10],
                 [11,1,2,3,4,10,5,7,8,6,12,9],
                 [1,2,11,3,4,10,5,7,8,6,12,9],
                 [1,2,3,12,4,10,5,7,8,6,11,9],
                 [1,12,2,3,4,10,5,7,8,6,11,9],
                 [1,2,3,10,4,12,5,7,8,6,9,11],
                 [1,2,3,10,4,11,5,7,8,6,12,9],
                 [11,1,2,10,3,4,5,7,8,6,12,9],
                 [1,12,2,10,3,4,5,7,8,6,11,9],
                 [1,10,2,3,4,12,5,7,8,6,9,11],
                 [1,10,2,12,3,4,5,7,8,6,9,11],
                 [1,10,2,3,4,11,5,7,8,6,12,9],
                 [1,10,2,11,3,4,5,7,8,6,12,9],
                 [1,2,3,11,4,9,5,7,8,6,12,10],
                 [1,11,2,3,4,9,5,7,8,6,12,10],
                 [1,11,12,2,3,10,4,9,5,7,8,6],
                 [1,10,2,3,4,9,5,7,8,6,11,12],
                 [1,10,2,12,3,11,4,9,5,7,8,6],
                 [1,10,2,11,12,3,4,9,5,7,8,6],
                 [10,1,2,12,3,9,4,11,5,7,8,6],
                 [10,12,1,2,3,9,4,11,5,7,8,6],
                 [10,1,2,11,3,9,12,4,5,7,8,6],
                 [1,11,12,2,3,9,10,4,5,7,8,6],
                 [1,11,2,9,3,4,5,7,8,6,12,10],
                 [1,10,2,9,3,4,5,7,8,6,11,12],
                 [1,10,2,9,3,12,4,11,5,7,8,6],
                 [1,10,2,9,3,11,12,4,5,7,8,6],
                 [10,12,1,9,2,3,4,11,5,7,8,6],
                 [10,12,1,9,2,11,3,4,5,7,8,6],
                 [10,11,1,9,12,2,3,4,5,7,8,6],
                 [10,11,1,9,2,3,12,4,5,7,8,6],
                 [1,9,10,2,3,4,5,7,8,6,11,12],
                 [1,9,10,2,3,12,4,11,5,7,8,6],
                 [1,9,10,2,3,11,12,4,5,7,8,6],
                 [1,9,11,2,10,3,12,4,5,7,8,6],
                 [1,9,2,12,10,3,11,4,5,7,8,6],
                 [1,9,2,3,10,4,5,7,8,6,11,12],
                 [1,9,2,12,3,11,10,4,5,7,8,6],
                 [1,9,2,11,12,3,10,4,5,7,8,6],
                 [1,2,3,12,4,7,5,6,8,11,9,10],
                 [1,2,3,11,4,7,5,6,12,8,9,10],
                 [1,2,3,11,4,7,5,6,8,9,12,10],
                 [1,11,2,3,4,7,5,6,12,8,9,10],
                 [1,11,2,3,4,7,5,6,8,9,12,10],
                 [11,1,2,3,4,7,5,6,8,10,12,9],
                 [1,2,11,3,4,7,5,6,8,10,12,9],
                 [1,2,3,12,4,7,5,6,8,10,11,9],
                 [11,1,2,3,4,7,5,10,6,8,12,9],
                 [1,2,11,3,4,7,5,10,6,8,12,9],
                 [1,2,3,12,4,7,5,10,6,8,11,9],
                 [1,2,3,10,4,7,5,6,8,12,9,11],
                 [1,2,3,10,4,7,5,12,6,8,9,11],
                 [1,2,3,10,4,7,5,6,8,11,12,9],
                 [1,2,3,10,4,7,5,11,6,8,12,9],
                 [1,10,2,3,4,7,5,6,8,9,11,12],
                 [1,10,2,3,4,7,5,6,8,12,9,11],
                 [1,10,2,3,4,7,5,12,6,8,9,11],
                 [1,10,2,3,4,7,5,6,8,11,12,9],
                 [1,10,2,3,4,7,5,12,6,11,8,9],
                 [1,10,2,3,4,7,5,11,12,6,8,9],
                 [1,10,2,3,4,7,5,11,6,8,12,9],
                 [1,10,2,12,3,11,4,7,5,6,8,9],
                 [1,10,2,11,12,3,4,7,5,6,8,9],
                 [10,1,2,3,4,7,5,12,6,9,8,11],
                 [10,1,2,3,4,7,5,11,6,9,12,8],
                 [1,2,10,3,4,7,5,12,6,9,8,11],
                 [1,2,10,3,4,7,5,11,6,9,12,8],
                 [11,1,2,3,4,7,10,5,6,9,12,8],
                 [1,2,11,3,4,7,10,5,6,9,12,8],
                 [1,2,3,12,4,7,10,5,6,9,11,8],
                 [1,2,3,12,4,7,5,11,6,9,10,8],
                 [1,2,3,11,4,7,12,5,6,9,10,8],
                 [1,11,2,3,4,7,12,5,6,9,10,8],
                 [1,2,3,12,4,7,5,9,6,11,8,10],
                 [1,2,3,11,4,7,5,9,12,6,8,10],
                 [1,2,3,11,4,7,5,9,6,8,12,10],
                 [1,11,2,3,4,7,5,9,12,6,8,10],
                 [1,11,2,3,4,7,5,9,6,8,12,10],
                 [11,1,2,3,4,7,5,9,6,10,12,8],
                 [1,2,11,3,4,7,5,9,6,10,12,8],
                 [1,2,3,12,4,7,5,9,6,10,11,8],
                 [1,2,3,10,4,7,5,9,6,12,8,11],
                 [1,2,3,10,4,7,5,9,6,11,12,8],
                 [1,10,2,3,4,7,5,9,6,12,8,11],
                 [1,10,2,3,4,7,5,9,6,11,12,8],
                 [1,10,2,12,3,11,4,7,5,9,6,8],
                 [1,10,2,11,12,3,4,7,5,9,6,8],
                 [10,1,2,12,3,9,4,7,5,6,8,11],
                 [10,12,1,2,3,9,4,7,5,6,8,11],
                 [10,1,2,12,3,9,4,7,5,11,6,8],
                 [10,12,1,2,3,9,4,7,5,11,6,8],
                 [10,1,2,11,3,9,4,7,12,5,6,8],
                 [10,1,2,11,3,9,4,7,5,6,12,8],
                 [11,1,10,2,3,9,4,7,5,6,12,8],
                 [1,12,10,2,3,9,4,7,5,6,11,8],
                 [1,12,2,11,3,9,4,7,5,6,10,8],
                 [1,11,12,2,3,9,4,7,5,6,10,8],
                 [1,12,2,9,3,11,4,7,5,6,8,10],
                 [1,11,2,9,12,3,4,7,5,6,8,10],
                 [11,1,2,9,3,10,4,7,5,6,12,8],
                 [1,12,2,9,3,10,4,7,5,6,11,8],
                 [1,10,2,9,3,12,4,7,5,6,8,11],
                 [1,10,2,9,3,12,4,7,5,11,6,8],
                 [1,10,2,9,3,11,4,7,12,5,6,8],
                 [1,10,2,9,3,11,4,7,5,6,12,8],
                 [10,12,1,9,2,3,4,7,5,6,8,11],
                 [10,12,1,9,2,3,4,7,5,11,6,8],
                 [1,9,10,2,3,12,4,7,5,6,8,11],
                 [1,9,10,2,3,12,4,7,5,11,6,8],
                 [1,9,10,2,3,11,4,7,12,5,6,8],
                 [1,9,10,2,3,11,4,7,5,6,12,8],
                 [1,9,11,2,10,3,4,7,12,5,6,8],
                 [1,9,11,2,10,3,4,7,5,6,12,8],
                 [1,9,2,12,10,3,4,7,11,5,6,8],
                 [1,9,2,12,10,3,4,7,5,6,11,8],
                 [1,9,2,12,3,11,4,7,10,5,6,8],
                 [1,9,2,11,12,3,4,7,10,5,6,8],
                 [1,9,2,12,3,11,4,7,5,6,10,8],
                 [1,9,2,11,12,3,4,7,5,6,10,8],
                 [10,12,9,1,2,3,4,7,5,8,6,11],
                 [11,9,10,1,2,3,4,7,5,8,12,6],
                 [9,12,10,1,2,3,4,7,5,8,11,6],
                 [9,1,10,2,3,12,4,7,5,8,6,11],
                 [9,1,10,2,3,11,4,7,5,8,12,6],
                 [11,9,1,2,10,3,4,7,5,8,12,6],
                 [9,1,11,2,10,3,4,7,5,8,12,6],
                 [9,1,2,12,10,3,4,7,5,8,11,6],
                 [9,12,1,2,10,3,4,7,5,8,11,6],
                 [9,1,2,12,3,11,4,7,5,8,10,6],
                 [9,12,1,2,3,11,4,7,5,8,10,6],
                 [9,1,2,11,12,3,4,7,5,8,10,6],
                 [9,12,1,11,2,3,4,7,5,8,10,6],
                 [9,11,1,2,12,3,4,7,5,8,10,6],
                 [1,10,9,2,3,12,4,7,5,8,6,11],
                 [1,10,9,2,3,11,4,7,5,8,12,6],
                 [10,12,1,2,9,3,4,7,5,8,6,11],
                 [10,1,2,11,9,3,4,7,5,8,12,6],
                 [1,2,3,11,4,7,5,8,9,6,12,10],
                 [1,11,2,3,4,7,5,8,9,6,12,10],
                 [1,10,2,11,12,3,4,7,5,8,9,6],
                 [1,2,3,8,4,7,5,6,9,11,12,10],
                 [1,2,3,8,4,7,5,11,6,9,12,10],
                 [11,1,2,10,3,8,4,7,5,6,12,9],
                 [1,12,2,10,3,8,4,7,5,6,11,9],
                 [1,10,2,12,3,8,4,7,5,6,9,11],
                 [1,10,2,11,3,8,4,7,5,6,12,9],
                 [10,12,1,2,3,8,4,7,5,9,6,11],
                 [1,11,2,9,3,8,4,7,5,6,12,10],
                 [1,10,2,9,3,8,4,7,5,6,11,12],
                 [1,10,2,9,3,8,4,7,5,12,6,11],
                 [1,10,2,9,3,8,4,7,5,11,12,6],
                 [10,12,1,9,2,11,3,8,4,7,5,6],
                 [10,11,1,9,12,2,3,8,4,7,5,6],
                 [1,9,10,2,3,8,4,7,5,6,11,12],
                 [1,9,10,2,3,8,4,7,5,12,6,11],
                 [1,9,10,2,3,8,4,7,5,11,12,6],
                 [1,9,11,2,3,8,4,7,10,5,12,6],
                 [1,9,2,12,3,8,4,7,10,5,11,6],
                 [1,9,2,12,3,8,4,7,5,11,10,6],
                 [1,9,2,11,3,8,4,7,12,5,10,6],
                 [10,12,9,1,2,8,3,11,4,7,5,6],
                 [10,11,9,1,2,8,12,3,4,7,5,6],
                 [11,9,10,1,2,8,12,3,4,7,5,6],
                 [9,12,10,1,2,8,11,3,4,7,5,6],
                 [9,1,2,8,10,3,4,7,5,6,11,12],
                 [9,1,2,8,10,3,4,7,5,12,6,11],
                 [9,1,2,8,10,3,4,7,5,11,12,6],
                 [9,12,1,11,2,8,10,3,4,7,5,6],
                 [9,11,12,1,2,8,10,3,4,7,5,6],
                 [9,1,2,8,11,3,4,7,10,5,12,6],
                 [9,1,2,8,3,12,4,7,10,5,11,6],
                 [9,1,2,8,3,12,4,7,5,11,10,6],
                 [9,1,2,8,3,11,4,7,12,5,10,6],
                 [1,11,2,8,9,3,4,7,5,6,12,10],
                 [1,10,2,8,9,3,4,7,5,6,11,12],
                 [1,10,2,8,9,3,4,7,5,12,6,11],
                 [1,10,2,8,9,3,4,7,5,11,12,6],
                 [10,1,2,8,3,12,4,7,9,5,6,11],
                 [10,1,2,8,3,11,4,7,9,5,12,6],
                 [1,10,2,8,3,12,4,7,5,11,9,6],
                 [1,8,2,3,4,7,5,6,9,11,12,10],
                 [1,8,2,3,4,7,5,11,6,9,12,10],
                 [1,8,2,12,3,11,4,7,5,6,9,10],
                 [1,8,2,11,12,3,4,7,5,6,9,10],
                 [1,8,2,12,3,11,4,7,5,10,6,9],
                 [1,8,2,11,12,3,4,7,5,10,6,9],
                 [1,8,11,2,3,10,4,7,12,5,6,9],
                 [1,8,11,2,3,10,4,7,5,6,12,9],
                 [1,8,2,12,3,10,4,7,11,5,6,9],
                 [1,8,2,12,3,10,4,7,5,6,11,9],
                 [1,8,2,10,3,12,4,7,5,6,9,11],
                 [1,8,2,10,3,12,4,7,5,11,6,9],
                 [1,8,2,10,3,11,4,7,12,5,6,9],
                 [1,8,2,10,3,11,4,7,5,6,12,9],
                 [10,12,1,8,2,3,4,7,5,9,6,11],
                 [1,8,10,2,3,12,4,7,5,9,6,11],
                 [1,8,10,2,3,11,4,7,5,9,12,6],
                 [1,8,11,2,10,3,4,7,5,9,12,6],
                 [1,8,2,12,10,3,4,7,5,9,11,6],
                 [1,8,2,12,3,11,4,7,5,9,10,6],
                 [1,8,2,11,12,3,4,7,5,9,10,6],
                 [1,8,2,12,3,9,4,7,5,6,10,11],
                 [1,8,2,12,3,9,4,7,5,11,6,10],
                 [1,8,2,11,3,9,4,7,12,5,6,10],
                 [1,8,2,11,3,9,4,7,5,6,12,10],
                 [1,8,11,2,3,9,4,7,5,10,12,6],
                 [1,8,2,12,3,9,4,7,5,10,11,6],
                 [1,8,2,10,3,9,4,7,5,6,11,12],
                 [1,8,2,10,3,9,4,7,5,12,6,11],
                 [1,8,2,10,3,9,4,7,5,11,12,6],
                 [10,12,1,8,2,9,3,11,4,7,5,6],
                 [10,11,1,8,2,9,12,3,4,7,5,6],
                 [1,8,2,9,10,3,4,7,5,6,11,12],
                 [1,8,2,9,10,3,4,7,5,12,6,11],
                 [1,8,2,9,10,3,4,7,5,11,12,6],
                 [1,8,2,9,11,3,4,7,10,5,12,6],
                 [1,8,2,9,3,12,4,7,10,5,11,6],
                 [1,8,2,9,3,12,4,7,5,11,10,6],
                 [1,8,2,9,3,11,4,7,12,5,10,6],
                 [8,1,2,12,3,7,4,5,6,9,10,11],
                 [8,1,2,11,3,7,4,5,6,9,12,10],
                 [8,11,1,2,3,7,4,5,6,9,12,10],
                 [8,1,11,2,3,7,4,5,6,10,12,9],
                 [8,1,2,12,3,7,4,5,6,10,11,9],
                 [8,1,2,12,3,7,4,11,5,10,6,9],
                 [8,12,1,2,3,7,4,11,5,10,6,9],
                 [8,1,2,11,3,7,12,4,5,10,6,9],
                 [11,8,1,2,3,7,4,10,12,5,6,9],
                 [11,8,1,2,3,7,4,10,5,6,12,9],
                 [8,1,11,2,3,7,4,10,12,5,6,9],
                 [8,1,11,2,3,7,4,10,5,6,12,9],
                 [8,1,2,12,3,7,4,10,11,5,6,9],
                 [8,12,1,2,3,7,4,10,11,5,6,9],
                 [8,1,2,12,3,7,4,10,5,6,11,9],
                 [8,12,1,2,3,7,4,10,5,6,11,9],
                 [8,1,2,10,3,7,4,5,6,9,11,12],
                 [8,1,2,10,3,7,4,12,5,11,6,9],
                 [8,1,2,10,3,7,4,11,12,5,6,9],
                 [8,12,1,11,2,10,3,7,4,5,6,9],
                 [8,11,12,1,2,10,3,7,4,5,6,9],
                 [11,8,1,10,12,2,3,7,4,5,6,9],
                 [8,12,1,10,11,2,3,7,4,5,6,9],
                 [8,10,1,2,3,7,4,12,5,11,6,9],
                 [8,10,1,2,3,7,4,11,12,5,6,9],
                 [8,10,1,12,2,11,3,7,4,5,6,9],
                 [8,10,1,11,12,2,3,7,4,5,6,9],
                 [10,8,1,2,3,7,4,12,5,9,6,11],
                 [10,8,1,2,3,7,4,11,5,9,12,6],
                 [8,1,10,2,3,7,4,12,5,9,6,11],
                 [8,1,10,2,3,7,4,11,5,9,12,6],
                 [11,8,1,2,3,7,10,4,5,9,12,6],
                 [8,1,11,2,3,7,10,4,5,9,12,6],
                 [8,1,2,12,3,7,10,4,5,9,11,6],
                 [8,12,1,2,3,7,10,4,5,9,11,6],
                 [8,1,2,12,3,7,4,11,5,9,10,6],
                 [8,12,1,2,3,7,4,11,5,9,10,6],
                 [8,1,2,11,3,7,12,4,5,9,10,6],
                 [8,11,1,2,3,7,12,4,5,9,10,6],
                 [8,1,2,12,3,7,4,9,5,6,10,11],
                 [8,1,2,12,3,7,4,9,5,11,6,10],
                 [8,1,2,11,3,7,4,9,12,5,6,10],
                 [8,1,2,11,3,7,4,9,5,6,12,10],
                 [8,11,1,2,3,7,4,9,5,6,12,10],
                 [8,1,11,2,3,7,4,9,5,10,12,6],
                 [8,1,2,12,3,7,4,9,5,10,11,6],
                 [8,1,2,10,3,7,4,9,5,6,11,12],
                 [8,1,2,10,3,7,4,9,5,12,6,11],
                 [8,1,2,10,3,7,4,9,5,11,12,6],
                 [8,12,1,11,2,10,3,7,4,9,5,6],
                 [8,11,12,1,2,10,3,7,4,9,5,6],
                 [11,8,1,10,12,2,3,7,4,9,5,6],
                 [8,12,1,10,11,2,3,7,4,9,5,6],
                 [8,10,1,12,2,11,3,7,4,9,5,6],
                 [8,10,1,11,12,2,3,7,4,9,5,6],
                 [8,1,2,9,3,7,10,4,5,6,11,12],
                 [8,1,2,9,3,7,10,4,5,12,6,11],
                 [8,1,2,9,3,7,10,4,5,11,12,6],
                 [8,12,1,11,2,9,3,7,10,4,5,6],
                 [8,11,12,1,2,9,3,7,10,4,5,6],
                 [8,1,2,9,3,7,11,4,10,5,12,6],
                 [8,1,2,9,3,7,4,12,10,5,11,6],
                 [8,1,2,9,3,7,4,12,5,11,10,6],
                 [8,11,1,9,12,2,3,7,4,5,6,10],
                 [8,12,1,9,2,11,3,7,4,10,5,6],
                 [8,11,1,9,12,2,3,7,4,10,5,6],
                 [9,1,8,2,3,7,10,4,5,6,11,12],
                 [9,1,8,2,3,7,10,4,5,12,6,11],
                 [9,1,8,2,3,7,10,4,5,11,12,6],
                 [9,12,1,11,8,2,3,7,10,4,5,6],
                 [9,11,12,1,8,2,3,7,10,4,5,6],
                 [9,1,8,2,3,7,11,4,10,5,12,6],
                 [9,1,8,2,3,7,4,12,5,11,10,6],
                 [1,11,8,2,3,7,9,4,5,6,12,10],
                 [1,11,8,2,3,7,4,5,9,6,12,10],
                 [1,2,3,7,8,4,5,6,9,11,12,10],
                 [1,2,3,7,8,4,5,11,6,9,12,10],
                 [11,1,2,10,3,7,8,4,5,6,12,9],
                 [1,12,2,10,3,7,8,4,5,6,11,9],
                 [1,10,2,12,3,7,8,4,5,6,9,11],
                 [1,10,2,11,3,7,8,4,5,6,12,9],
                 [10,12,1,2,3,7,8,4,5,9,6,11],
                 [1,11,2,9,3,7,8,4,5,6,12,10],
                 [10,12,1,9,2,11,3,7,8,4,5,6],
                 [10,11,1,9,12,2,3,7,8,4,5,6],
                 [1,9,10,2,3,7,8,4,5,6,11,12],
                 [1,9,10,2,3,7,8,4,5,12,6,11],
                 [1,9,10,2,3,7,8,4,5,11,12,6],
                 [1,9,11,2,3,7,8,4,10,5,12,6],
                 [1,9,2,12,3,7,8,4,10,5,11,6],
                 [1,9,2,12,3,7,8,4,5,11,10,6],
                 [1,9,2,11,3,7,8,4,12,5,10,6],
                 [11,9,1,2,3,7,10,4,8,5,12,6],
                 [9,1,11,2,3,7,10,4,8,5,12,6],
                 [9,1,2,12,3,7,10,4,8,5,11,6],
                 [9,12,1,2,3,7,10,4,8,5,11,6],
                 [9,1,2,12,3,7,4,11,8,5,10,6],
                 [9,12,1,2,3,7,4,11,8,5,10,6],
                 [9,1,2,11,3,7,12,4,8,5,10,6],
                 [10,12,1,2,3,7,9,4,8,5,6,11],
                 [1,2,3,7,4,11,8,5,9,6,12,10],
                 [1,2,3,7,4,5,8,6,9,11,12,10],
                 [1,2,3,7,11,4,5,10,8,6,12,9],
                 [1,2,3,7,4,10,5,12,8,6,9,11],
                 [1,2,3,7,4,10,5,11,8,6,12,9],
                 [11,1,2,10,3,7,4,5,8,6,12,9],
                 [1,12,2,10,3,7,4,5,8,6,11,9],
                 [1,10,2,12,3,7,4,5,8,6,9,11],
                 [1,10,2,11,3,7,4,5,8,6,12,9],
                 [1,2,3,7,4,11,5,9,8,6,12,10],
                 [10,12,1,2,3,7,4,9,5,11,8,6],
                 [1,11,2,9,3,7,4,5,8,6,12,10],
                 [10,12,1,9,2,11,3,7,4,5,8,6],
                 [10,11,1,9,12,2,3,7,4,5,8,6],
                 [1,9,2,12,3,7,10,4,11,5,8,6],
                 [1,9,2,12,3,7,4,11,10,5,8,6],
                 [11,1,2,7,3,4,5,10,6,8,12,9],
                 [11,1,2,7,3,10,4,5,6,8,12,9],
                 [1,12,2,7,3,10,4,5,6,8,11,9],
                 [1,10,2,7,3,4,5,12,6,8,9,11],
                 [1,10,2,7,3,12,4,5,6,8,9,11],
                 [1,10,2,7,3,4,5,11,6,8,12,9],
                 [1,10,2,7,3,11,4,5,6,8,12,9],
                 [10,1,2,7,3,4,5,12,6,9,8,11],
                 [10,1,2,7,3,12,4,5,6,9,8,11],
                 [10,1,2,7,3,4,5,11,6,9,12,8],
                 [10,1,2,7,3,11,4,5,6,9,12,8],
                 [11,1,2,7,10,3,4,5,6,9,12,8],
                 [1,12,2,7,10,3,4,5,6,9,11,8],
                 [11,1,2,7,3,4,10,5,6,9,12,8],
                 [1,12,2,7,3,11,4,5,6,9,10,8],
                 [1,11,2,7,12,3,4,5,6,9,10,8],
                 [1,11,2,7,3,4,12,5,6,9,10,8],
                 [1,11,2,7,3,4,5,9,12,6,8,10],
                 [1,11,2,7,3,4,5,9,6,8,12,10],
                 [11,1,2,7,3,4,5,9,6,10,12,8],
                 [1,10,2,7,3,4,5,9,6,12,8,11],
                 [1,10,2,7,3,4,5,9,6,11,12,8],
                 [10,1,2,7,3,12,4,9,5,6,8,11],
                 [10,1,2,7,3,11,4,9,5,6,12,8],
                 [11,1,2,7,10,3,4,9,5,6,12,8],
                 [1,12,2,7,10,3,4,9,5,6,11,8],
                 [1,12,2,7,3,11,4,9,5,6,10,8],
                 [1,11,2,7,12,3,4,9,5,6,10,8],
                 [1,11,2,7,3,9,4,5,6,8,12,10],
                 [11,1,2,7,3,9,4,10,5,6,12,8],
                 [1,12,2,7,3,9,4,10,5,6,11,8],
                 [10,12,1,9,2,7,3,4,5,11,6,8],
                 [10,12,1,9,2,7,3,11,4,5,6,8],
                 [1,9,2,7,11,3,10,4,5,6,12,8],
                 [1,9,2,7,3,12,10,4,5,6,11,8],
                 [10,12,9,1,2,7,3,4,5,8,6,11],
                 [11,9,10,1,2,7,3,4,5,8,12,6],
                 [9,12,10,1,2,7,3,4,5,8,11,6],
                 [9,12,1,11,2,7,3,4,5,8,10,6],
                 [1,11,2,7,3,4,5,8,9,6,12,10],
                 [11,1,2,7,3,10,4,8,5,6,12,9],
                 [1,12,2,7,3,10,4,8,5,6,11,9],
                 [1,10,2,7,3,12,4,8,5,6,9,11],
                 [1,10,2,7,3,11,4,8,5,6,12,9],
                 [1,11,2,7,3,9,4,8,5,6,12,10],
                 [10,12,1,9,2,7,3,11,4,8,5,6],
                 [9,12,1,11,2,7,3,8,10,4,5,6],
                 [9,11,12,1,2,7,3,8,10,4,5,6],
                 [1,11,2,7,3,8,9,4,5,6,12,10],
                 [1,11,2,7,3,8,4,5,9,6,12,10],
                 [1,8,2,7,3,12,4,5,6,9,10,11],
                 [1,8,2,7,3,4,5,11,6,9,12,10],
                 [1,8,2,7,3,11,4,5,6,9,12,10],
                 [1,8,2,7,3,12,4,11,5,10,6,9],
                 [1,8,2,7,3,11,12,4,5,10,6,9],
                 [1,8,2,7,11,3,4,10,12,5,6,9],
                 [1,8,2,7,11,3,4,10,5,6,12,9],
                 [1,8,2,7,3,12,4,10,11,5,6,9],
                 [1,8,2,7,3,12,4,10,5,6,11,9],
                 [1,8,2,7,3,10,4,5,6,9,11,12],
                 [1,8,2,7,3,10,4,12,5,11,6,9],
                 [1,8,2,7,3,10,4,11,12,5,6,9],
                 [10,12,1,8,2,7,3,4,5,9,6,11],
                 [1,8,2,7,10,3,4,12,5,9,6,11],
                 [1,8,2,7,10,3,4,11,5,9,12,6],
                 [1,8,2,7,11,3,10,4,5,9,12,6],
                 [1,8,2,7,3,11,12,4,5,9,10,6],
                 [1,8,2,7,3,11,4,9,5,6,12,10],
                 [1,8,2,7,3,10,4,9,5,6,11,12],
                 [1,8,2,7,3,10,4,9,5,12,6,11],
                 [1,8,2,7,3,10,4,9,5,11,12,6],
                 [1,8,2,7,3,9,10,4,5,6,11,12],
                 [1,8,2,7,3,9,10,4,5,12,6,11],
                 [1,8,2,7,3,9,10,4,5,11,12,6],
                 [1,8,2,7,3,9,11,4,10,5,12,6],
                 [8,11,1,7,2,3,4,5,6,9,12,10],
                 [8,12,1,7,2,11,3,4,5,10,6,9],
                 [8,11,1,7,12,2,3,4,5,10,6,9],
                 [11,8,1,7,2,3,4,10,12,5,6,9],
                 [11,8,1,7,2,3,4,10,5,6,12,9],
                 [8,12,1,7,2,3,4,10,11,5,6,9],
                 [8,12,1,7,2,3,4,10,5,6,11,9],
                 [8,12,1,7,2,11,3,10,4,5,6,9],
                 [8,11,1,7,12,2,3,10,4,5,6,9],
                 [11,8,1,7,2,10,12,3,4,5,6,9],
                 [11,8,1,7,2,10,3,4,12,5,6,9],
                 [8,12,1,7,2,10,11,3,4,5,6,9],
                 [8,12,1,7,2,10,3,4,11,5,6,9],
                 [8,10,1,7,2,12,3,4,5,11,6,9],
                 [8,10,1,7,2,12,3,11,4,5,6,9],
                 [8,10,1,7,2,11,12,3,4,5,6,9],
                 [8,10,1,7,2,11,3,4,12,5,6,9],
                 [10,8,1,7,2,12,3,4,5,9,6,11],
                 [10,8,1,7,2,11,3,4,5,9,12,6],
                 [11,8,1,7,10,2,3,4,5,9,12,6],
                 [8,12,1,7,10,2,3,4,5,9,11,6],
                 [11,8,1,7,2,3,10,4,5,9,12,6],
                 [8,12,1,7,2,3,10,4,5,9,11,6],
                 [8,12,1,7,2,11,3,4,5,9,10,6],
                 [8,11,1,7,12,2,3,4,5,9,10,6],
                 [8,11,1,7,2,3,4,9,5,6,12,10],
                 [8,12,1,7,2,11,3,10,4,9,5,6],
                 [8,11,1,7,12,2,3,10,4,9,5,6],
                 [11,8,1,7,2,10,12,3,4,9,5,6],
                 [8,12,1,7,2,10,11,3,4,9,5,6],
                 [8,10,1,7,2,12,3,11,4,9,5,6],
                 [8,10,1,7,2,11,12,3,4,9,5,6],
                 [8,11,1,7,12,2,3,9,10,4,5,6],
                 [8,11,1,7,2,9,12,3,4,10,5,6],
                 [8,9,1,7,2,3,10,4,5,6,11,12],
                 [8,9,1,7,2,3,10,4,5,12,6,11],
                 [8,9,1,7,2,3,10,4,5,11,12,6],
                 [1,7,8,2,3,12,4,5,6,9,10,11],
                 [1,7,8,2,3,4,5,11,6,9,12,10],
                 [1,7,8,2,3,11,4,5,6,9,12,10],
                 [1,7,8,2,3,12,4,11,5,10,6,9],
                 [1,7,8,2,3,11,12,4,5,10,6,9],
                 [1,7,8,2,11,3,4,10,12,5,6,9],
                 [1,7,8,2,3,12,4,10,11,5,6,9],
                 [1,7,8,2,3,12,4,10,5,6,11,9],
                 [1,7,8,2,3,10,4,5,6,9,11,12],
                 [1,7,8,2,3,10,4,12,5,11,6,9],
                 [1,7,8,2,3,10,4,11,12,5,6,9],
                 [10,12,1,7,8,2,3,4,5,9,6,11],
                 [1,7,8,2,10,3,4,12,5,9,6,11],
                 [1,7,8,2,10,3,4,11,5,9,12,6],
                 [1,7,8,2,11,3,10,4,5,9,12,6],
                 [1,7,8,2,3,11,12,4,5,9,10,6],
                 [1,7,8,2,3,11,4,9,5,6,12,10],
                 [1,7,8,2,3,10,4,9,5,6,11,12],
                 [1,7,8,2,3,10,4,9,5,12,6,11],
                 [1,7,8,2,3,10,4,9,5,11,12,6],
                 [1,7,8,2,3,9,10,4,5,12,6,11],
                 [1,7,8,2,3,9,10,4,5,11,12,6],
                 [9,11,1,7,12,2,8,3,10,4,5,6],
                 [1,7,9,2,8,3,10,4,5,12,6,11],
                 [1,7,2,12,8,3,9,4,5,6,10,11],
                 [1,7,2,12,8,3,9,4,5,11,6,10],
                 [1,7,2,11,8,3,9,4,12,5,6,10],
                 [1,7,2,11,8,3,9,4,5,6,12,10],
                 [1,7,11,2,8,3,9,4,5,10,12,6],
                 [1,7,2,12,8,3,9,4,5,10,11,6],
                 [1,7,2,10,8,3,9,4,5,6,11,12],
                 [1,7,2,10,8,3,9,4,5,12,6,11],
                 [1,7,2,10,8,3,9,4,5,11,12,6],
                 [1,7,10,2,8,3,4,12,9,5,6,11],
                 [1,7,10,2,8,3,4,11,9,5,12,6],
                 [1,7,11,2,8,3,10,4,9,5,12,6],
                 [1,7,2,12,8,3,10,4,9,5,11,6],
                 [1,7,2,12,8,3,4,11,9,5,10,6],
                 [1,7,2,11,8,3,12,4,9,5,10,6],
                 [1,7,2,12,8,3,4,5,9,6,10,11],
                 [1,7,2,11,8,3,4,5,9,6,12,10],
                 [1,7,2,12,8,3,4,11,5,10,9,6],
                 [1,7,2,11,8,3,12,4,5,10,9,6],
                 [1,7,11,2,8,3,4,10,12,5,9,6],
                 [1,7,2,12,8,3,4,10,11,5,9,6],
                 [1,7,2,10,8,3,4,5,9,6,11,12],
                 [1,7,2,10,8,3,4,12,5,11,9,6],
                 [1,7,2,10,8,3,4,11,12,5,9,6],
                 [1,7,2,3,8,4,5,6,9,11,12,10],
                 [1,7,2,3,8,4,5,11,6,9,12,10],
                 [1,7,2,12,3,11,8,4,5,6,9,10],
                 [1,7,2,11,12,3,8,4,5,6,9,10],
                 [1,7,2,12,3,11,8,4,5,10,6,9],
                 [1,7,2,11,12,3,8,4,5,10,6,9],
                 [1,7,11,2,3,10,8,4,12,5,6,9],
                 [1,7,11,2,3,10,8,4,5,6,12,9],
                 [1,7,2,12,3,10,8,4,11,5,6,9],
                 [1,7,2,12,3,10,8,4,5,6,11,9],
                 [1,7,2,10,3,12,8,4,5,6,9,11],
                 [1,7,2,10,3,12,8,4,5,11,6,9],
                 [1,7,2,10,3,11,8,4,12,5,6,9],
                 [1,7,2,10,3,11,8,4,5,6,12,9],
                 [10,12,1,7,2,3,8,4,5,9,6,11],
                 [1,7,10,2,3,11,8,4,5,9,12,6],
                 [1,7,11,2,10,3,8,4,5,9,12,6],
                 [1,7,2,12,10,3,8,4,5,9,11,6],
                 [1,7,2,12,3,11,8,4,5,9,10,6],
                 [1,7,2,11,12,3,8,4,5,9,10,6],
                 [1,7,2,12,3,9,8,4,5,6,10,11],
                 [1,7,2,12,3,9,8,4,5,11,6,10],
                 [1,7,2,11,3,9,8,4,12,5,6,10],
                 [1,7,2,11,3,9,8,4,5,6,12,10],
                 [1,7,11,2,3,9,8,4,5,10,12,6],
                 [1,7,2,12,3,9,8,4,5,10,11,6],
                 [1,7,2,10,3,9,8,4,5,6,11,12],
                 [1,7,2,10,3,9,8,4,5,12,6,11],
                 [1,7,2,10,3,9,8,4,5,11,12,6],
                 [10,12,1,7,2,9,3,11,8,4,5,6],
                 [10,9,1,7,2,12,3,4,8,5,6,11],
                 [10,9,1,7,2,11,3,4,8,5,12,6],
                 [11,9,1,7,10,2,3,4,8,5,12,6],
                 [9,12,1,7,10,2,3,4,8,5,11,6],
                 [9,12,1,7,2,11,3,4,8,5,10,6],
                 [9,11,1,7,12,2,3,4,8,5,10,6],
                 [10,12,1,7,9,2,3,4,8,5,6,11],
                 [1,7,2,12,9,3,4,11,8,5,6,10],
                 [1,7,2,11,9,3,12,4,8,5,6,10],
                 [1,7,11,2,9,3,4,10,8,5,12,6],
                 [1,7,2,12,9,3,4,10,8,5,11,6],
                 [10,12,1,7,2,3,9,4,8,5,6,11],
                 [1,7,11,2,10,3,9,4,8,5,12,6],
                 [1,7,2,12,10,3,9,4,8,5,11,6],
                 [1,7,2,12,3,11,9,4,8,5,10,6],
                 [1,7,2,11,12,3,9,4,8,5,10,6],
                 [1,7,2,12,3,4,8,5,9,6,10,11],
                 [1,7,2,3,4,11,8,5,9,6,12,10],
                 [1,7,2,11,3,4,8,5,9,6,12,10],
                 [1,7,2,12,3,11,4,10,8,5,9,6],
                 [1,7,2,11,12,3,4,10,8,5,9,6],
                 [1,7,2,12,3,10,11,4,8,5,9,6],
                 [1,7,2,3,4,5,8,6,9,11,12,10],
                 [1,7,2,12,3,4,5,11,8,6,9,10],
                 [1,7,2,12,3,11,4,5,8,6,9,10],
                 [1,7,11,2,3,4,5,10,8,6,12,9],
                 [1,7,2,12,3,4,5,10,8,6,11,9],
                 [1,7,11,2,3,10,4,5,8,6,12,9],
                 [1,7,2,12,3,10,4,5,8,6,11,9],
                 [1,7,2,10,3,4,5,12,8,6,9,11],
                 [1,7,2,10,3,12,4,5,8,6,9,11],
                 [1,7,2,10,3,4,5,11,8,6,12,9],
                 [1,7,2,10,3,11,4,5,8,6,12,9],
                 [1,7,2,3,4,11,5,9,8,6,12,10],
                 [1,7,2,11,3,4,5,9,8,6,12,10],
                 [1,7,2,12,3,11,4,10,5,9,8,6],
                 [1,7,2,12,3,10,11,4,5,9,8,6],
                 [10,12,1,7,2,3,4,9,5,11,8,6],
                 [1,7,2,12,10,3,4,9,11,5,8,6],
                 [1,7,2,12,3,9,4,5,8,6,10,11],
                 [1,7,2,11,3,9,4,5,8,6,12,10],
                 [1,7,2,12,3,9,4,11,5,10,8,6],
                 [1,7,2,12,3,9,4,10,11,5,8,6],
                 [10,12,1,7,2,9,3,4,5,11,8,6],
                 [10,12,1,7,2,9,3,11,4,5,8,6],
                 [8,7,1,2,3,11,4,6,5,9,12,10],
                 [8,7,1,11,2,3,4,6,5,9,12,10],
                 [8,11,7,1,2,3,4,6,5,9,12,10],
                 [8,7,11,1,2,3,4,6,5,10,12,9],
                 [8,7,1,2,11,3,4,6,5,10,12,9],
                 [8,7,1,2,3,12,4,6,5,10,11,9],
                 [8,7,1,2,3,10,4,6,5,12,9,11],
                 [8,7,1,2,3,10,4,6,5,11,12,9],
                 [8,12,7,1,2,11,3,10,4,6,5,9],
                 [8,12,7,11,1,2,3,10,4,6,5,9],
                 [8,11,12,7,1,2,3,10,4,6,5,9],
                 [8,11,7,1,12,2,3,10,4,6,5,9],
                 [11,8,7,1,2,10,12,3,4,6,5,9],
                 [8,12,7,1,2,10,11,3,4,6,5,9],
                 [8,7,1,10,2,3,4,6,5,12,9,11],
                 [8,7,1,10,2,3,4,6,5,11,12,9],
                 [8,12,7,11,1,10,2,3,4,6,5,9],
                 [8,11,12,7,1,10,2,3,4,6,5,9],
                 [11,8,7,10,1,2,12,3,4,6,5,9],
                 [8,12,7,10,11,1,2,3,4,6,5,9],
                 [8,12,7,10,1,2,11,3,4,6,5,9],
                 [8,10,7,1,2,12,3,11,4,6,5,9],
                 [8,10,7,12,1,2,3,11,4,6,5,9],
                 [8,10,7,1,2,11,12,3,4,6,5,9],
                 [8,10,7,12,1,11,2,3,4,6,5,9],
                 [8,10,7,11,1,2,12,3,4,6,5,9],
                 [10,8,7,1,2,12,3,9,4,6,5,11],
                 [10,12,8,7,1,2,3,9,4,6,5,11],
                 [10,8,7,1,2,11,3,9,4,6,12,5],
                 [11,8,7,1,10,2,3,9,4,6,12,5],
                 [8,12,7,1,10,2,3,9,4,6,11,5],
                 [8,12,7,1,2,11,3,9,4,6,10,5],
                 [8,11,7,1,12,2,3,9,4,6,10,5],
                 [8,12,7,1,2,9,3,11,4,6,5,10],
                 [8,11,7,1,2,9,12,3,4,6,5,10],
                 [11,8,7,1,2,9,3,10,4,6,12,5],
                 [8,12,7,1,2,9,3,10,4,6,11,5],
                 [8,10,7,1,2,9,3,12,4,6,5,11],
                 [8,10,7,1,2,9,3,11,4,6,12,5],
                 [10,12,8,7,1,9,2,3,4,6,5,11],
                 [8,12,7,9,1,2,3,11,4,6,5,10],
                 [8,12,7,9,1,11,2,3,4,6,5,10],
                 [8,11,7,9,1,2,12,3,4,6,5,10],
                 [11,8,7,9,1,2,3,10,4,6,12,5],
                 [8,12,7,9,1,2,3,10,4,6,11,5],
                 [11,8,7,9,1,10,2,3,4,6,12,5],
                 [8,12,7,9,1,10,2,3,4,6,11,5],
                 [8,10,7,9,1,2,3,12,4,6,5,11],
                 [8,10,7,9,1,2,3,11,4,6,12,5],
                 [8,10,7,9,1,11,2,3,4,6,12,5],
                 [10,12,8,9,7,1,2,3,4,6,5,11],
                 [8,9,10,7,1,2,3,12,4,6,5,11],
                 [8,9,10,7,1,2,3,11,4,6,12,5],
                 [8,9,10,7,1,11,2,3,4,6,12,5],
                 [8,9,11,7,10,1,2,3,4,6,12,5],
                 [8,9,7,12,10,1,2,3,4,6,11,5],
                 [8,9,11,7,1,2,10,3,4,6,12,5],
                 [8,9,7,12,1,2,10,3,4,6,11,5],
                 [8,9,7,12,1,2,3,11,4,6,10,5],
                 [8,9,7,12,1,11,2,3,4,6,10,5],
                 [8,9,7,11,1,2,12,3,4,6,10,5],
                 [10,12,9,7,8,1,2,3,4,6,5,11],
                 [9,7,8,1,10,2,3,12,4,6,5,11],
                 [9,7,8,1,10,2,3,11,4,6,12,5],
                 [9,7,8,1,11,2,10,3,4,6,12,5],
                 [9,7,8,1,2,12,10,3,4,6,11,5],
                 [9,7,8,1,2,12,3,11,4,6,10,5],
                 [9,7,8,1,2,11,12,3,4,6,10,5],
                 [7,12,8,1,9,2,3,11,4,6,5,10],
                 [7,11,8,1,9,2,12,3,4,6,5,10],
                 [11,7,8,1,9,2,3,10,4,6,12,5],
                 [7,12,8,1,9,2,3,10,4,6,11,5],
                 [7,10,8,1,9,2,3,12,4,6,5,11],
                 [7,10,8,1,9,2,3,11,4,6,12,5],
                 [10,7,8,1,2,12,9,3,4,6,5,11],
                 [10,7,8,1,2,11,9,3,4,6,12,5],
                 [11,7,8,1,10,2,9,3,4,6,12,5],
                 [7,12,8,1,10,2,9,3,4,6,11,5],
                 [7,12,8,1,2,11,9,3,4,6,10,5],
                 [7,11,8,1,12,2,9,3,4,6,10,5],
                 [7,11,8,1,2,3,4,6,9,5,12,10],
                 [7,12,8,1,2,11,3,10,4,6,9,5],
                 [7,11,8,1,12,2,3,10,4,6,9,5],
                 [11,7,8,1,2,10,12,3,4,6,9,5],
                 [7,12,8,1,2,10,11,3,4,6,9,5],
                 [7,10,8,1,2,12,3,11,4,6,9,5],
                 [7,10,8,1,2,11,12,3,4,6,9,5],
                 [7,1,8,2,3,11,4,6,5,9,12,10],
                 [7,1,8,2,11,3,4,6,5,10,12,9],
                 [7,1,8,2,3,12,4,6,5,10,11,9],
                 [7,1,8,2,3,10,4,6,5,12,9,11],
                 [7,1,8,2,3,10,4,6,5,11,12,9],
                 [7,12,1,11,8,2,3,10,4,6,5,9],
                 [7,11,12,1,8,2,3,10,4,6,5,9],
                 [11,7,1,10,8,2,12,3,4,6,5,9],
                 [7,12,1,10,8,2,11,3,4,6,5,9],
                 [7,10,1,12,8,2,3,11,4,6,5,9],
                 [7,10,1,11,8,2,12,3,4,6,5,9],
                 [10,12,7,1,8,2,3,9,4,6,5,11],
                 [10,7,1,11,8,2,3,9,4,6,12,5],
                 [11,7,10,1,8,2,3,9,4,6,12,5],
                 [7,12,10,1,8,2,3,9,4,6,11,5],
                 [7,12,1,11,8,2,3,9,4,6,10,5],
                 [7,12,1,9,8,2,3,11,4,6,5,10],
                 [7,11,1,9,8,2,12,3,4,6,5,10],
                 [11,7,1,9,8,2,3,10,4,6,12,5],
                 [7,12,1,9,8,2,3,10,4,6,11,5],
                 [7,10,1,9,8,2,3,12,4,6,5,11],
                 [7,10,1,9,8,2,3,11,4,6,12,5],
                 [7,9,10,1,8,2,3,12,4,6,5,11],
                 [7,9,10,1,8,2,3,11,4,6,12,5],
                 [7,9,11,1,8,2,10,3,4,6,12,5],
                 [7,9,1,12,8,2,10,3,4,6,11,5],
                 [7,9,1,12,8,2,3,11,4,6,10,5],
                 [7,9,1,11,8,2,12,3,4,6,10,5],
                 [10,12,9,7,1,2,8,3,4,6,5,11],
                 [9,7,10,1,2,12,8,3,4,6,5,11],
                 [9,7,10,1,2,11,8,3,4,6,12,5],
                 [11,9,7,1,10,2,8,3,4,6,12,5],
                 [9,7,11,1,10,2,8,3,4,6,12,5],
                 [9,7,1,12,10,2,8,3,4,6,11,5],
                 [9,12,7,1,10,2,8,3,4,6,11,5],
                 [9,7,1,12,2,11,8,3,4,6,10,5],
                 [9,12,7,1,2,11,8,3,4,6,10,5],
                 [9,7,1,11,12,2,8,3,4,6,10,5],
                 [9,11,7,1,12,2,8,3,4,6,10,5],
                 [7,12,9,1,2,11,8,3,4,6,5,10],
                 [7,11,9,1,12,2,8,3,4,6,5,10],
                 [11,7,9,1,2,10,8,3,4,6,12,5],
                 [7,12,9,1,2,10,8,3,4,6,11,5],
                 [7,10,9,1,2,12,8,3,4,6,5,11],
                 [7,10,9,1,2,11,8,3,4,6,12,5],
                 [10,12,7,1,9,2,8,3,4,6,5,11],
                 [10,7,1,11,9,2,8,3,4,6,12,5],
                 [11,7,10,1,9,2,8,3,4,6,12,5],
                 [7,12,10,1,9,2,8,3,4,6,11,5],
                 [7,12,1,11,9,2,8,3,4,6,10,5],
                 [7,1,2,11,8,3,4,6,9,5,12,10],
                 [7,11,1,2,8,3,4,6,9,5,12,10],
                 [7,12,1,11,2,10,8,3,4,6,9,5],
                 [7,11,12,1,2,10,8,3,4,6,9,5],
                 [11,7,1,10,12,2,8,3,4,6,9,5],
                 [7,12,1,10,11,2,8,3,4,6,9,5],
                 [7,10,1,12,2,11,8,3,4,6,9,5],
                 [7,10,1,11,12,2,8,3,4,6,9,5],
                 [7,1,2,3,4,6,8,5,9,11,12,10],
                 [7,12,1,2,3,11,4,6,8,5,9,10],
                 [7,12,1,11,2,3,4,6,8,5,9,10],
                 [7,11,1,2,12,3,4,6,8,5,9,10],
                 [11,7,1,2,3,10,4,6,8,5,12,9],
                 [7,1,11,2,3,10,4,6,8,5,12,9],
                 [7,1,2,12,3,10,4,6,8,5,11,9],
                 [7,12,1,2,3,10,4,6,8,5,11,9],
                 [7,1,2,10,3,12,4,6,8,5,9,11],
                 [7,1,2,10,3,11,4,6,8,5,12,9],
                 [11,7,1,10,2,3,4,6,8,5,12,9],
                 [7,12,1,10,2,3,4,6,8,5,11,9],
                 [7,10,1,2,3,12,4,6,8,5,9,11],
                 [7,10,1,2,3,11,4,6,8,5,12,9],
                 [7,10,1,11,2,3,4,6,8,5,12,9],
                 [7,1,2,11,3,9,4,6,8,5,12,10],
                 [7,11,1,2,3,9,4,6,8,5,12,10],
                 [7,12,1,11,2,10,3,9,4,6,8,5],
                 [7,11,12,1,2,10,3,9,4,6,8,5],
                 [11,7,1,10,12,2,3,9,4,6,8,5],
                 [7,12,1,10,11,2,3,9,4,6,8,5],
                 [7,10,1,12,2,11,3,9,4,6,8,5],
                 [7,10,1,11,12,2,3,9,4,6,8,5],
                 [10,7,1,12,2,9,3,11,4,6,8,5],
                 [10,7,1,11,2,9,12,3,4,6,8,5],
                 [11,7,10,1,2,9,12,3,4,6,8,5],
                 [7,12,10,1,2,9,11,3,4,6,8,5],
                 [7,12,1,11,2,9,10,3,4,6,8,5],
                 [7,11,12,1,2,9,10,3,4,6,8,5],
                 [7,11,1,9,2,3,4,6,8,5,12,10],
                 [7,12,1,9,2,11,3,10,4,6,8,5],
                 [7,11,1,9,12,2,3,10,4,6,8,5],
                 [11,7,1,9,2,10,12,3,4,6,8,5],
                 [7,12,1,9,2,10,11,3,4,6,8,5],
                 [7,10,1,9,2,12,3,11,4,6,8,5],
                 [7,10,1,9,2,11,12,3,4,6,8,5],
                 [10,12,7,9,1,2,3,11,4,6,8,5],
                 [10,12,7,9,1,11,2,3,4,6,8,5],
                 [10,11,7,9,1,2,12,3,4,6,8,5],
                 [7,9,10,1,2,3,4,6,8,5,11,12],
                 [7,9,10,1,2,12,3,11,4,6,8,5],
                 [7,9,10,1,2,11,12,3,4,6,8,5],
                 [7,9,11,1,10,2,12,3,4,6,8,5],
                 [7,9,1,12,10,2,11,3,4,6,8,5],
                 [7,9,1,2,10,3,4,6,8,5,11,12],
                 [7,9,1,12,2,11,10,3,4,6,8,5],
                 [7,9,1,11,12,2,10,3,4,6,8,5],
                 [11,1,7,2,3,10,4,6,5,8,12,9],
                 [1,12,7,2,3,10,4,6,5,8,11,9],
                 [1,10,7,2,3,12,4,6,5,8,9,11],
                 [1,10,7,2,3,11,4,6,5,8,12,9],
                 [10,1,7,2,3,12,4,6,5,9,8,11],
                 [10,1,7,2,3,11,4,6,5,9,12,8],
                 [11,1,7,2,10,3,4,6,5,9,12,8],
                 [1,12,7,2,10,3,4,6,5,9,11,8],
                 [1,12,7,2,3,11,4,6,5,9,10,8],
                 [1,11,7,2,12,3,4,6,5,9,10,8],
                 [1,11,7,2,3,9,4,6,12,5,8,10],
                 [1,11,7,2,3,9,4,6,5,8,12,10],
                 [11,1,7,2,3,9,4,6,5,10,12,8],
                 [1,10,7,2,3,9,4,6,5,12,8,11],
                 [1,10,7,2,3,9,4,6,5,11,12,8],
                 [10,12,1,9,7,2,3,11,4,6,5,8],
                 [1,9,7,2,10,3,4,6,5,12,8,11],
                 [1,9,7,2,10,3,4,6,5,11,12,8],
                 [1,9,7,2,11,3,4,6,10,5,12,8],
                 [1,9,7,2,3,12,4,6,10,5,11,8],
                 [1,9,7,2,3,12,4,6,5,11,10,8],
                 [1,9,7,2,3,11,4,6,12,5,10,8],
                 [10,12,9,1,7,2,3,8,4,6,5,11],
                 [11,9,10,1,7,2,3,8,4,6,12,5],
                 [9,12,10,1,7,2,3,8,4,6,11,5],
                 [9,12,1,11,7,2,3,8,4,6,10,5],
                 [1,11,7,2,3,8,4,6,9,5,12,10],
                 [1,8,7,2,3,11,4,6,5,9,12,10],
                 [1,8,7,2,11,3,4,6,5,10,12,9],
                 [1,8,7,2,3,12,4,6,5,10,11,9],
                 [1,8,7,2,3,10,4,6,5,12,9,11],
                 [1,8,7,2,3,10,4,6,5,11,12,9],
                 [10,12,1,8,7,2,3,9,4,6,5,11],
                 [8,11,1,2,7,3,4,6,5,9,12,10],
                 [8,1,11,2,7,3,4,6,5,10,12,9],
                 [8,1,2,12,7,3,4,6,5,10,11,9],
                 [8,1,2,10,7,3,4,6,5,12,9,11],
                 [8,1,2,10,7,3,4,6,5,11,12,9],
                 [8,12,1,11,2,10,7,3,4,6,5,9],
                 [8,11,12,1,2,10,7,3,4,6,5,9],
                 [11,8,1,10,12,2,7,3,4,6,5,9],
                 [8,12,1,10,11,2,7,3,4,6,5,9],
                 [8,10,1,12,2,11,7,3,4,6,5,9],
                 [8,10,1,11,12,2,7,3,4,6,5,9],
                 [10,8,1,11,2,9,7,3,4,6,12,5],
                 [11,8,10,1,2,9,7,3,4,6,12,5],
                 [8,12,10,1,2,9,7,3,4,6,11,5],
                 [8,12,1,11,2,9,7,3,4,6,10,5],
                 [8,12,1,9,2,11,7,3,4,6,5,10],
                 [8,11,1,9,12,2,7,3,4,6,5,10],
                 [11,8,1,9,2,10,7,3,4,6,12,5],
                 [8,12,1,9,2,10,7,3,4,6,11,5],
                 [8,10,1,9,2,12,7,3,4,6,5,11],
                 [8,10,1,9,2,11,7,3,4,6,12,5],
                 [10,12,9,1,8,2,7,3,4,6,5,11],
                 [11,9,10,1,8,2,7,3,4,6,12,5],
                 [9,12,10,1,8,2,7,3,4,6,11,5],
                 [9,12,1,11,8,2,7,3,4,6,10,5],
                 [1,11,8,2,7,3,4,6,9,5,12,10],
                 [1,2,7,3,4,6,8,5,9,11,12,10],
                 [11,1,2,10,7,3,4,6,8,5,12,9],
                 [1,12,2,10,7,3,4,6,8,5,11,9],
                 [1,10,2,12,7,3,4,6,8,5,9,11],
                 [1,10,2,11,7,3,4,6,8,5,12,9],
                 [1,11,2,9,7,3,4,6,8,5,12,10],
                 [10,12,1,9,2,11,7,3,4,6,8,5],
                 [1,2,3,12,4,6,7,5,8,11,9,10],
                 [1,2,3,11,4,6,7,5,12,8,9,10],
                 [1,11,2,3,4,6,7,5,12,8,9,10],
                 [1,11,2,3,4,6,7,5,8,9,12,10],
                 [11,1,2,3,4,6,7,5,8,10,12,9],
                 [1,2,11,3,4,6,7,5,8,10,12,9],
                 [1,2,3,12,4,6,7,5,8,10,11,9],
                 [1,2,3,10,4,6,7,5,8,12,9,11],
                 [1,2,3,10,4,6,7,5,8,11,12,9],
                 [1,10,2,3,4,6,7,5,8,12,9,11],
                 [1,10,2,3,4,6,7,5,8,11,12,9],
                 [10,1,2,12,3,9,4,6,7,5,8,11],
                 [10,12,1,2,3,9,4,6,7,5,8,11],
                 [10,1,2,11,3,9,4,6,7,5,12,8],
                 [11,1,10,2,3,9,4,6,7,5,12,8],
                 [1,12,10,2,3,9,4,6,7,5,11,8],
                 [1,12,2,11,3,9,4,6,7,5,10,8],
                 [1,11,12,2,3,9,4,6,7,5,10,8],
                 [1,12,2,9,3,11,4,6,7,5,8,10],
                 [1,11,2,9,12,3,4,6,7,5,8,10],
                 [11,1,2,9,3,10,4,6,7,5,12,8],
                 [1,12,2,9,3,10,4,6,7,5,11,8],
                 [1,10,2,9,3,12,4,6,7,5,8,11],
                 [1,10,2,9,3,11,4,6,7,5,12,8],
                 [10,12,1,9,2,3,4,6,7,5,8,11],
                 [1,9,10,2,3,12,4,6,7,5,8,11],
                 [1,9,10,2,3,11,4,6,7,5,12,8],
                 [1,9,11,2,10,3,4,6,7,5,12,8],
                 [1,9,2,12,10,3,4,6,7,5,11,8],
                 [1,9,2,12,3,11,4,6,7,5,10,8],
                 [1,9,2,11,12,3,4,6,7,5,10,8],
                 [1,2,3,8,4,6,7,5,9,11,12,10],
                 [11,1,2,10,3,8,4,6,7,5,12,9],
                 [1,12,2,10,3,8,4,6,7,5,11,9],
                 [1,10,2,12,3,8,4,6,7,5,9,11],
                 [1,10,2,11,3,8,4,6,7,5,12,9],
                 [1,11,2,9,3,8,4,6,7,5,12,10],
                 [11,9,10,1,2,8,12,3,4,6,7,5],
                 [9,12,10,1,2,8,11,3,4,6,7,5],
                 [9,12,1,11,2,8,10,3,4,6,7,5],
                 [9,11,12,1,2,8,10,3,4,6,7,5],
                 [1,11,2,8,9,3,4,6,7,5,12,10],
                 [1,8,2,3,4,6,7,5,9,11,12,10],
                 [1,8,11,2,3,10,4,6,7,5,12,9],
                 [1,8,2,12,3,10,4,6,7,5,11,9],
                 [1,8,2,10,3,12,4,6,7,5,9,11],
                 [1,8,2,10,3,11,4,6,7,5,12,9],
                 [10,1,2,12,3,6,4,9,5,7,8,11],
                 [10,12,1,2,3,6,4,9,5,7,8,11],
                 [10,1,2,11,3,6,4,9,5,7,12,8],
                 [11,1,10,2,3,6,4,9,5,7,12,8],
                 [1,12,10,2,3,6,4,9,5,7,11,8],
                 [1,12,2,11,3,6,4,9,5,7,10,8],
                 [1,11,12,2,3,6,4,9,5,7,10,8],
                 [1,11,2,9,3,6,12,4,5,7,8,10],
                 [11,1,2,9,3,6,4,10,5,7,12,8],
                 [1,10,2,9,3,6,4,12,5,7,8,11],
                 [1,10,2,9,3,6,4,11,5,7,12,8],
                 [1,9,10,2,3,6,4,12,5,7,8,11],
                 [1,9,10,2,3,6,4,11,5,7,12,8],
                 [1,9,11,2,3,6,10,4,5,7,12,8],
                 [1,9,2,12,3,6,10,4,5,7,11,8],
                 [1,9,2,12,3,6,4,11,5,7,10,8],
                 [1,9,2,11,3,6,12,4,5,7,10,8],
                 [9,1,10,2,3,6,4,12,5,8,7,11],
                 [9,1,10,2,3,6,4,11,5,8,12,7],
                 [9,1,11,2,3,6,10,4,5,8,12,7],
                 [9,1,2,12,3,6,10,4,5,8,11,7],
                 [9,1,2,12,3,6,4,11,5,8,10,7],
                 [9,1,2,11,3,6,12,4,5,8,10,7],
                 [1,11,9,2,3,6,12,4,5,8,7,10],
                 [11,1,9,2,3,6,4,10,5,8,12,7],
                 [1,10,9,2,3,6,4,12,5,8,7,11],
                 [1,10,9,2,3,6,4,11,5,8,12,7],
                 [10,1,2,12,3,6,9,4,5,8,7,11],
                 [10,12,1,2,3,6,9,4,5,8,7,11],
                 [10,1,2,11,3,6,9,4,5,8,12,7],
                 [11,1,10,2,3,6,9,4,5,8,12,7],
                 [1,12,10,2,3,6,9,4,5,8,11,7],
                 [1,12,2,11,3,6,9,4,5,8,10,7],
                 [1,11,12,2,3,6,9,4,5,8,10,7],
                 [1,2,3,6,4,11,5,8,9,7,12,10],
                 [1,12,2,11,3,6,4,10,5,8,9,7],
                 [1,11,12,2,3,6,4,10,5,8,9,7],
                 [11,1,2,10,3,6,12,4,5,8,9,7],
                 [1,12,2,10,3,6,11,4,5,8,9,7],
                 [1,10,2,12,3,6,4,11,5,8,9,7],
                 [1,10,2,11,3,6,12,4,5,8,9,7],
                 [1,2,3,6,4,8,5,7,9,11,12,10],
                 [1,2,3,6,4,8,5,11,7,9,12,10],
                 [1,12,2,11,3,6,4,8,5,10,7,9],
                 [1,11,12,2,3,6,4,8,5,10,7,9],
                 [11,1,2,10,3,6,4,8,12,5,7,9],
                 [11,1,2,10,3,6,4,8,5,7,12,9],
                 [1,12,2,10,3,6,4,8,11,5,7,9],
                 [1,12,2,10,3,6,4,8,5,7,11,9],
                 [1,10,2,12,3,6,4,8,5,7,9,11],
                 [1,10,2,12,3,6,4,8,5,11,7,9],
                 [1,10,2,11,3,6,4,8,12,5,7,9],
                 [1,10,2,11,3,6,4,8,5,7,12,9],
                 [10,1,2,12,3,6,4,8,5,9,7,11],
                 [10,12,1,2,3,6,4,8,5,9,7,11],
                 [10,1,2,11,3,6,4,8,5,9,12,7],
                 [11,1,10,2,3,6,4,8,5,9,12,7],
                 [1,12,10,2,3,6,4,8,5,9,11,7],
                 [1,12,2,11,3,6,4,8,5,9,10,7],
                 [1,11,12,2,3,6,4,8,5,9,10,7],
                 [1,11,2,9,3,6,4,8,12,5,7,10],
                 [11,1,2,9,3,6,4,8,5,10,12,7],
                 [1,10,2,9,3,6,4,8,5,12,7,11],
                 [1,10,2,9,3,6,4,8,5,11,12,7],
                 [1,9,10,2,3,6,4,8,5,12,7,11],
                 [1,9,10,2,3,6,4,8,5,11,12,7],
                 [1,9,11,2,3,6,4,8,10,5,12,7],
                 [1,9,2,12,3,6,4,8,10,5,11,7],
                 [1,9,2,12,3,6,4,8,5,11,10,7],
                 [1,9,2,11,3,6,4,8,12,5,10,7],
                 [11,9,10,1,2,8,3,6,12,4,5,7],
                 [9,12,10,1,2,8,3,6,11,4,5,7],
                 [9,12,1,11,2,8,3,6,10,4,5,7],
                 [1,11,2,8,3,6,9,4,12,5,7,10],
                 [11,1,2,8,3,6,9,4,5,10,12,7],
                 [1,10,2,8,3,6,9,4,5,12,7,11],
                 [1,10,2,8,3,6,9,4,5,11,12,7],
                 [10,1,2,8,3,6,4,12,9,5,7,11],
                 [10,1,2,8,3,6,4,11,9,5,12,7],
                 [11,1,2,8,3,6,10,4,9,5,12,7],
                 [1,11,2,8,3,6,12,4,9,5,10,7],
                 [1,8,11,2,3,6,4,10,5,7,12,9],
                 [1,8,2,12,3,6,4,10,5,7,11,9],
                 [1,8,2,10,3,6,4,12,5,7,9,11],
                 [1,8,2,10,3,6,4,11,5,7,12,9],
                 [1,8,10,2,3,6,4,12,5,9,7,11],
                 [1,8,10,2,3,6,4,11,5,9,12,7],
                 [1,8,11,2,3,6,10,4,5,9,12,7],
                 [1,8,2,12,3,6,10,4,5,9,11,7],
                 [1,8,2,12,3,6,4,11,5,9,10,7],
                 [1,8,2,11,3,6,12,4,5,9,10,7],
                 [1,8,2,12,3,6,4,9,5,11,7,10],
                 [1,8,2,11,3,6,4,9,12,5,7,10],
                 [1,8,11,2,3,6,4,9,5,10,12,7],
                 [1,8,2,12,3,6,4,9,5,10,11,7],
                 [1,8,2,10,3,6,4,9,5,12,7,11],
                 [1,8,2,10,3,6,4,9,5,11,12,7],
                 [8,11,1,2,3,6,4,7,5,9,12,10],
                 [8,1,11,2,3,6,4,7,5,10,12,9],
                 [8,1,2,12,3,6,4,7,5,10,11,9],
                 [8,1,2,10,3,6,4,7,5,12,9,11],
                 [8,1,2,10,3,6,4,7,5,11,12,9],
                 [8,12,1,11,2,10,3,6,4,7,5,9],
                 [8,11,12,1,2,10,3,6,4,7,5,9],
                 [11,8,1,10,12,2,3,6,4,7,5,9],
                 [8,12,1,10,11,2,3,6,4,7,5,9],
                 [8,10,1,12,2,11,3,6,4,7,5,9],
                 [8,10,1,11,12,2,3,6,4,7,5,9],
                 [10,8,1,11,2,9,3,6,4,7,12,5],
                 [11,8,10,1,2,9,3,6,4,7,12,5],
                 [8,12,10,1,2,9,3,6,4,7,11,5],
                 [8,12,1,11,2,9,3,6,4,7,10,5],
                 [8,12,1,9,2,11,3,6,4,7,5,10],
                 [8,11,1,9,12,2,3,6,4,7,5,10],
                 [11,8,1,9,2,10,3,6,4,7,12,5],
                 [8,12,1,9,2,10,3,6,4,7,11,5],
                 [8,10,1,9,2,12,3,6,4,7,5,11],
                 [8,10,1,9,2,11,3,6,4,7,12,5],
                 [11,9,10,1,8,2,3,6,4,7,12,5],
                 [9,12,10,1,8,2,3,6,4,7,11,5],
                 [1,2,3,6,4,7,8,5,9,11,12,10],
                 [1,12,2,10,3,6,4,7,8,5,11,9],
                 [1,10,2,12,3,6,4,7,8,5,9,11],
                 [1,10,2,11,3,6,4,7,8,5,12,9],
                 [1,10,2,7,3,6,4,12,5,8,9,11],
                 [10,1,2,7,3,6,4,12,5,9,8,11],
                 [10,1,2,7,3,6,4,11,5,9,12,8],
                 [11,1,2,7,3,6,10,4,5,9,12,8],
                 [1,11,2,7,3,6,12,4,5,9,10,8],
                 [1,11,2,7,3,6,4,9,12,5,8,10],
                 [11,1,2,7,3,6,4,9,5,10,12,8],
                 [1,10,2,7,3,6,4,9,5,12,8,11],
                 [1,10,2,7,3,6,4,9,5,11,12,8],
                 [11,9,10,1,2,7,3,6,4,8,12,5],
                 [8,12,1,7,2,11,3,6,4,10,5,9],
                 [8,11,1,7,12,2,3,6,4,10,5,9],
                 [11,8,1,7,2,10,3,6,12,4,5,9],
                 [8,12,1,7,2,10,3,6,11,4,5,9],
                 [8,10,1,7,2,12,3,6,4,11,5,9],
                 [8,10,1,7,2,11,3,6,12,4,5,9],
                 [10,8,1,7,2,12,3,6,4,9,5,11],
                 [10,8,1,7,2,11,3,6,4,9,12,5],
                 [11,8,1,7,10,2,3,6,4,9,12,5],
                 [8,12,1,7,10,2,3,6,4,9,11,5],
                 [8,12,1,7,2,11,3,6,4,9,10,5],
                 [8,11,1,7,12,2,3,6,4,9,10,5],
                 [11,9,1,7,10,2,3,6,8,4,12,5],
                 [9,12,1,7,10,2,3,6,8,4,11,5],
                 [9,12,1,7,2,11,3,6,8,4,10,5],
                 [9,11,1,7,12,2,3,6,8,4,10,5],
                 [1,7,11,2,3,6,4,10,8,5,12,9],
                 [1,7,2,12,3,6,4,10,8,5,11,9],
                 [1,7,2,10,3,6,4,12,8,5,9,11],
                 [8,11,7,1,2,6,3,4,5,9,12,10],
                 [8,12,7,1,2,6,3,11,4,10,5,9],
                 [11,8,7,1,2,6,3,10,12,4,5,9],
                 [8,12,7,1,2,6,3,10,11,4,5,9],
                 [8,12,7,11,1,10,2,6,3,4,5,9],
                 [8,11,12,7,1,10,2,6,3,4,5,9],
                 [8,12,7,10,11,1,2,6,3,4,5,9],
                 [8,10,7,1,2,6,3,11,12,4,5,9],
                 [8,10,7,12,1,11,2,6,3,4,5,9],
                 [10,8,7,1,2,6,3,11,4,9,12,5],
                 [11,8,7,1,2,6,10,3,4,9,12,5],
                 [8,12,7,1,2,6,10,3,4,9,11,5],
                 [10,7,8,1,2,6,3,11,9,4,12,5],
                 [11,7,8,1,2,6,10,3,9,4,12,5],
                 [7,12,8,1,2,6,10,3,9,4,11,5],
                 [7,12,8,1,2,6,3,11,9,4,10,5],
                 [7,11,8,1,2,6,3,4,9,5,12,10],
                 [11,7,8,1,2,6,3,10,12,4,9,5],
                 [7,10,8,1,2,6,3,11,12,4,9,5],
                 [11,7,1,10,2,6,8,3,12,4,5,9],
                 [7,10,1,11,2,6,8,3,12,4,5,9],
                 [10,7,1,11,2,6,8,3,4,9,12,5],
                 [11,7,10,1,2,6,8,3,4,9,12,5],
                 [7,12,10,1,2,6,8,3,4,9,11,5],
                 [7,12,1,11,2,6,8,3,4,9,10,5],
                 [9,7,10,1,2,6,3,12,8,4,5,11],
                 [9,7,10,1,2,6,3,11,8,4,12,5],
                 [11,9,7,1,2,6,10,3,8,4,12,5],
                 [9,7,11,1,2,6,10,3,8,4,12,5],
                 [9,7,1,12,2,6,10,3,8,4,11,5],
                 [9,7,1,11,2,6,12,3,8,4,10,5],
                 [11,7,9,1,2,6,3,10,8,4,12,5],
                 [7,12,9,1,2,6,3,10,8,4,11,5],
                 [10,7,1,11,2,6,9,3,8,4,12,5],
                 [11,7,10,1,2,6,9,3,8,4,12,5],
                 [7,12,10,1,2,6,9,3,8,4,11,5],
                 [7,12,1,11,2,6,9,3,8,4,10,5],
                 [7,12,1,11,2,6,3,10,8,4,9,5],
                 [7,11,12,1,2,6,3,10,8,4,9,5],
                 [11,7,1,10,2,6,12,3,8,4,9,5],
                 [7,12,1,10,2,6,11,3,8,4,9,5],
                 [7,10,1,11,2,6,12,3,8,4,9,5],
                 [7,1,2,6,3,4,8,5,9,11,12,10],
                 [7,12,1,11,2,6,3,4,8,5,9,10],
                 [7,1,2,6,3,10,4,12,8,5,9,11],
                 [11,7,1,10,2,6,3,4,8,5,12,9],
                 [7,12,1,10,2,6,3,4,8,5,11,9],
                 [7,10,1,11,2,6,3,4,8,5,12,9],
                 [7,12,1,11,2,6,3,10,4,9,8,5],
                 [7,11,12,1,2,6,3,10,4,9,8,5],
                 [11,7,1,10,2,6,12,3,4,9,8,5],
                 [7,12,1,10,2,6,11,3,4,9,8,5],
                 [7,10,1,11,2,6,12,3,4,9,8,5],
                 [10,7,1,11,2,6,3,9,12,4,8,5],
                 [11,7,10,1,2,6,3,9,12,4,8,5],
                 [7,12,10,1,2,6,3,9,11,4,8,5],
                 [7,12,1,11,2,6,3,9,10,4,8,5],
                 [7,11,1,9,2,6,3,4,8,5,12,10],
                 [11,7,1,9,2,6,3,10,12,4,8,5],
                 [7,12,1,9,2,6,3,10,11,4,8,5],
                 [7,10,1,9,2,6,3,11,12,4,8,5],
                 [10,12,7,9,1,11,2,6,3,4,8,5],
                 [7,9,10,1,2,6,3,4,8,5,11,12],
                 [7,9,10,1,2,6,3,12,4,11,8,5],
                 [7,9,10,1,2,6,3,11,12,4,8,5],
                 [7,9,11,1,2,6,10,3,12,4,8,5],
                 [7,9,1,12,2,6,10,3,11,4,8,5],
                 [7,9,1,11,2,6,12,3,10,4,8,5],
                 [1,10,2,6,7,3,4,12,5,8,9,11],
                 [1,11,2,6,7,3,12,4,5,9,10,8],
                 [1,11,2,6,7,3,4,9,12,5,8,10],
                 [11,1,2,6,7,3,4,9,5,10,12,8],
                 [1,10,2,6,7,3,4,9,5,12,8,11],
                 [1,10,2,6,7,3,4,9,5,11,12,8],
                 [11,9,10,1,2,6,7,3,4,8,12,5],
                 [8,1,2,6,3,10,7,4,5,12,9,11],
                 [8,12,1,11,2,6,3,10,7,4,5,9],
                 [8,11,12,1,2,6,3,10,7,4,5,9],
                 [11,8,1,10,2,6,12,3,7,4,5,9],
                 [8,12,1,10,2,6,11,3,7,4,5,9],
                 [8,10,1,11,2,6,12,3,7,4,5,9],
                 [10,8,1,11,2,6,3,9,7,4,12,5],
                 [11,8,10,1,2,6,3,9,7,4,12,5],
                 [8,12,10,1,2,6,3,9,7,4,11,5],
                 [8,12,1,11,2,6,3,9,7,4,10,5],
                 [11,8,1,9,2,6,3,10,7,4,12,5],
                 [11,9,10,1,2,6,8,3,7,4,12,5],
                 [1,12,2,6,3,10,7,4,8,5,11,9],
                 [1,10,2,6,3,12,7,4,8,5,9,11],
                 [1,11,2,6,3,4,7,5,12,8,9,10],
                 [11,1,2,6,3,4,7,5,8,10,12,9],
                 [1,10,2,6,3,4,7,5,8,12,9,11],
                 [1,10,2,6,3,4,7,5,8,11,12,9],
                 [10,1,2,6,3,12,4,9,7,5,8,11],
                 [11,1,2,6,10,3,4,9,7,5,12,8],
                 [1,12,2,6,10,3,4,9,7,5,11,8],
                 [1,11,2,6,12,3,4,9,7,5,10,8],
                 [1,11,2,6,3,9,12,4,7,5,8,10],
                 [11,1,2,6,3,9,4,10,7,5,12,8],
                 [1,10,2,6,3,9,4,12,7,5,8,11],
                 [10,12,1,9,2,6,3,4,7,5,8,11],
                 [1,9,2,6,10,3,4,12,7,5,8,11],
                 [1,12,2,6,3,10,4,8,7,5,11,9],
                 [1,10,2,6,3,12,4,8,7,5,9,11],
                 [11,9,10,1,2,6,3,8,12,4,7,5],
                 [1,8,2,6,3,4,7,5,9,11,12,10],
                 [1,8,2,6,3,10,4,12,7,5,9,11],
                 [1,6,2,12,3,4,5,7,8,11,9,10],
                 [1,6,11,2,3,4,5,7,8,10,12,9],
                 [1,6,2,12,3,4,5,7,8,10,11,9],
                 [1,6,2,10,3,4,5,7,8,12,9,11],
                 [1,6,2,10,3,4,5,7,8,11,12,9],
                 [10,12,1,6,2,3,4,9,5,7,8,11],
                 [1,6,10,2,3,12,4,9,5,7,8,11],
                 [1,6,2,12,10,3,4,9,5,7,11,8],
                 [1,6,2,12,3,11,4,9,5,7,10,8],
                 [1,6,2,11,12,3,4,9,5,7,10,8],
                 [1,6,2,12,3,9,4,11,5,7,8,10],
                 [1,6,2,11,3,9,12,4,5,7,8,10],
                 [1,6,2,12,3,9,4,10,5,7,11,8],
                 [1,6,2,10,3,9,4,12,5,7,8,11],
                 [10,12,1,6,2,9,3,4,5,7,8,11],
                 [1,6,2,9,10,3,4,12,5,7,8,11],
                 [10,9,1,6,2,12,3,4,5,8,7,11],
                 [10,9,1,6,2,11,3,4,5,8,12,7],
                 [11,9,1,6,10,2,3,4,5,8,12,7],
                 [9,12,1,6,10,2,3,4,5,8,11,7],
                 [9,12,1,6,2,11,3,4,5,8,10,7],
                 [9,11,1,6,12,2,3,4,5,8,10,7],
                 [10,12,1,6,9,2,3,4,5,8,7,11],
                 [1,6,9,2,10,3,4,12,5,8,7,11],
                 [1,6,9,2,10,3,4,11,5,8,12,7],
                 [1,6,2,12,9,3,4,11,5,8,7,10],
                 [1,6,2,11,9,3,12,4,5,8,7,10],
                 [1,6,11,2,9,3,4,10,5,8,12,7],
                 [1,6,2,12,9,3,4,10,5,8,11,7],
                 [1,6,2,10,9,3,4,12,5,8,7,11],
                 [1,6,2,10,9,3,4,11,5,8,12,7],
                 [10,12,1,6,2,3,9,4,5,8,7,11],
                 [1,6,10,2,3,12,9,4,5,8,7,11],
                 [1,6,10,2,3,11,9,4,5,8,12,7],
                 [1,6,11,2,10,3,9,4,5,8,12,7],
                 [1,6,2,12,10,3,9,4,5,8,11,7],
                 [1,6,2,12,3,11,9,4,5,8,10,7],
                 [1,6,2,11,12,3,9,4,5,8,10,7],
                 [1,6,2,12,3,4,5,8,9,7,10,11],
                 [1,6,2,3,4,11,5,8,9,7,12,10],
                 [1,6,2,11,3,4,5,8,9,7,12,10],
                 [1,6,2,12,3,11,4,10,5,8,9,7],
                 [1,6,2,11,12,3,4,10,5,8,9,7],
                 [1,6,11,2,3,10,12,4,5,8,9,7],
                 [1,6,2,12,3,10,11,4,5,8,9,7],
                 [1,6,2,10,3,4,5,8,9,7,11,12],
                 [1,6,2,10,3,12,4,11,5,8,9,7],
                 [1,6,2,10,3,11,12,4,5,8,9,7],
                 [1,6,2,3,4,8,5,7,9,11,12,10],
                 [1,6,2,3,4,8,5,11,7,9,12,10],
                 [1,6,2,12,3,11,4,8,5,10,7,9],
                 [1,6,2,11,12,3,4,8,5,10,7,9],
                 [1,6,11,2,3,10,4,8,12,5,7,9],
                 [1,6,2,12,3,10,4,8,11,5,7,9],
                 [1,6,2,12,3,10,4,8,5,7,11,9],
                 [1,6,2,10,3,12,4,8,5,7,9,11],
                 [1,6,2,10,3,12,4,8,5,11,7,9],
                 [1,6,2,10,3,11,4,8,12,5,7,9],
                 [10,12,1,6,2,3,4,8,5,9,7,11],
                 [1,6,10,2,3,12,4,8,5,9,7,11],
                 [1,6,10,2,3,11,4,8,5,9,12,7],
                 [1,6,2,12,10,3,4,8,5,9,11,7],
                 [1,6,2,12,3,11,4,8,5,9,10,7],
                 [1,6,2,11,12,3,4,8,5,9,10,7],
                 [1,6,2,12,3,9,4,8,5,11,7,10],
                 [1,6,2,11,3,9,4,8,12,5,7,10],
                 [1,6,2,12,3,9,4,8,5,10,11,7],
                 [1,6,2,10,3,9,4,8,5,12,7,11],
                 [1,6,2,10,3,9,4,8,5,11,12,7],
                 [1,6,2,9,10,3,4,8,5,12,7,11],
                 [1,6,2,9,10,3,4,8,5,11,12,7],
                 [11,9,1,6,10,2,3,8,12,4,5,7],
                 [9,11,1,6,12,2,3,8,10,4,5,7],
                 [1,6,2,12,3,8,9,4,5,11,7,10],
                 [1,6,2,11,3,8,9,4,12,5,7,10],
                 [1,6,2,12,3,8,9,4,5,10,11,7],
                 [1,6,2,8,3,4,5,7,9,11,12,10],
                 [1,6,2,8,3,10,4,12,5,7,9,11],
                 [1,6,2,8,3,10,4,9,5,11,12,7],
                 [8,11,1,6,2,3,4,7,5,9,12,10],
                 [8,11,1,6,12,2,3,10,4,7,5,9],
                 [11,8,1,6,2,10,12,3,4,7,5,9],
                 [8,10,1,6,2,12,3,11,4,7,5,9],
                 [8,10,1,6,2,11,12,3,4,7,5,9],
                 [10,8,1,6,2,12,3,9,4,7,5,11],
                 [10,8,1,6,2,11,3,9,4,7,12,5],
                 [11,8,1,6,10,2,3,9,4,7,12,5],
                 [8,11,1,6,12,2,3,9,4,7,10,5],
                 [11,9,1,6,10,2,8,3,4,7,12,5],
                 [9,11,1,6,12,2,8,3,4,7,10,5],
                 [1,6,2,3,4,7,8,5,9,11,12,10],
                 [1,6,2,12,3,10,4,7,8,5,11,9],
                 [1,6,2,10,3,12,4,7,8,5,9,11],
                 [1,6,2,12,3,7,4,10,5,8,11,9],
                 [1,6,2,10,3,7,4,12,5,8,9,11],
                 [1,6,2,12,3,7,4,9,5,10,11,8],
                 [11,9,1,6,10,2,3,7,4,8,12,5],
                 [9,11,1,6,12,2,3,7,4,8,10,5],
                 [1,6,2,7,3,4,8,5,9,11,12,10],
                 [6,1,2,12,3,5,4,7,8,11,9,10],
                 [6,1,11,2,3,5,4,7,8,10,12,9],
                 [6,1,2,12,3,5,4,7,8,10,11,9],
                 [6,1,2,10,3,5,4,7,8,12,9,11],
                 [6,1,2,10,3,5,4,7,8,11,12,9],
                 [10,12,6,1,2,9,3,5,4,7,8,11],
                 [6,12,10,1,2,9,3,5,4,7,11,8],
                 [6,12,1,11,2,9,3,5,4,7,10,8],
                 [6,12,1,9,2,11,3,5,4,7,8,10],
                 [6,11,1,9,12,2,3,5,4,7,8,10],
                 [6,12,1,9,2,10,3,5,4,7,11,8],
                 [6,10,1,9,2,12,3,5,4,7,8,11],
                 [10,12,6,9,1,2,3,5,4,7,8,11],
                 [6,9,10,1,2,12,3,5,4,7,8,11],
                 [6,9,1,12,10,2,3,5,4,7,11,8],
                 [6,9,1,12,2,11,3,5,4,7,10,8],
                 [6,9,1,11,12,2,3,5,4,7,10,8],
                 [10,9,6,1,2,12,3,5,4,8,7,11],
                 [10,12,9,6,1,2,3,5,4,8,7,11],
                 [9,6,10,1,2,12,3,5,4,8,7,11],
                 [11,9,6,1,10,2,3,5,4,8,12,7],
                 [9,6,1,12,10,2,3,5,4,8,11,7],
                 [9,12,6,1,10,2,3,5,4,8,11,7],
                 [9,6,1,12,2,11,3,5,4,8,10,7],
                 [9,12,6,1,2,11,3,5,4,8,10,7],
                 [9,6,1,11,12,2,3,5,4,8,10,7],
                 [9,11,6,1,12,2,3,5,4,8,10,7],
                 [6,12,9,1,2,11,3,5,4,8,7,10],
                 [6,11,9,1,12,2,3,5,4,8,7,10],
                 [6,12,9,1,2,10,3,5,4,8,11,7],
                 [6,10,9,1,2,12,3,5,4,8,7,11],
                 [10,12,6,1,9,2,3,5,4,8,7,11],
                 [6,12,10,1,9,2,3,5,4,8,11,7],
                 [6,12,1,11,9,2,3,5,4,8,10,7],
                 [6,1,2,12,3,5,4,8,9,7,10,11],
                 [6,1,2,11,3,5,4,8,9,7,12,10],
                 [6,11,1,2,3,5,4,8,9,7,12,10],
                 [6,1,2,10,3,5,4,8,9,7,11,12],
                 [6,12,1,11,2,10,3,5,4,8,9,7],
                 [6,11,12,1,2,10,3,5,4,8,9,7],
                 [11,6,1,10,12,2,3,5,4,8,9,7],
                 [6,12,1,10,11,2,3,5,4,8,9,7],
                 [6,10,1,12,2,11,3,5,4,8,9,7],
                 [6,10,1,11,12,2,3,5,4,8,9,7],
                 [6,1,2,8,3,5,4,7,9,11,12,10],
                 [6,12,1,10,2,8,3,5,4,7,11,9],
                 [11,9,10,6,1,8,12,2,3,5,4,7],
                 [9,11,12,6,1,8,10,2,3,5,4,7],
                 [6,8,1,2,3,5,4,7,9,11,12,10],
                 [6,8,1,2,3,5,4,11,7,9,12,10],
                 [6,8,1,12,2,11,3,5,4,10,7,9],
                 [6,8,1,11,12,2,3,5,4,10,7,9],
                 [6,8,11,1,2,10,3,5,12,4,7,9],
                 [6,8,1,12,2,10,3,5,11,4,7,9],
                 [6,8,1,12,2,10,3,5,4,7,11,9],
                 [6,8,1,10,2,12,3,5,4,7,9,11],
                 [6,8,1,10,2,12,3,5,4,11,7,9],
                 [6,8,1,10,2,11,3,5,12,4,7,9],
                 [6,8,1,9,2,12,3,5,10,4,11,7],
                 [6,1,2,7,3,5,8,4,9,11,12,10],
                 [6,12,1,7,2,10,3,5,4,8,11,9],
                 [6,8,1,7,2,12,3,5,4,10,11,9],
                 [6,7,1,2,3,5,8,4,9,11,12,10],
                 [6,7,1,12,2,10,3,5,8,4,11,9],
                 [7,1,6,2,3,5,8,4,9,11,12,10],
                 [11,7,1,10,6,2,3,5,8,4,12,9],
                 [7,10,1,11,6,2,3,5,8,4,12,9],
                 [7,11,1,9,6,2,3,5,8,4,12,10],
                 [10,12,7,9,1,11,6,2,3,5,8,4],
                 [7,9,10,1,6,2,3,5,8,4,11,12],
                 [11,1,6,2,3,5,7,4,8,10,12,9],
                 [1,10,6,2,3,5,7,4,8,12,9,11],
                 [1,10,6,2,3,5,7,4,8,11,12,9],
                 [10,12,1,9,6,2,3,5,7,4,8,11],
                 [1,8,6,2,3,5,7,4,9,11,12,10],
                 [1,2,3,5,6,4,7,8,9,11,12,10],
                 [1,2,3,5,6,4,7,11,8,9,12,10],
                 [1,12,2,11,3,5,6,4,7,10,8,9],
                 [1,11,12,2,3,5,6,4,7,10,8,9],
                 [1,12,2,10,3,5,6,4,11,7,8,9],
                 [1,10,2,12,3,5,6,4,7,11,8,9],
                 [10,1,2,12,3,5,6,4,7,9,8,11],
                 [10,12,1,2,3,5,6,4,7,9,8,11],
                 [10,1,2,11,3,5,6,4,7,9,12,8],
                 [11,1,10,2,3,5,6,4,7,9,12,8],
                 [1,12,10,2,3,5,6,4,7,9,11,8],
                 [1,12,2,11,3,5,6,4,7,9,10,8],
                 [1,11,12,2,3,5,6,4,7,9,10,8],
                 [1,11,2,9,3,5,6,4,12,7,8,10],
                 [11,1,2,9,3,5,6,4,7,10,12,8],
                 [1,10,2,9,3,5,6,4,7,12,8,11],
                 [1,10,2,9,3,5,6,4,7,11,12,8],
                 [1,9,10,2,3,5,6,4,7,12,8,11],
                 [1,9,10,2,3,5,6,4,7,11,12,8],
                 [1,9,11,2,3,5,6,4,10,7,12,8],
                 [1,9,2,11,3,5,6,4,12,7,10,8],
                 [10,12,9,1,2,8,3,5,6,4,7,11],
                 [9,12,10,1,2,8,3,5,6,4,11,7],
                 [9,12,1,11,2,8,3,5,6,4,10,7],
                 [1,11,2,8,3,5,6,4,9,7,12,10],
                 [1,10,2,8,3,5,6,4,9,7,11,12],
                 [1,8,2,11,3,5,6,4,7,9,12,10],
                 [1,8,11,2,3,5,6,4,7,10,12,9],
                 [1,8,2,10,3,5,6,4,7,9,11,12],
                 [1,8,2,10,3,5,6,4,7,11,12,9],
                 [10,12,1,8,2,9,3,5,6,4,7,11],
                 [11,1,2,7,3,5,6,4,8,10,12,9],
                 [1,10,2,7,3,5,6,4,8,11,12,9],
                 [10,12,1,9,2,7,3,5,6,4,8,11],
                 [1,8,2,7,3,5,6,4,9,11,12,10],
                 [11,8,1,7,2,10,3,5,6,4,12,9],
                 [8,10,1,7,2,11,3,5,6,4,12,9],
                 [8,11,1,7,2,9,3,5,6,4,12,10],
                 [1,7,8,2,3,5,6,4,9,11,12,10],
                 [1,11,2,5,12,3,4,6,7,10,8,9],
                 [1,10,2,5,3,12,4,6,7,11,8,9],
                 [10,1,2,5,3,12,4,6,7,9,8,11],
                 [10,1,2,5,3,11,4,6,7,9,12,8],
                 [11,1,2,5,10,3,4,6,7,9,12,8],
                 [1,11,2,5,12,3,4,6,7,9,10,8],
                 [1,11,2,5,3,9,4,6,12,7,8,10],
                 [11,1,2,5,3,9,4,6,7,10,12,8],
                 [1,10,2,5,3,9,4,6,7,12,8,11],
                 [1,10,2,5,3,9,4,6,7,11,12,8],
                 [1,11,2,5,12,3,4,8,6,10,7,9],
                 [11,1,2,5,3,10,4,8,12,6,7,9],
                 [1,10,2,5,3,12,4,8,6,11,7,9],
                 [1,10,2,5,3,11,4,8,12,6,7,9],
                 [10,1,2,5,3,12,4,8,6,9,7,11],
                 [1,11,2,5,12,3,4,8,6,9,10,7],
                 [1,11,2,5,3,9,4,8,12,6,7,10],
                 [1,10,2,5,3,9,4,8,6,12,7,11],
                 [10,12,9,1,2,5,3,8,4,6,7,11],
                 [9,12,10,1,2,5,3,8,4,6,11,7],
                 [9,12,1,11,2,5,3,8,4,6,10,7],
                 [1,11,2,5,3,8,4,6,9,7,12,10],
                 [1,10,2,5,3,8,4,6,9,7,11,12],
                 [1,8,2,5,3,11,4,6,7,9,12,10],
                 [10,12,1,8,2,5,3,9,4,6,7,11],
                 [11,8,1,10,2,5,12,3,4,7,6,9],
                 [8,10,1,11,2,5,12,3,4,7,6,9],
                 [10,8,1,11,2,5,3,9,4,7,12,6],
                 [11,8,10,1,2,5,3,9,4,7,12,6],
                 [11,1,2,5,3,7,4,6,8,10,12,9],
                 [1,10,2,5,3,7,4,6,8,11,12,9],
                 [10,12,1,9,2,5,3,7,4,6,8,11],
                 [8,11,1,7,2,5,3,9,4,6,12,10],
                 [11,7,1,10,2,5,3,6,8,4,12,9],
                 [7,10,1,11,2,5,3,6,8,4,12,9],
                 [7,11,1,9,2,5,3,6,8,4,12,10],
                 [10,12,7,9,1,11,2,5,3,6,8,4],
                 [7,9,10,1,2,5,3,6,8,4,11,12],
                 [11,1,2,5,3,6,7,4,8,10,12,9],
                 [1,10,2,5,3,6,7,4,8,11,12,9],
                 [10,12,1,6,2,5,9,3,4,8,7,11],
                 [1,6,2,5,3,11,4,8,9,7,12,10],
                 [10,12,9,6,1,5,2,3,4,8,7,11],
                 [9,6,1,5,10,2,3,12,4,8,7,11],
                 [6,12,1,5,10,2,9,3,4,8,11,7],
                 [6,11,1,5,2,3,4,8,9,7,12,10],
                 [11,6,1,5,2,10,12,3,4,8,9,7],
                 [6,12,1,5,2,10,11,3,4,8,9,7],
                 [1,5,6,2,3,11,4,8,9,7,12,10],
                 [10,12,7,9,1,5,2,11,6,3,8,4],
                 [1,5,2,3,6,4,7,11,8,9,12,10],
                 [10,12,1,5,2,3,6,4,7,9,8,11],
                 [10,12,1,5,9,2,3,8,6,4,7,11],
                 [1,5,2,11,3,8,6,4,9,7,12,10],
                 [1,5,2,8,3,11,6,4,7,9,12,10],
                 [10,12,1,5,2,8,3,9,6,4,7,11],
                 [6,12,5,7,1,11,2,4,3,9,10,8],
                 [6,9,5,7,1,11,2,4,12,3,10,8],
                 [10,12,4,6,1,3,2,5,7,9,8,11],
                 [4,6,1,3,2,8,5,11,7,9,12,10]];

const h1_data = [[1, 2, 3, 4, 5, 6],
                 [1, 2, 3, 6, 4, 5],
                 [1, 2, 3, 5, 6, 4],
                 [5, 1, 2, 4, 6, 3],
                 [1, 4, 2, 5, 6, 3]];

const o1_data = [[1,2,3,4,5,6,7,8],
                 [1,2,3,4,5,8,6,7],
                 [1,2,3,4,5,7,8,6],
                 [1,2,3,8,4,7,5,6],
                 [1,2,3,7,8,4,5,6],
                 [1,2,3,7,4,5,8,6],
                 [7,1,2,3,4,6,8,5],
                 [1,2,7,3,4,6,8,5],
                 [1,2,3,8,4,6,7,5],
                 [1,2,3,6,4,8,5,7],
                 [1,2,3,6,4,7,8,5],
                 [6,1,2,8,3,5,4,7],
                 [6,1,2,7,3,5,8,4],
                 [7,1,6,2,3,5,8,4],
                 [1,7,8,2,3,5,6,4],
                 [1,6,2,5,3,8,4,7],
                 [1,6,2,5,3,7,8,4],
                 [1,5,6,2,3,7,8,4]];

const p2_data = [[1,2,3,4,5,6,7,8,9,10],
                 [1,2,3,4,5,6,7,10,8,9],
                 [1,2,3,4,5,10,6,7,8,9],
                 [1,2,3,10,4,5,6,7,8,9],
                 [1,10,2,3,4,5,6,7,8,9],
                 [1,2,3,4,5,6,7,9,10,8],
                 [1,2,3,4,5,10,6,9,7,8],
                 [1,2,3,10,4,5,6,9,7,8],
                 [1,2,3,4,5,9,10,6,7,8],
                 [1,2,3,4,5,9,6,7,10,8],
                 [1,2,3,9,4,5,10,6,7,8],
                 [1,2,3,9,4,5,6,7,10,8],
                 [1,9,2,3,10,4,5,6,7,8],
                 [1,9,2,3,4,5,10,6,7,8],
                 [1,9,2,3,4,5,6,7,10,8],
                 [9,1,2,3,4,5,6,8,10,7],
                 [1,2,9,3,4,5,6,8,10,7],
                 [1,2,3,4,9,5,6,8,10,7],
                 [1,2,3,4,5,10,6,8,9,7],
                 [1,2,3,10,4,5,6,8,9,7],
                 [1,2,3,4,5,8,6,10,7,9],
                 [1,2,3,4,5,8,6,9,10,7],
                 [1,2,3,10,4,9,5,8,6,7],
                 [1,10,2,3,4,9,5,8,6,7],
                 [1,2,3,9,10,4,5,8,6,7],
                 [1,10,2,9,3,4,5,8,6,7],
                 [1,9,10,2,3,4,5,8,6,7],
                 [1,9,2,3,10,4,5,8,6,7],
                 [9,1,2,3,4,8,10,5,6,7],
                 [9,1,2,3,4,8,5,6,10,7],
                 [1,2,9,3,4,8,10,5,6,7],
                 [1,2,9,3,4,8,5,6,10,7],
                 [1,2,3,10,4,8,9,5,6,7],
                 [1,10,2,3,4,8,9,5,6,7],
                 [1,2,3,10,4,8,5,6,9,7],
                 [1,2,3,8,4,5,6,10,7,9],
                 [1,2,3,8,4,10,5,6,7,9],
                 [1,2,3,8,4,5,6,9,10,7],
                 [1,2,3,8,4,10,5,9,6,7],
                 [1,2,3,8,4,9,10,5,6,7],
                 [1,2,3,8,4,9,5,6,10,7],
                 [1,9,10,2,3,8,4,5,6,7],
                 [9,1,2,8,10,3,4,5,6,7],
                 [1,10,2,8,3,4,9,5,6,7],
                 [1,8,2,3,4,10,5,6,7,9],
                 [1,8,2,10,3,4,5,6,7,9],
                 [1,8,2,3,4,5,6,9,10,7],
                 [1,8,2,3,4,10,5,9,6,7],
                 [1,8,2,10,3,4,5,9,6,7],
                 [1,8,2,3,4,9,10,5,6,7],
                 [1,8,2,3,4,9,5,6,10,7],
                 [1,8,2,10,3,9,4,5,6,7],
                 [8,1,2,3,4,10,5,7,6,9],
                 [8,1,2,10,3,4,5,7,6,9],
                 [8,1,2,3,4,9,5,7,10,6],
                 [8,1,2,9,3,4,5,7,10,6],
                 [9,1,8,2,3,4,5,7,10,6],
                 [1,2,8,3,4,10,5,7,6,9],
                 [1,2,8,3,4,9,5,7,10,6],
                 [9,1,2,3,8,4,5,7,10,6],
                 [1,2,9,3,8,4,5,7,10,6],
                 [1,2,3,10,8,4,5,7,9,6],
                 [1,2,3,10,4,9,5,7,8,6],
                 [1,2,3,9,10,4,5,7,8,6],
                 [1,10,2,9,3,4,5,7,8,6],
                 [1,9,10,2,3,4,5,7,8,6],
                 [1,9,2,3,10,4,5,7,8,6],
                 [1,2,3,10,4,7,5,9,6,8],
                 [1,2,3,9,4,7,10,5,6,8],
                 [1,2,3,9,4,7,5,6,10,8],
                 [1,9,2,3,4,7,10,5,6,8],
                 [1,9,2,3,4,7,5,6,10,8],
                 [9,1,2,3,4,7,5,8,10,6],
                 [1,2,9,3,4,7,5,8,10,6],
                 [1,2,3,10,4,7,5,8,9,6],
                 [1,2,3,8,4,7,5,10,6,9],
                 [1,2,3,8,4,7,5,9,10,6],
                 [1,8,2,3,4,7,5,10,6,9],
                 [1,8,2,3,4,7,5,9,10,6],
                 [8,1,2,10,3,7,4,5,6,9],
                 [8,10,1,2,3,7,4,9,5,6],
                 [8,1,2,9,3,7,4,5,10,6],
                 [9,1,8,2,3,7,4,5,10,6],
                 [1,2,3,7,8,4,5,10,6,9],
                 [1,2,3,7,8,4,5,9,10,6],
                 [1,2,3,7,9,4,8,5,10,6],
                 [1,2,3,7,4,10,8,5,9,6],
                 [1,2,3,7,4,10,5,9,8,6],
                 [1,2,3,7,4,9,10,5,8,6],
                 [1,10,2,9,3,7,4,5,8,6],
                 [1,9,10,2,3,7,4,5,8,6],
                 [1,10,2,7,3,4,5,9,6,8],
                 [1,10,2,7,3,9,4,5,6,8],
                 [1,9,2,7,10,3,4,5,6,8],
                 [1,9,2,7,3,4,10,5,6,8],
                 [9,1,2,7,3,4,5,8,10,6],
                 [9,1,2,7,3,8,4,5,10,6],
                 [1,8,2,7,3,9,4,5,10,6],
                 [1,7,8,2,3,9,4,5,10,6],
                 [1,7,9,2,8,3,4,5,10,6],
                 [1,7,2,10,8,3,4,5,9,6],
                 [1,7,9,2,3,4,8,5,10,6],
                 [1,7,2,3,9,4,8,5,10,6],
                 [1,7,2,3,4,10,8,5,9,6],
                 [1,7,2,10,3,4,8,5,9,6],
                 [1,7,2,3,4,10,5,9,8,6],
                 [1,7,2,10,3,4,5,9,8,6],
                 [1,7,2,3,4,9,10,5,8,6],
                 [1,7,2,10,3,9,4,5,8,6],
                 [1,7,2,9,10,3,4,5,8,6],
                 [1,7,2,9,3,4,10,5,8,6],
                 [8,7,1,9,2,3,4,6,10,5],
                 [7,1,8,2,3,10,4,6,5,9],
                 [7,1,8,2,3,9,4,6,10,5],
                 [7,1,9,2,8,3,4,6,10,5],
                 [7,1,2,10,8,3,4,6,9,5],
                 [7,1,2,10,3,9,4,6,8,5],
                 [7,10,1,2,3,9,4,6,8,5],
                 [7,1,2,9,10,3,4,6,8,5],
                 [7,10,1,9,2,3,4,6,8,5],
                 [7,9,1,2,10,3,4,6,8,5],
                 [1,10,7,2,3,9,4,6,5,8],
                 [1,9,7,2,10,3,4,6,5,8],
                 [9,1,7,2,3,8,4,6,10,5],
                 [1,8,7,2,3,10,4,6,5,9],
                 [1,8,7,2,3,9,4,6,10,5],
                 [8,1,2,10,7,3,4,6,5,9],
                 [8,1,2,9,7,3,4,6,10,5],
                 [9,1,8,2,7,3,4,6,10,5],
                 [1,10,2,9,7,3,4,6,8,5],
                 [1,9,10,2,7,3,4,6,8,5],
                 [1,2,3,9,4,6,7,5,10,8],
                 [1,9,2,3,4,6,7,5,10,8],
                 [1,10,2,9,3,8,4,6,7,5],
                 [1,9,10,2,3,8,4,6,7,5],
                 [9,1,2,8,10,3,4,6,7,5],
                 [1,10,2,8,9,3,4,6,7,5],
                 [1,8,2,10,3,9,4,6,7,5],
                 [1,8,2,9,10,3,4,6,7,5],
                 [1,2,3,6,4,9,5,7,10,8],
                 [1,2,3,6,9,4,5,8,10,7],
                 [1,2,3,6,4,10,5,8,9,7],
                 [1,10,2,9,3,6,4,8,5,7],
                 [1,9,10,2,3,6,4,8,5,7],
                 [9,1,2,8,3,6,10,4,5,7],
                 [1,10,2,8,3,6,9,4,5,7],
                 [1,8,2,10,3,6,4,5,7,9],
                 [1,8,2,10,3,6,4,9,5,7],
                 [1,8,2,9,3,6,10,4,5,7],
                 [1,8,2,9,3,6,4,5,10,7],
                 [8,1,2,10,3,6,4,7,5,9],
                 [8,1,2,9,3,6,4,7,10,5],
                 [9,1,8,2,3,6,4,7,10,5],
                 [1,9,10,2,3,6,4,7,8,5],
                 [1,10,2,7,3,6,4,9,5,8],
                 [1,9,2,7,3,6,10,4,5,8],
                 [9,1,2,7,3,6,4,8,10,5],
                 [1,8,2,7,3,6,4,10,5,9],
                 [1,8,2,7,3,6,4,9,10,5],
                 [1,7,8,2,3,6,4,10,5,9],
                 [1,7,8,2,3,6,4,9,10,5],
                 [1,7,9,2,3,6,8,4,10,5],
                 [1,7,2,10,3,6,8,4,9,5],
                 [1,7,2,10,3,6,4,9,8,5],
                 [1,7,2,9,3,6,10,4,8,5],
                 [7,1,2,6,8,3,4,10,5,9],
                 [7,1,2,6,8,3,4,9,10,5],
                 [7,1,2,6,3,10,8,4,9,5],
                 [1,9,2,6,7,3,10,4,5,8],
                 [9,1,2,6,7,3,4,8,10,5],
                 [1,8,2,6,7,3,4,9,10,5],
                 [8,1,2,6,3,10,7,4,5,9],
                 [8,1,2,6,3,9,7,4,10,5],
                 [9,1,2,6,8,3,7,4,10,5],
                 [1,9,2,6,10,3,7,4,8,5],
                 [1,9,2,6,3,4,7,5,10,8],
                 [1,9,2,6,10,3,4,8,7,5],
                 [9,1,2,6,3,8,10,4,7,5],
                 [1,8,2,6,3,10,4,9,7,5],
                 [1,8,2,6,3,9,10,4,7,5],
                 [1,6,2,3,4,9,5,7,10,8],
                 [1,6,2,9,3,4,5,7,10,8],
                 [1,6,2,7,8,3,4,9,10,5],
                 [6,1,2,10,3,5,4,8,9,7],
                 [9,6,1,8,10,2,3,5,4,7],
                 [6,8,1,9,10,2,3,5,4,7],
                 [6,9,1,7,10,2,3,5,4,8],
                 [6,8,1,7,2,10,3,5,4,9],
                 [6,8,1,7,2,9,3,5,10,4],
                 [8,1,2,5,3,10,4,7,6,9],
                 [5,8,1,9,2,4,6,3,10,7],
                 [8,10,5,7,1,9,2,4,6,3],
                 [7,10,1,4,2,9,3,6,8,5]];

const h2_data = [[1,2,3,4,5,6,7,8,9,10,11,12],
                 [1,2,3,4,5,6,7,8,9,12,10,11],
                 [1,2,3,4,5,6,7,12,8,9,10,11],
                 [1,2,3,4,5,12,6,7,8,9,10,11],
                 [1,2,3,12,4,5,6,7,8,9,10,11],
                 [1,12,2,3,4,5,6,7,8,9,10,11],
                 [1,2,3,4,5,6,7,8,9,11,12,10],
                 [1,2,3,4,5,6,7,12,8,11,9,10],
                 [1,2,3,4,5,12,6,7,8,11,9,10],
                 [1,2,3,12,4,5,6,7,8,11,9,10],
                 [1,2,3,4,5,6,7,11,12,8,9,10],
                 [1,2,3,4,5,6,7,11,8,9,12,10],
                 [1,2,3,4,5,12,6,11,7,8,9,10],
                 [1,2,3,12,4,5,6,11,7,8,9,10],
                 [1,2,3,4,5,11,12,6,7,8,9,10],
                 [1,2,3,4,5,11,6,7,12,8,9,10],
                 [1,2,3,4,5,11,6,7,8,9,12,10],
                 [1,2,3,11,4,5,12,6,7,8,9,10],
                 [1,2,3,11,4,5,6,7,12,8,9,10],
                 [1,2,3,11,4,5,6,7,8,9,12,10],
                 [1,11,2,3,12,4,5,6,7,8,9,10],
                 [1,11,2,3,4,5,12,6,7,8,9,10],
                 [1,11,2,3,4,5,6,7,12,8,9,10],
                 [1,11,2,3,4,5,6,7,8,9,12,10],
                 [11,1,2,3,4,5,6,7,8,10,12,9],
                 [1,2,11,3,4,5,6,7,8,10,12,9],
                 [1,2,3,4,11,5,6,7,8,10,12,9],
                 [1,2,3,4,5,6,11,7,8,10,12,9],
                 [1,2,3,4,5,6,7,12,8,10,11,9],
                 [1,2,3,4,5,12,6,7,8,10,11,9],
                 [1,2,3,12,4,5,6,7,8,10,11,9],
                 [1,2,3,4,5,6,7,10,8,12,9,11],
                 [1,2,3,4,5,6,7,10,8,11,12,9],
                 [1,2,3,4,5,12,6,11,7,10,8,9],
                 [1,2,3,12,4,5,6,11,7,10,8,9],
                 [1,12,2,3,4,5,6,11,7,10,8,9],
                 [1,2,3,4,5,11,12,6,7,10,8,9],
                 [1,2,3,12,4,11,5,6,7,10,8,9],
                 [1,12,2,3,4,11,5,6,7,10,8,9],
                 [1,2,3,11,12,4,5,6,7,10,8,9],
                 [1,2,3,11,4,5,12,6,7,10,8,9],
                 [1,12,2,11,3,4,5,6,7,10,8,9],
                 [1,11,12,2,3,4,5,6,7,10,8,9],
                 [1,11,2,3,12,4,5,6,7,10,8,9],
                 [1,11,2,3,4,5,12,6,7,10,8,9],
                 [11,1,2,3,4,5,6,10,12,7,8,9],
                 [11,1,2,3,4,5,6,10,7,8,12,9],
                 [1,2,11,3,4,5,6,10,12,7,8,9],
                 [1,2,11,3,4,5,6,10,7,8,12,9],
                 [1,2,3,4,11,5,6,10,12,7,8,9],
                 [1,2,3,4,11,5,6,10,7,8,12,9],
                 [1,2,3,4,5,12,6,10,11,7,8,9],
                 [1,2,3,12,4,5,6,10,11,7,8,9],
                 [1,12,2,3,4,5,6,10,11,7,8,9],
                 [1,2,3,4,5,12,6,10,7,8,11,9],
                 [1,2,3,12,4,5,6,10,7,8,11,9],
                 [1,2,3,4,5,10,6,7,8,12,9,11],
                 [1,2,3,4,5,10,6,12,7,8,9,11],
                 [1,2,3,4,5,10,6,7,8,11,12,9],
                 [1,2,3,4,5,10,6,12,7,11,8,9],
                 [1,2,3,4,5,10,6,11,12,7,8,9],
                 [1,2,3,4,5,10,6,11,7,8,12,9],
                 [1,2,3,12,4,11,5,10,6,7,8,9],
                 [1,12,2,3,4,11,5,10,6,7,8,9],
                 [1,2,3,11,12,4,5,10,6,7,8,9],
                 [1,12,2,11,3,4,5,10,6,7,8,9],
                 [1,11,12,2,3,4,5,10,6,7,8,9],
                 [1,11,2,3,12,4,5,10,6,7,8,9],
                 [11,1,2,3,4,10,12,5,6,7,8,9],
                 [11,1,2,3,4,10,5,6,12,7,8,9],
                 [11,1,2,3,4,10,5,6,7,8,12,9],
                 [1,2,11,3,4,10,12,5,6,7,8,9],
                 [1,2,11,3,4,10,5,6,12,7,8,9],
                 [1,2,11,3,4,10,5,6,7,8,12,9],
                 [1,2,3,12,4,10,11,5,6,7,8,9],
                 [1,12,2,3,4,10,11,5,6,7,8,9],
                 [1,2,3,12,4,10,5,6,11,7,8,9],
                 [1,12,2,3,4,10,5,6,11,7,8,9],
                 [1,2,3,12,4,10,5,6,7,8,11,9],
                 [1,2,3,10,4,5,6,7,8,12,9,11],
                 [1,2,3,10,4,5,6,12,7,8,9,11],
                 [1,2,3,10,4,12,5,6,7,8,9,11],
                 [1,2,3,10,4,5,6,7,8,11,12,9],
                 [1,2,3,10,4,5,6,12,7,11,8,9],
                 [1,2,3,10,4,12,5,6,7,11,8,9],
                 [1,2,3,10,4,5,6,11,12,7,8,9],
                 [1,2,3,10,4,5,6,11,7,8,12,9],
                 [1,2,3,10,4,12,5,11,6,7,8,9],
                 [1,2,3,10,4,11,12,5,6,7,8,9],
                 [1,2,3,10,4,11,5,6,12,7,8,9],
                 [1,2,3,10,4,11,5,6,7,8,12,9],
                 [1,11,12,2,3,10,4,5,6,7,8,9],
                 [11,1,2,10,12,3,4,5,6,7,8,9],
                 [1,12,2,10,3,4,11,5,6,7,8,9],
                 [1,12,2,10,3,4,5,6,11,7,8,9],
                 [1,10,2,3,4,5,6,12,7,8,9,11],
                 [1,10,2,3,4,12,5,6,7,8,9,11],
                 [1,10,2,12,3,4,5,6,7,8,9,11],
                 [1,10,2,3,4,5,6,7,8,11,12,9],
                 [1,10,2,3,4,5,6,12,7,11,8,9],
                 [1,10,2,3,4,12,5,6,7,11,8,9],
                 [1,10,2,12,3,4,5,6,7,11,8,9],
                 [1,10,2,3,4,5,6,11,12,7,8,9],
                 [1,10,2,3,4,5,6,11,7,8,12,9],
                 [1,10,2,3,4,12,5,11,6,7,8,9],
                 [1,10,2,12,3,4,5,11,6,7,8,9],
                 [1,10,2,3,4,11,12,5,6,7,8,9],
                 [1,10,2,3,4,11,5,6,12,7,8,9],
                 [1,10,2,3,4,11,5,6,7,8,12,9],
                 [1,10,2,12,3,11,4,5,6,7,8,9],
                 [10,1,2,3,4,5,6,12,7,9,8,11],
                 [10,1,2,3,4,12,5,6,7,9,8,11],
                 [10,1,2,12,3,4,5,6,7,9,8,11],
                 [10,1,2,3,4,5,6,11,7,9,12,8],
                 [10,1,2,3,4,11,5,6,7,9,12,8],
                 [10,1,2,11,3,4,5,6,7,9,12,8],
                 [11,1,10,2,3,4,5,6,7,9,12,8],
                 [1,2,10,3,4,5,6,12,7,9,8,11],
                 [1,2,10,3,4,12,5,6,7,9,8,11],
                 [1,2,10,3,4,5,6,11,7,9,12,8],
                 [1,2,10,3,4,11,5,6,7,9,12,8],
                 [11,1,2,3,10,4,5,6,7,9,12,8],
                 [1,2,11,3,10,4,5,6,7,9,12,8],
                 [1,2,3,12,10,4,5,6,7,9,11,8],
                 [1,2,3,4,10,5,6,12,7,9,8,11],
                 [1,2,3,4,10,5,6,11,7,9,12,8],
                 [11,1,2,3,4,5,10,6,7,9,12,8],
                 [1,2,11,3,4,5,10,6,7,9,12,8],
                 [1,2,3,4,11,5,10,6,7,9,12,8],
                 [1,2,3,4,5,12,10,6,7,9,11,8],
                 [1,2,3,12,4,5,10,6,7,9,11,8],
                 [1,2,3,4,5,12,6,11,7,9,10,8],
                 [1,2,3,12,4,5,6,11,7,9,10,8],
                 [1,2,3,4,5,11,12,6,7,9,10,8],
                 [1,2,3,12,4,11,5,6,7,9,10,8],
                 [1,12,2,3,4,11,5,6,7,9,10,8],
                 [1,2,3,11,12,4,5,6,7,9,10,8],
                 [1,2,3,11,4,5,12,6,7,9,10,8],
                 [1,12,2,11,3,4,5,6,7,9,10,8],
                 [1,11,12,2,3,4,5,6,7,9,10,8],
                 [1,11,2,3,12,4,5,6,7,9,10,8],
                 [1,11,2,3,4,5,12,6,7,9,10,8],
                 [1,2,3,12,4,5,6,9,7,8,10,11],
                 [1,2,3,4,5,12,6,9,7,11,8,10],
                 [1,2,3,12,4,5,6,9,7,11,8,10],
                 [1,2,3,4,5,11,6,9,12,7,8,10],
                 [1,2,3,4,5,11,6,9,7,8,12,10],
                 [1,2,3,11,4,5,6,9,12,7,8,10],
                 [1,2,3,11,4,5,6,9,7,8,12,10],
                 [1,11,2,3,4,5,6,9,12,7,8,10],
                 [1,11,2,3,4,5,6,9,7,8,12,10],
                 [11,1,2,3,4,5,6,9,7,10,12,8],
                 [1,2,11,3,4,5,6,9,7,10,12,8],
                 [1,2,3,4,11,5,6,9,7,10,12,8],
                 [1,2,3,4,5,12,6,9,7,10,11,8],
                 [1,2,3,12,4,5,6,9,7,10,11,8],
                 [1,2,3,4,5,10,6,9,7,12,8,11],
                 [1,2,3,4,5,10,6,9,7,11,12,8],
                 [1,2,3,12,4,11,5,10,6,9,7,8],
                 [1,2,3,11,12,4,5,10,6,9,7,8],
                 [1,12,2,11,3,4,5,10,6,9,7,8],
                 [1,11,12,2,3,4,5,10,6,9,7,8],
                 [1,11,2,3,12,4,5,10,6,9,7,8],
                 [11,1,2,3,4,10,12,5,6,9,7,8],
                 [1,2,11,3,4,10,12,5,6,9,7,8],
                 [1,2,3,12,4,10,11,5,6,9,7,8],
                 [1,2,3,10,4,5,6,9,7,12,8,11],
                 [1,2,3,10,4,5,6,9,7,11,12,8],
                 [1,2,3,10,4,12,5,11,6,9,7,8],
                 [1,2,3,10,4,11,12,5,6,9,7,8],
                 [1,12,2,11,3,10,4,5,6,9,7,8],
                 [1,11,12,2,3,10,4,5,6,9,7,8],
                 [11,1,2,10,12,3,4,5,6,9,7,8],
                 [11,1,2,10,3,4,12,5,6,9,7,8],
                 [1,12,2,10,11,3,4,5,6,9,7,8],
                 [1,12,2,10,3,4,11,5,6,9,7,8],
                 [1,10,2,3,4,5,6,9,7,12,8,11],
                 [1,10,2,3,4,5,6,9,7,11,12,8],
                 [1,10,2,3,4,12,5,11,6,9,7,8],
                 [1,10,2,12,3,4,5,11,6,9,7,8],
                 [1,10,2,3,4,11,12,5,6,9,7,8],
                 [1,10,2,12,3,11,4,5,6,9,7,8],
                 [1,10,2,11,12,3,4,5,6,9,7,8],
                 [1,10,2,11,3,4,12,5,6,9,7,8],
                 [10,1,2,3,4,12,5,9,6,7,8,11],
                 [10,1,2,12,3,4,5,9,6,7,8,11],
                 [10,1,2,3,4,12,5,9,6,11,7,8],
                 [10,1,2,12,3,4,5,9,6,11,7,8],
                 [10,12,1,2,3,4,5,9,6,11,7,8],
                 [10,1,2,3,4,11,5,9,12,6,7,8],
                 [10,1,2,3,4,11,5,9,6,7,12,8],
                 [10,1,2,11,3,4,5,9,12,6,7,8],
                 [10,1,2,11,3,4,5,9,6,7,12,8],
                 [11,1,10,2,3,4,5,9,12,6,7,8],
                 [11,1,10,2,3,4,5,9,6,7,12,8],
                 [1,12,10,2,3,4,5,9,11,6,7,8],
                 [1,2,10,3,4,12,5,9,6,7,8,11],
                 [1,2,10,3,4,12,5,9,6,11,7,8],
                 [1,2,10,3,4,11,5,9,12,6,7,8],
                 [1,2,10,3,4,11,5,9,6,7,12,8],
                 [11,1,2,3,10,4,5,9,12,6,7,8],
                 [11,1,2,3,10,4,5,9,6,7,12,8],
                 [1,2,11,3,10,4,5,9,12,6,7,8],
                 [1,2,11,3,10,4,5,9,6,7,12,8],
                 [1,2,3,12,10,4,5,9,6,7,11,8],
                 [1,2,3,4,5,9,10,6,7,12,8,11],
                 [1,2,3,4,5,9,10,6,7,11,12,8],
                 [1,2,3,11,12,4,5,9,10,6,7,8],
                 [1,12,2,11,3,4,5,9,10,6,7,8],
                 [1,11,12,2,3,4,5,9,10,6,7,8],
                 [1,11,2,3,12,4,5,9,10,6,7,8],
                 [1,2,3,4,5,9,11,6,10,7,12,8],
                 [1,2,3,4,5,9,6,12,10,7,11,8],
                 [1,2,3,4,5,9,6,12,7,11,10,8],
                 [1,2,3,4,5,9,6,11,12,7,10,8],
                 [1,2,3,12,4,11,5,9,6,7,10,8],
                 [1,12,2,3,4,11,5,9,6,7,10,8],
                 [1,2,3,11,12,4,5,9,6,7,10,8],
                 [1,12,2,11,3,4,5,9,6,7,10,8],
                 [1,11,12,2,3,4,5,9,6,7,10,8],
                 [1,11,2,3,12,4,5,9,6,7,10,8],
                 [1,2,3,12,4,9,5,6,7,11,8,10],
                 [1,12,2,3,4,9,5,6,7,11,8,10],
                 [1,2,3,12,4,9,5,11,6,7,8,10],
                 [1,12,2,3,4,9,5,11,6,7,8,10],
                 [1,2,3,11,4,9,12,5,6,7,8,10],
                 [1,2,3,11,4,9,5,6,12,7,8,10],
                 [1,2,3,11,4,9,5,6,7,8,12,10],
                 [1,11,2,3,4,9,12,5,6,7,8,10],
                 [1,11,2,3,4,9,5,6,12,7,8,10],
                 [1,11,2,3,4,9,5,6,7,8,12,10],
                 [11,1,2,3,4,9,5,6,7,10,12,8],
                 [1,2,11,3,4,9,5,6,7,10,12,8],
                 [1,2,3,12,4,9,5,6,7,10,11,8],
                 [1,11,2,3,4,9,12,5,6,10,7,8],
                 [11,1,2,3,4,9,5,10,12,6,7,8],
                 [11,1,2,3,4,9,5,10,6,7,12,8],
                 [1,2,11,3,4,9,5,10,6,7,12,8],
                 [1,2,3,12,4,9,5,10,6,7,11,8],
                 [1,2,3,10,4,9,5,6,7,12,8,11],
                 [1,2,3,10,4,9,5,12,6,7,8,11],
                 [1,2,3,10,4,9,5,6,7,11,12,8],
                 [1,2,3,10,4,9,5,12,6,11,7,8],
                 [1,2,3,10,4,9,5,11,12,6,7,8],
                 [1,2,3,10,4,9,5,11,6,7,12,8],
                 [1,10,2,3,4,9,5,6,7,12,8,11],
                 [1,10,2,3,4,9,5,12,6,7,8,11],
                 [1,10,2,3,4,9,5,6,7,11,12,8],
                 [1,10,2,3,4,9,5,12,6,11,7,8],
                 [1,10,2,3,4,9,5,11,12,6,7,8],
                 [1,10,2,3,4,9,5,11,6,7,12,8],
                 [10,1,2,12,3,9,4,5,6,7,8,11],
                 [10,1,2,12,3,9,4,5,6,11,7,8],
                 [10,12,1,2,3,9,4,5,6,11,7,8],
                 [10,12,1,2,3,9,4,11,5,6,7,8],
                 [10,1,2,11,3,9,4,5,12,6,7,8],
                 [10,1,2,11,3,9,4,5,6,7,12,8],
                 [10,11,1,2,3,9,4,5,12,6,7,8],
                 [11,1,10,2,3,9,4,5,12,6,7,8],
                 [11,1,10,2,3,9,4,5,6,7,12,8],
                 [1,12,10,2,3,9,4,5,11,6,7,8],
                 [1,2,3,9,10,4,5,6,7,12,8,11],
                 [1,2,3,9,10,4,5,12,6,7,8,11],
                 [1,2,3,9,10,4,5,6,7,11,12,8],
                 [1,2,3,9,10,4,5,12,6,11,7,8],
                 [1,2,3,9,10,4,5,11,12,6,7,8],
                 [1,2,3,9,10,4,5,11,6,7,12,8],
                 [1,2,3,9,11,4,10,5,12,6,7,8],
                 [1,2,3,9,11,4,10,5,6,7,12,8],
                 [1,2,3,9,4,12,10,5,11,6,7,8],
                 [1,2,3,9,4,12,10,5,6,7,11,8],
                 [1,2,3,9,4,5,10,6,7,12,8,11],
                 [1,2,3,9,4,5,10,6,7,11,12,8],
                 [1,2,3,9,4,12,5,11,10,6,7,8],
                 [1,12,2,11,3,9,4,5,10,6,7,8],
                 [1,11,12,2,3,9,4,5,10,6,7,8],
                 [1,2,3,9,11,4,5,6,10,7,12,8],
                 [1,2,3,9,4,5,11,6,10,7,12,8],
                 [1,2,3,9,4,5,6,12,10,7,11,8],
                 [1,2,3,9,4,12,5,6,10,7,11,8],
                 [1,2,3,9,4,5,6,12,7,11,10,8],
                 [1,2,3,9,4,12,5,6,7,11,10,8],
                 [1,2,3,9,4,5,6,11,12,7,10,8],
                 [1,2,3,9,4,12,5,11,6,7,10,8],
                 [1,2,3,9,4,11,12,5,6,7,10,8],
                 [1,2,3,9,4,11,5,6,12,7,10,8],
                 [1,12,2,11,3,9,4,5,6,7,10,8],
                 [1,11,12,2,3,9,4,5,6,7,10,8],
                 [1,12,2,9,3,4,5,6,7,11,8,10],
                 [1,12,2,9,3,4,5,11,6,7,8,10],
                 [1,12,2,9,3,11,4,5,6,7,8,10],
                 [1,11,2,9,12,3,4,5,6,7,8,10],
                 [1,11,2,9,3,4,12,5,6,7,8,10],
                 [1,11,2,9,3,4,5,6,12,7,8,10],
                 [11,1,2,9,3,4,5,6,7,10,12,8],
                 [1,12,2,9,3,4,5,11,6,10,7,8],
                 [1,12,2,9,3,11,4,5,6,10,7,8],
                 [1,11,2,9,12,3,4,5,6,10,7,8],
                 [1,11,2,9,3,4,12,5,6,10,7,8],
                 [11,1,2,9,3,4,5,10,12,6,7,8],
                 [11,1,2,9,3,4,5,10,6,7,12,8],
                 [1,12,2,9,3,4,5,10,11,6,7,8],
                 [11,1,2,9,3,10,4,5,12,6,7,8],
                 [11,1,2,9,3,10,4,5,6,7,12,8],
                 [1,12,2,9,3,10,4,5,11,6,7,8],
                 [1,10,2,9,3,11,4,5,12,6,7,8],
                 [1,10,2,9,3,11,4,5,6,7,12,8],
                 [1,9,10,2,3,11,4,5,12,6,7,8],
                 [1,9,10,2,3,11,4,5,6,7,12,8],
                 [1,9,11,2,10,3,4,5,12,6,7,8],
                 [1,9,11,2,10,3,4,5,6,7,12,8],
                 [1,9,2,12,10,3,4,5,11,6,7,8],
                 [1,9,2,12,10,3,4,5,6,7,11,8],
                 [1,9,2,3,10,4,5,12,6,7,8,11],
                 [1,9,2,3,10,4,5,12,6,11,7,8],
                 [1,9,2,3,10,4,5,11,12,6,7,8],
                 [1,9,2,3,10,4,5,11,6,7,12,8],
                 [1,9,11,2,3,4,10,5,12,6,7,8],
                 [1,9,11,2,3,4,10,5,6,7,12,8],
                 [1,9,2,3,11,4,10,5,12,6,7,8],
                 [1,9,2,3,11,4,10,5,6,7,12,8],
                 [1,9,2,3,4,12,10,5,11,6,7,8],
                 [1,9,2,12,3,4,10,5,11,6,7,8],
                 [1,9,2,3,4,12,10,5,6,7,11,8],
                 [1,9,2,12,3,4,10,5,6,7,11,8],
                 [1,9,2,3,4,12,5,11,10,6,7,8],
                 [1,9,2,12,3,4,5,11,10,6,7,8],
                 [1,9,2,3,4,11,12,5,10,6,7,8],
                 [1,9,2,12,3,11,4,5,10,6,7,8],
                 [1,9,2,11,12,3,4,5,10,6,7,8],
                 [1,9,2,11,3,4,12,5,10,6,7,8],
                 [1,9,11,2,3,4,5,6,10,7,12,8],
                 [1,9,2,3,11,4,5,6,10,7,12,8],
                 [1,9,2,3,4,5,11,6,10,7,12,8],
                 [1,9,2,3,4,5,6,12,10,7,11,8],
                 [1,9,2,3,4,12,5,6,10,7,11,8],
                 [1,9,2,12,3,4,5,6,10,7,11,8],
                 [1,9,2,3,4,5,6,12,7,11,10,8],
                 [1,9,2,3,4,12,5,6,7,11,10,8],
                 [1,9,2,12,3,4,5,6,7,11,10,8],
                 [1,9,2,3,4,5,6,11,12,7,10,8],
                 [1,9,2,3,4,12,5,11,6,7,10,8],
                 [1,9,2,12,3,4,5,11,6,7,10,8],
                 [1,9,2,3,4,11,12,5,6,7,10,8],
                 [1,9,2,3,4,11,5,6,12,7,10,8],
                 [1,9,2,12,3,11,4,5,6,7,10,8],
                 [1,9,2,11,12,3,4,5,6,7,10,8],
                 [1,9,2,11,3,4,12,5,6,7,10,8],
                 [1,9,2,11,3,4,5,6,12,7,10,8],
                 [10,9,1,2,3,12,4,5,6,8,7,11],
                 [10,9,1,2,3,11,4,5,6,8,12,7],
                 [10,9,1,11,2,3,4,5,6,8,12,7],
                 [9,1,10,2,3,4,5,12,6,8,7,11],
                 [9,1,10,2,3,12,4,5,6,8,7,11],
                 [9,1,10,2,3,4,5,11,6,8,12,7],
                 [9,1,10,2,3,11,4,5,6,8,12,7],
                 [9,1,11,2,10,3,4,5,6,8,12,7],
                 [9,1,2,12,10,3,4,5,6,8,11,7],
                 [9,1,2,3,10,4,5,12,6,8,7,11],
                 [9,1,2,3,10,4,5,11,6,8,12,7],
                 [9,1,11,2,3,4,10,5,6,8,12,7],
                 [9,1,2,3,11,4,10,5,6,8,12,7],
                 [9,1,2,3,4,12,10,5,6,8,11,7],
                 [9,1,2,12,3,4,10,5,6,8,11,7],
                 [9,1,2,3,4,12,5,11,6,8,10,7],
                 [9,1,2,12,3,4,5,11,6,8,10,7],
                 [9,12,1,2,3,4,5,11,6,8,10,7],
                 [9,1,2,3,4,11,12,5,6,8,10,7],
                 [9,1,2,12,3,11,4,5,6,8,10,7],
                 [9,12,1,2,3,11,4,5,6,8,10,7],
                 [9,1,2,11,12,3,4,5,6,8,10,7],
                 [9,1,2,11,3,4,12,5,6,8,10,7],
                 [9,12,1,11,2,3,4,5,6,8,10,7],
                 [9,11,1,2,12,3,4,5,6,8,10,7],
                 [9,11,1,2,3,4,12,5,6,8,10,7],
                 [1,12,9,2,3,4,5,11,6,8,7,10],
                 [1,12,9,2,3,11,4,5,6,8,7,10],
                 [1,11,9,2,12,3,4,5,6,8,7,10],
                 [1,11,9,2,3,4,12,5,6,8,7,10],
                 [11,1,9,2,3,4,5,10,6,8,12,7],
                 [11,1,9,2,3,10,4,5,6,8,12,7],
                 [1,10,9,2,3,4,5,12,6,8,7,11],
                 [1,10,9,2,3,12,4,5,6,8,7,11],
                 [1,10,9,2,3,4,5,11,6,8,12,7],
                 [1,10,9,2,3,11,4,5,6,8,12,7],
                 [10,1,2,12,9,3,4,5,6,8,7,11],
                 [10,1,2,11,9,3,4,5,6,8,12,7],
                 [11,1,10,2,9,3,4,5,6,8,12,7],
                 [1,2,9,3,10,4,5,12,6,8,7,11],
                 [1,2,9,3,10,4,5,11,6,8,12,7],
                 [1,2,9,3,11,4,10,5,6,8,12,7],
                 [1,2,9,3,4,12,10,5,6,8,11,7],
                 [1,2,9,3,4,12,5,11,6,8,10,7],
                 [1,2,9,3,4,11,12,5,6,8,10,7],
                 [1,12,2,11,9,3,4,5,6,8,10,7],
                 [1,11,12,2,9,3,4,5,6,8,10,7],
                 [1,2,3,12,9,4,5,11,6,8,7,10],
                 [1,12,2,3,9,4,5,11,6,8,7,10],
                 [1,2,3,11,9,4,12,5,6,8,7,10],
                 [1,11,2,3,9,4,12,5,6,8,7,10],
                 [11,1,2,3,9,4,5,10,6,8,12,7],
                 [1,2,11,3,9,4,5,10,6,8,12,7],
                 [1,2,3,12,9,4,5,10,6,8,11,7],
                 [1,2,3,10,9,4,5,12,6,8,7,11],
                 [1,2,3,10,9,4,5,11,6,8,12,7],
                 [1,10,2,3,9,4,5,12,6,8,7,11],
                 [1,10,2,3,9,4,5,11,6,8,12,7],
                 [10,1,2,3,4,12,9,5,6,8,7,11],
                 [10,1,2,12,3,4,9,5,6,8,7,11],
                 [10,1,2,3,4,11,9,5,6,8,12,7],
                 [10,1,2,11,3,4,9,5,6,8,12,7],
                 [11,1,10,2,3,4,9,5,6,8,12,7],
                 [1,2,10,3,4,12,9,5,6,8,7,11],
                 [1,2,10,3,4,11,9,5,6,8,12,7],
                 [11,1,2,3,10,4,9,5,6,8,12,7],
                 [1,2,11,3,10,4,9,5,6,8,12,7],
                 [1,2,3,12,10,4,9,5,6,8,11,7],
                 [1,2,3,12,4,11,9,5,6,8,10,7],
                 [1,12,2,3,4,11,9,5,6,8,10,7],
                 [1,2,3,11,12,4,9,5,6,8,10,7],
                 [1,12,2,11,3,4,9,5,6,8,10,7],
                 [1,11,12,2,3,4,9,5,6,8,10,7],
                 [1,11,2,3,12,4,9,5,6,8,10,7],
                 [1,2,3,12,4,5,6,8,9,7,10,11],
                 [1,2,3,4,5,11,6,8,9,7,12,10],
                 [1,2,3,11,4,5,6,8,9,7,12,10],
                 [1,11,2,3,4,5,6,8,9,7,12,10],
                 [1,2,3,12,4,11,5,10,6,8,9,7],
                 [1,12,2,3,4,11,5,10,6,8,9,7],
                 [1,2,3,11,12,4,5,10,6,8,9,7],
                 [1,12,2,11,3,4,5,10,6,8,9,7],
                 [1,11,12,2,3,4,5,10,6,8,9,7],
                 [1,11,2,3,12,4,5,10,6,8,9,7],
                 [11,1,2,3,4,10,12,5,6,8,9,7],
                 [1,2,11,3,4,10,12,5,6,8,9,7],
                 [1,2,3,12,4,10,11,5,6,8,9,7],
                 [1,12,2,3,4,10,11,5,6,8,9,7],
                 [1,2,3,10,4,12,5,11,6,8,9,7],
                 [1,2,3,10,4,11,12,5,6,8,9,7],
                 [1,12,2,11,3,10,4,5,6,8,9,7],
                 [1,11,12,2,3,10,4,5,6,8,9,7],
                 [11,1,2,10,12,3,4,5,6,8,9,7],
                 [11,1,2,10,3,4,12,5,6,8,9,7],
                 [1,12,2,10,11,3,4,5,6,8,9,7],
                 [1,12,2,10,3,4,11,5,6,8,9,7],
                 [1,10,2,3,4,12,5,11,6,8,9,7],
                 [1,10,2,12,3,4,5,11,6,8,9,7],
                 [1,10,2,3,4,11,12,5,6,8,9,7],
                 [1,10,2,12,3,11,4,5,6,8,9,7],
                 [1,10,2,11,12,3,4,5,6,8,9,7],
                 [1,10,2,11,3,4,12,5,6,8,9,7],
                 [1,2,3,4,5,8,6,11,7,9,12,10],
                 [1,12,2,11,3,4,5,8,6,7,9,10],
                 [1,11,12,2,3,4,5,8,6,7,9,10],
                 [1,11,2,3,12,4,5,8,6,7,9,10],
                 [1,2,3,4,5,8,11,6,7,10,12,9],
                 [1,2,3,4,5,8,6,12,7,10,11,9],
                 [1,2,3,12,4,11,5,8,6,10,7,9],
                 [1,12,2,3,4,11,5,8,6,10,7,9],
                 [1,2,3,11,12,4,5,8,6,10,7,9],
                 [1,12,2,11,3,4,5,8,6,10,7,9],
                 [1,11,12,2,3,4,5,8,6,10,7,9],
                 [1,11,2,3,12,4,5,8,6,10,7,9],
                 [11,1,2,3,4,10,5,8,12,6,7,9],
                 [11,1,2,3,4,10,5,8,6,7,12,9],
                 [1,2,11,3,4,10,5,8,12,6,7,9],
                 [1,2,11,3,4,10,5,8,6,7,12,9],
                 [1,2,3,12,4,10,5,8,11,6,7,9],
                 [1,12,2,3,4,10,5,8,11,6,7,9],
                 [1,2,3,12,4,10,5,8,6,7,11,9],
                 [1,2,3,10,4,12,5,8,6,7,9,11],
                 [1,2,3,10,4,12,5,8,6,11,7,9],
                 [1,2,3,10,4,11,5,8,12,6,7,9],
                 [1,2,3,10,4,11,5,8,6,7,12,9],
                 [11,1,2,10,3,4,5,8,12,6,7,9],
                 [11,1,2,10,3,4,5,8,6,7,12,9],
                 [1,12,2,10,3,4,5,8,11,6,7,9],
                 [1,10,2,3,4,12,5,8,6,7,9,11],
                 [1,10,2,12,3,4,5,8,6,7,9,11],
                 [1,10,2,3,4,12,5,8,6,11,7,9],
                 [1,10,2,12,3,4,5,8,6,11,7,9],
                 [1,10,2,3,4,11,5,8,12,6,7,9],
                 [1,10,2,3,4,11,5,8,6,7,12,9],
                 [1,10,2,11,3,4,5,8,12,6,7,9],
                 [1,10,2,11,3,4,5,8,6,7,12,9],
                 [10,1,2,3,4,12,5,8,6,9,7,11],
                 [10,1,2,12,3,4,5,8,6,9,7,11],
                 [10,1,2,3,4,11,5,8,6,9,12,7],
                 [10,1,2,11,3,4,5,8,6,9,12,7],
                 [11,1,10,2,3,4,5,8,6,9,12,7],
                 [1,2,10,3,4,12,5,8,6,9,7,11],
                 [1,2,10,3,4,11,5,8,6,9,12,7],
                 [11,1,2,3,10,4,5,8,6,9,12,7],
                 [1,2,11,3,10,4,5,8,6,9,12,7],
                 [1,2,3,12,10,4,5,8,6,9,11,7],
                 [1,2,3,12,4,11,5,8,6,9,10,7],
                 [1,12,2,3,4,11,5,8,6,9,10,7],
                 [1,2,3,11,12,4,5,8,6,9,10,7],
                 [1,12,2,11,3,4,5,8,6,9,10,7],
                 [1,11,12,2,3,4,5,8,6,9,10,7],
                 [1,11,2,3,12,4,5,8,6,9,10,7],
                 [1,2,3,12,4,9,5,8,6,11,7,10],
                 [1,12,2,3,4,9,5,8,6,11,7,10],
                 [1,2,3,11,4,9,5,8,12,6,7,10],
                 [1,2,3,11,4,9,5,8,6,7,12,10],
                 [1,11,2,3,4,9,5,8,12,6,7,10],
                 [1,11,2,3,4,9,5,8,6,7,12,10],
                 [11,1,2,3,4,9,5,8,6,10,12,7],
                 [1,2,11,3,4,9,5,8,6,10,12,7],
                 [1,2,3,12,4,9,5,8,6,10,11,7],
                 [1,2,3,10,4,9,5,8,6,12,7,11],
                 [1,2,3,10,4,9,5,8,6,11,12,7],
                 [1,12,2,11,3,10,4,9,5,8,6,7],
                 [1,11,12,2,3,10,4,9,5,8,6,7],
                 [11,1,2,10,12,3,4,9,5,8,6,7],
                 [1,12,2,10,11,3,4,9,5,8,6,7],
                 [1,10,2,3,4,9,5,8,6,12,7,11],
                 [1,10,2,3,4,9,5,8,6,11,12,7],
                 [1,10,2,12,3,11,4,9,5,8,6,7],
                 [1,10,2,11,12,3,4,9,5,8,6,7],
                 [10,1,2,12,3,9,4,11,5,8,6,7],
                 [10,12,1,2,3,9,4,11,5,8,6,7],
                 [10,1,2,11,3,9,12,4,5,8,6,7],
                 [11,1,10,2,3,9,12,4,5,8,6,7],
                 [1,12,10,2,3,9,11,4,5,8,6,7],
                 [1,2,3,9,10,4,5,8,6,12,7,11],
                 [1,2,3,9,10,4,5,8,6,11,12,7],
                 [1,12,2,11,3,9,10,4,5,8,6,7],
                 [1,11,12,2,3,9,10,4,5,8,6,7],
                 [1,2,3,9,11,4,5,8,10,6,12,7],
                 [1,2,3,9,4,12,5,8,10,6,11,7],
                 [1,2,3,9,4,12,5,8,6,11,10,7],
                 [1,2,3,9,4,11,5,8,12,6,10,7],
                 [1,12,2,9,3,4,5,8,6,11,7,10],
                 [1,11,2,9,3,4,5,8,12,6,7,10],
                 [1,11,2,9,3,4,5,8,6,7,12,10],
                 [11,1,2,9,3,4,5,8,6,10,12,7],
                 [1,12,2,9,3,11,4,10,5,8,6,7],
                 [1,11,2,9,12,3,4,10,5,8,6,7],
                 [11,1,2,9,3,10,12,4,5,8,6,7],
                 [1,12,2,9,3,10,11,4,5,8,6,7],
                 [1,10,2,9,3,4,5,8,6,12,7,11],
                 [1,10,2,9,3,4,5,8,6,11,12,7],
                 [1,10,2,9,3,12,4,11,5,8,6,7],
                 [1,10,2,9,3,11,12,4,5,8,6,7],
                 [10,12,1,9,2,3,4,11,5,8,6,7],
                 [10,12,1,9,2,11,3,4,5,8,6,7],
                 [10,11,1,9,12,2,3,4,5,8,6,7],
                 [10,11,1,9,2,3,12,4,5,8,6,7],
                 [1,9,10,2,3,4,5,8,6,12,7,11],
                 [1,9,10,2,3,4,5,8,6,11,12,7],
                 [1,9,10,2,3,12,4,11,5,8,6,7],
                 [1,9,10,2,3,11,12,4,5,8,6,7],
                 [1,9,11,2,10,3,12,4,5,8,6,7],
                 [1,9,2,12,10,3,11,4,5,8,6,7],
                 [1,9,2,3,10,4,5,8,6,12,7,11],
                 [1,9,2,3,10,4,5,8,6,11,12,7],
                 [1,9,2,12,3,11,10,4,5,8,6,7],
                 [1,9,2,11,12,3,10,4,5,8,6,7],
                 [1,9,11,2,3,4,5,8,10,6,12,7],
                 [1,9,2,3,11,4,5,8,10,6,12,7],
                 [1,9,2,3,4,12,5,8,10,6,11,7],
                 [1,9,2,12,3,4,5,8,10,6,11,7],
                 [1,9,2,3,4,12,5,8,6,11,10,7],
                 [1,9,2,12,3,4,5,8,6,11,10,7],
                 [1,9,2,3,4,11,5,8,12,6,10,7],
                 [1,9,2,11,3,4,5,8,12,6,10,7],
                 [10,9,1,2,3,12,4,8,5,6,7,11],
                 [10,12,9,1,2,3,4,8,5,11,6,7],
                 [10,9,1,2,3,11,4,8,5,6,12,7],
                 [10,9,1,11,2,3,4,8,12,5,6,7],
                 [10,9,1,11,2,3,4,8,5,6,12,7],
                 [10,11,9,1,2,3,4,8,12,5,6,7],
                 [11,9,10,1,2,3,4,8,12,5,6,7],
                 [9,12,10,1,2,3,4,8,11,5,6,7],
                 [9,1,10,2,3,12,4,8,5,6,7,11],
                 [9,1,10,2,3,12,4,8,5,11,6,7],
                 [9,1,10,2,3,11,4,8,12,5,6,7],
                 [9,1,10,2,3,11,4,8,5,6,12,7],
                 [11,9,1,2,10,3,4,8,12,5,6,7],
                 [9,1,11,2,10,3,4,8,12,5,6,7],
                 [9,1,11,2,10,3,4,8,5,6,12,7],
                 [9,1,2,12,10,3,4,8,11,5,6,7],
                 [9,12,1,2,10,3,4,8,11,5,6,7],
                 [9,1,2,12,10,3,4,8,5,6,11,7],
                 [9,1,2,3,4,8,10,5,6,12,7,11],
                 [9,1,2,3,4,8,10,5,6,11,12,7],
                 [9,1,2,12,3,11,4,8,10,5,6,7],
                 [9,12,1,2,3,11,4,8,10,5,6,7],
                 [9,1,2,11,12,3,4,8,10,5,6,7],
                 [9,12,1,11,2,3,4,8,10,5,6,7],
                 [9,11,1,2,12,3,4,8,10,5,6,7],
                 [9,1,2,3,4,8,11,5,10,6,12,7],
                 [9,1,2,3,4,8,5,12,10,6,11,7],
                 [9,1,2,3,4,8,5,12,6,11,10,7],
                 [9,1,2,3,4,8,5,11,12,6,10,7],
                 [9,1,2,12,3,11,4,8,5,6,10,7],
                 [9,12,1,2,3,11,4,8,5,6,10,7],
                 [9,1,2,11,12,3,4,8,5,6,10,7],
                 [9,12,1,11,2,3,4,8,5,6,10,7],
                 [9,11,1,2,12,3,4,8,5,6,10,7],
                 [1,12,9,2,3,11,4,8,5,6,7,10],
                 [1,11,9,2,12,3,4,8,5,6,7,10],
                 [1,12,9,2,3,11,4,8,5,10,6,7],
                 [1,11,9,2,12,3,4,8,5,10,6,7],
                 [11,1,9,2,3,10,4,8,12,5,6,7],
                 [11,1,9,2,3,10,4,8,5,6,12,7],
                 [1,12,9,2,3,10,4,8,11,5,6,7],
                 [1,10,9,2,3,12,4,8,5,6,7,11],
                 [1,10,9,2,3,12,4,8,5,11,6,7],
                 [1,10,9,2,3,11,4,8,12,5,6,7],
                 [1,10,9,2,3,11,4,8,5,6,12,7],
                 [10,1,2,12,9,3,4,8,5,6,7,11],
                 [10,1,2,12,9,3,4,8,5,11,6,7],
                 [10,12,1,2,9,3,4,8,5,11,6,7],
                 [10,1,2,11,9,3,4,8,12,5,6,7],
                 [10,1,2,11,9,3,4,8,5,6,12,7],
                 [11,1,10,2,9,3,4,8,12,5,6,7],
                 [11,1,10,2,9,3,4,8,5,6,12,7],
                 [1,12,10,2,9,3,4,8,11,5,6,7],
                 [1,2,9,3,4,8,10,5,6,12,7,11],
                 [1,2,9,3,4,8,10,5,6,11,12,7],
                 [1,11,12,2,9,3,4,8,10,5,6,7],
                 [1,2,9,3,4,8,11,5,10,6,12,7],
                 [1,2,9,3,4,8,5,12,10,6,11,7],
                 [1,2,9,3,4,8,5,12,6,11,10,7],
                 [1,2,9,3,4,8,5,11,12,6,10,7],
                 [1,12,2,11,9,3,4,8,5,6,10,7],
                 [1,11,12,2,9,3,4,8,5,6,10,7],
                 [1,2,3,12,4,8,9,5,6,11,7,10],
                 [1,2,3,11,4,8,9,5,12,6,7,10],
                 [1,2,3,11,4,8,9,5,6,7,12,10],
                 [1,11,2,3,4,8,9,5,12,6,7,10],
                 [1,11,2,3,4,8,9,5,6,7,12,10],
                 [11,1,2,3,4,8,9,5,6,10,12,7],
                 [1,2,11,3,4,8,9,5,6,10,12,7],
                 [1,2,3,12,4,8,9,5,6,10,11,7],
                 [1,2,3,10,4,8,9,5,6,12,7,11],
                 [1,2,3,10,4,8,9,5,6,11,12,7],
                 [1,11,12,2,3,10,4,8,9,5,6,7],
                 [11,1,2,10,12,3,4,8,9,5,6,7],
                 [1,12,2,10,11,3,4,8,9,5,6,7],
                 [1,10,2,3,4,8,9,5,6,12,7,11],
                 [1,10,2,3,4,8,9,5,6,11,12,7],
                 [1,10,2,12,3,11,4,8,9,5,6,7],
                 [1,10,2,11,12,3,4,8,9,5,6,7],
                 [10,1,2,3,4,8,5,12,9,6,7,11],
                 [10,1,2,3,4,8,5,11,9,6,12,7],
                 [1,2,10,3,4,8,5,12,9,6,7,11],
                 [1,2,10,3,4,8,5,11,9,6,12,7],
                 [11,1,2,3,4,8,10,5,9,6,12,7],
                 [1,2,11,3,4,8,10,5,9,6,12,7],
                 [1,2,3,12,4,8,10,5,9,6,11,7],
                 [1,2,3,12,4,8,5,11,9,6,10,7],
                 [1,2,3,11,4,8,12,5,9,6,10,7],
                 [1,11,2,3,4,8,12,5,9,6,10,7],
                 [1,2,3,12,4,8,5,6,9,7,10,11],
                 [1,2,3,11,4,8,5,6,9,7,12,10],
                 [1,11,2,3,4,8,5,6,9,7,12,10],
                 [1,2,3,12,4,8,5,11,6,10,9,7],
                 [1,2,3,11,4,8,12,5,6,10,9,7],
                 [1,11,2,3,4,8,12,5,6,10,9,7],
                 [11,1,2,3,4,8,5,10,12,6,9,7],
                 [1,2,11,3,4,8,5,10,12,6,9,7],
                 [1,2,3,12,4,8,5,10,11,6,9,7],
                 [1,2,3,10,4,8,5,12,6,11,9,7],
                 [1,2,3,10,4,8,5,11,12,6,9,7],
                 [1,12,2,11,3,10,4,8,5,6,9,7],
                 [1,11,12,2,3,10,4,8,5,6,9,7],
                 [11,1,2,10,12,3,4,8,5,6,9,7],
                 [1,12,2,10,11,3,4,8,5,6,9,7],
                 [1,10,2,3,4,8,5,12,6,11,9,7],
                 [1,10,2,3,4,8,5,11,12,6,9,7],
                 [1,10,2,12,3,11,4,8,5,6,9,7],
                 [1,10,2,11,12,3,4,8,5,6,9,7],
                 [1,2,3,8,4,5,6,11,7,9,12,10],
                 [1,2,3,8,4,11,5,6,12,7,9,10],
                 [1,2,3,8,4,11,5,6,7,9,12,10],
                 [1,2,3,8,11,4,5,6,7,10,12,9],
                 [1,2,3,8,4,5,11,6,7,10,12,9],
                 [1,2,3,8,4,5,6,12,7,10,11,9],
                 [1,2,3,8,4,12,5,6,7,10,11,9],
                 [1,2,3,8,4,11,12,5,6,10,7,9],
                 [1,12,2,11,3,8,4,5,6,10,7,9],
                 [1,11,12,2,3,8,4,5,6,10,7,9],
                 [1,2,3,8,11,4,5,10,12,6,7,9],
                 [1,2,3,8,11,4,5,10,6,7,12,9],
                 [1,2,3,8,4,12,5,10,6,7,11,9],
                 [1,2,3,8,4,10,5,12,6,7,9,11],
                 [1,2,3,8,4,10,5,12,6,11,7,9],
                 [1,2,3,8,4,10,5,11,12,6,7,9],
                 [1,2,3,8,4,10,5,11,6,7,12,9],
                 [1,12,2,11,3,8,4,10,5,6,7,9],
                 [1,11,12,2,3,8,4,10,5,6,7,9],
                 [11,1,2,10,3,8,12,4,5,6,7,9],
                 [11,1,2,10,3,8,4,5,12,6,7,9],
                 [1,12,2,10,3,8,11,4,5,6,7,9],
                 [1,12,2,10,3,8,4,5,11,6,7,9],
                 [1,10,2,12,3,8,4,5,6,7,9,11],
                 [1,10,2,12,3,8,4,5,6,11,7,9],
                 [1,10,2,12,3,8,4,11,5,6,7,9],
                 [1,10,2,11,3,8,12,4,5,6,7,9],
                 [1,10,2,11,3,8,4,5,12,6,7,9],
                 [10,1,2,12,3,8,4,5,6,9,7,11],
                 [10,1,2,11,3,8,4,5,6,9,12,7],
                 [11,1,10,2,3,8,4,5,6,9,12,7],
                 [1,2,3,8,10,4,5,12,6,9,7,11],
                 [1,2,3,8,10,4,5,11,6,9,12,7],
                 [1,2,3,8,11,4,10,5,6,9,12,7],
                 [1,2,3,8,4,11,12,5,6,9,10,7],
                 [1,12,2,11,3,8,4,5,6,9,10,7],
                 [1,11,12,2,3,8,4,5,6,9,10,7],
                 [1,2,3,8,4,11,5,9,12,6,7,10],
                 [1,2,3,8,4,11,5,9,6,7,12,10],
                 [1,2,3,8,11,4,5,9,6,10,12,7],
                 [1,2,3,8,4,10,5,9,6,12,7,11],
                 [1,2,3,8,4,10,5,9,6,11,12,7],
                 [1,11,12,2,3,8,4,10,5,9,6,7],
                 [11,1,2,10,3,8,12,4,5,9,6,7],
                 [1,10,2,12,3,8,4,11,5,9,6,7],
                 [1,10,2,11,3,8,12,4,5,9,6,7],
                 [10,1,2,12,3,8,4,9,5,6,7,11],
                 [10,1,2,12,3,8,4,9,5,11,6,7],
                 [10,12,1,2,3,8,4,9,5,11,6,7],
                 [10,1,2,11,3,8,4,9,12,5,6,7],
                 [11,1,10,2,3,8,4,9,12,5,6,7],
                 [1,2,3,8,4,9,10,5,6,12,7,11],
                 [1,2,3,8,4,9,10,5,6,11,12,7],
                 [1,11,12,2,3,8,4,9,10,5,6,7],
                 [1,2,3,8,4,9,11,5,10,6,12,7],
                 [1,2,3,8,4,9,5,12,10,6,11,7],
                 [1,2,3,8,4,9,5,12,6,11,10,7],
                 [1,2,3,8,4,9,5,11,12,6,10,7],
                 [1,12,2,11,3,8,4,9,5,6,10,7],
                 [1,11,12,2,3,8,4,9,5,6,10,7],
                 [1,12,2,9,3,8,4,5,6,11,7,10],
                 [1,12,2,9,3,8,4,11,5,6,7,10],
                 [1,11,2,9,3,8,12,4,5,6,7,10],
                 [1,11,2,9,3,8,4,5,12,6,7,10],
                 [11,1,2,9,3,8,4,5,6,10,12,7],
                 [1,12,2,9,3,8,4,11,5,10,6,7],
                 [1,11,2,9,3,8,12,4,5,10,6,7],
                 [11,1,2,9,3,8,4,10,12,5,6,7],
                 [1,12,2,9,3,8,4,10,11,5,6,7],
                 [1,10,2,9,3,8,4,5,6,12,7,11],
                 [1,10,2,9,3,8,4,12,5,6,7,11],
                 [1,10,2,9,3,8,4,5,6,11,12,7],
                 [1,10,2,9,3,8,4,12,5,11,6,7],
                 [1,10,2,9,3,8,4,11,12,5,6,7],
                 [1,9,10,2,3,8,4,5,6,12,7,11],
                 [1,9,10,2,3,8,4,12,5,6,7,11],
                 [1,9,10,2,3,8,4,5,6,11,12,7],
                 [1,9,10,2,3,8,4,12,5,11,6,7],
                 [1,9,10,2,3,8,4,11,12,5,6,7],
                 [1,9,11,2,3,8,10,4,12,5,6,7],
                 [1,9,2,12,3,8,10,4,11,5,6,7],
                 [1,9,2,12,3,8,10,4,5,6,11,7],
                 [1,9,2,12,3,8,4,11,10,5,6,7],
                 [1,9,2,11,3,8,12,4,10,5,6,7],
                 [1,9,11,2,3,8,4,5,10,6,12,7],
                 [1,9,2,12,3,8,4,5,10,6,11,7],
                 [1,9,2,12,3,8,4,5,6,11,10,7],
                 [1,9,2,12,3,8,4,11,5,6,10,7],
                 [1,9,2,11,3,8,12,4,5,6,10,7],
                 [1,9,2,11,3,8,4,5,12,6,10,7],
                 [9,1,2,8,10,3,4,5,6,12,7,11],
                 [9,1,2,8,10,3,4,12,5,6,7,11],
                 [9,1,2,8,10,3,4,5,6,11,12,7],
                 [9,1,2,8,10,3,4,12,5,11,6,7],
                 [9,1,2,8,10,3,4,11,12,5,6,7],
                 [9,1,2,8,3,12,10,4,11,5,6,7],
                 [9,1,2,8,3,12,10,4,5,6,11,7],
                 [1,12,2,8,9,3,4,5,6,11,7,10],
                 [1,12,2,8,9,3,4,11,5,6,7,10],
                 [1,11,2,8,9,3,12,4,5,6,7,10],
                 [1,11,2,8,9,3,4,5,12,6,7,10],
                 [11,1,2,8,9,3,4,5,6,10,12,7],
                 [1,12,2,8,9,3,4,11,5,10,6,7],
                 [1,11,2,8,9,3,12,4,5,10,6,7],
                 [11,1,2,8,9,3,4,10,12,5,6,7],
                 [1,12,2,8,9,3,4,10,11,5,6,7],
                 [1,10,2,8,9,3,4,12,5,6,7,11],
                 [1,10,2,8,9,3,4,5,6,11,12,7],
                 [1,10,2,8,9,3,4,12,5,11,6,7],
                 [1,10,2,8,9,3,4,11,12,5,6,7],
                 [10,1,2,8,3,12,9,4,5,6,7,11],
                 [10,1,2,8,3,12,9,4,5,11,6,7],
                 [10,1,2,8,3,11,9,4,12,5,6,7],
                 [11,1,2,8,10,3,9,4,12,5,6,7],
                 [1,12,2,8,10,3,9,4,11,5,6,7],
                 [1,12,2,8,3,11,9,4,10,5,6,7],
                 [1,11,2,8,12,3,9,4,10,5,6,7],
                 [1,12,2,8,3,11,9,4,5,6,10,7],
                 [1,11,2,8,12,3,9,4,5,6,10,7],
                 [1,11,2,8,3,4,9,5,12,6,7,10],
                 [1,11,2,8,3,4,9,5,6,7,12,10],
                 [11,1,2,8,3,4,9,5,6,10,12,7],
                 [1,12,2,8,3,11,4,10,9,5,6,7],
                 [1,11,2,8,12,3,4,10,9,5,6,7],
                 [11,1,2,8,3,10,12,4,9,5,6,7],
                 [1,10,2,8,3,4,9,5,6,11,12,7],
                 [1,10,2,8,3,12,4,11,9,5,6,7],
                 [1,10,2,8,3,11,12,4,9,5,6,7],
                 [10,1,2,8,3,4,5,12,9,6,7,11],
                 [10,1,2,8,3,12,4,5,9,6,7,11],
                 [10,1,2,8,3,4,5,11,9,6,12,7],
                 [10,1,2,8,3,11,4,5,9,6,12,7],
                 [11,1,2,8,10,3,4,5,9,6,12,7],
                 [11,1,2,8,3,4,10,5,9,6,12,7],
                 [1,12,2,8,3,11,4,5,9,6,10,7],
                 [1,11,2,8,12,3,4,5,9,6,10,7],
                 [1,11,2,8,3,4,12,5,9,6,10,7],
                 [1,11,2,8,3,4,5,6,9,7,12,10],
                 [1,12,2,8,3,11,4,5,6,10,9,7],
                 [1,11,2,8,12,3,4,5,6,10,9,7],
                 [1,11,2,8,3,4,12,5,6,10,9,7],
                 [11,1,2,8,3,4,5,10,12,6,9,7],
                 [1,12,2,8,3,11,4,10,5,6,9,7],
                 [1,11,2,8,12,3,4,10,5,6,9,7],
                 [11,1,2,8,3,10,12,4,5,6,9,7],
                 [11,1,2,8,3,10,4,5,12,6,9,7],
                 [1,12,2,8,3,10,11,4,5,6,9,7],
                 [1,12,2,8,3,10,4,5,11,6,9,7],
                 [1,10,2,8,3,4,5,12,6,11,9,7],
                 [1,10,2,8,3,12,4,5,6,11,9,7],
                 [1,10,2,8,3,4,5,11,12,6,9,7],
                 [1,10,2,8,3,12,4,11,5,6,9,7],
                 [1,10,2,8,3,11,12,4,5,6,9,7],
                 [1,10,2,8,3,11,4,5,12,6,9,7],
                 [1,8,2,12,3,4,5,6,7,9,10,11],
                 [1,8,2,3,4,5,6,11,7,9,12,10],
                 [1,8,2,3,4,11,5,6,7,9,12,10],
                 [1,8,2,11,3,4,5,6,7,9,12,10],
                 [1,8,2,12,3,4,5,11,6,10,7,9],
                 [1,8,2,12,3,11,4,5,6,10,7,9],
                 [1,8,2,11,12,3,4,5,6,10,7,9],
                 [1,8,2,11,3,4,12,5,6,10,7,9],
                 [1,8,11,2,3,4,5,10,12,6,7,9],
                 [1,8,2,12,3,4,5,10,11,6,7,9],
                 [1,8,2,12,3,11,4,10,5,6,7,9],
                 [1,8,2,11,12,3,4,10,5,6,7,9],
                 [1,8,11,2,3,10,12,4,5,6,7,9],
                 [1,8,11,2,3,10,4,5,12,6,7,9],
                 [1,8,2,12,3,10,11,4,5,6,7,9],
                 [1,8,2,12,3,10,4,5,11,6,7,9],
                 [1,8,2,10,3,4,5,12,6,11,7,9],
                 [1,8,2,10,3,12,4,5,6,11,7,9],
                 [1,8,2,10,3,4,5,11,12,6,7,9],
                 [1,8,2,10,3,12,4,11,5,6,7,9],
                 [1,8,2,10,3,11,12,4,5,6,7,9],
                 [1,8,2,10,3,11,4,5,12,6,7,9],
                 [1,8,10,2,3,4,5,12,6,9,7,11],
                 [1,8,10,2,3,12,4,5,6,9,7,11],
                 [1,8,10,2,3,4,5,11,6,9,12,7],
                 [1,8,10,2,3,11,4,5,6,9,12,7],
                 [1,8,11,2,10,3,4,5,6,9,12,7],
                 [1,8,2,12,10,3,4,5,6,9,11,7],
                 [1,8,11,2,3,4,10,5,6,9,12,7],
                 [1,8,2,12,3,4,10,5,6,9,11,7],
                 [1,8,2,12,3,4,5,11,6,9,10,7],
                 [1,8,2,12,3,11,4,5,6,9,10,7],
                 [1,8,2,11,12,3,4,5,6,9,10,7],
                 [1,8,2,11,3,4,12,5,6,9,10,7],
                 [1,8,2,12,3,4,5,9,6,7,10,11],
                 [1,8,2,12,3,4,5,9,6,11,7,10],
                 [1,8,2,3,4,11,5,9,6,7,12,10],
                 [1,8,2,11,3,4,5,9,12,6,7,10],
                 [1,8,2,11,3,4,5,9,6,7,12,10],
                 [1,8,11,2,3,4,5,9,6,10,12,7],
                 [1,8,2,12,3,4,5,9,6,10,11,7],
                 [1,8,2,12,3,11,4,10,5,9,6,7],
                 [1,8,2,11,12,3,4,10,5,9,6,7],
                 [1,8,11,2,3,10,12,4,5,9,6,7],
                 [1,8,2,12,3,10,11,4,5,9,6,7],
                 [1,8,2,10,3,4,5,9,6,11,12,7],
                 [1,8,2,10,3,12,4,11,5,9,6,7],
                 [1,8,2,10,3,11,12,4,5,9,6,7],
                 [10,12,1,8,2,3,4,9,5,11,6,7],
                 [10,11,1,8,2,3,4,9,12,5,6,7],
                 [1,8,10,2,3,12,4,9,5,6,7,11],
                 [1,8,10,2,3,12,4,9,5,11,6,7],
                 [1,8,10,2,3,11,4,9,12,5,6,7],
                 [1,8,11,2,10,3,4,9,12,5,6,7],
                 [1,8,2,12,10,3,4,9,11,5,6,7],
                 [1,8,2,12,10,3,4,9,5,6,11,7],
                 [1,8,2,3,4,9,10,5,6,11,12,7],
                 [1,8,2,12,3,11,4,9,10,5,6,7],
                 [1,8,2,11,12,3,4,9,10,5,6,7],
                 [1,8,2,3,4,9,11,5,10,6,12,7],
                 [1,8,2,3,4,9,5,11,12,6,10,7],
                 [1,8,2,12,3,11,4,9,5,6,10,7],
                 [1,8,2,11,12,3,4,9,5,6,10,7],
                 [1,8,2,12,3,9,4,5,6,11,7,10],
                 [1,8,2,12,3,9,4,11,5,6,7,10],
                 [1,8,2,11,3,9,12,4,5,6,7,10],
                 [1,8,2,11,3,9,4,5,12,6,7,10],
                 [1,8,11,2,3,9,4,5,6,10,12,7],
                 [1,8,2,12,3,9,4,5,6,10,11,7],
                 [1,8,2,12,3,9,4,11,5,10,6,7],
                 [1,8,2,11,3,9,12,4,5,10,6,7],
                 [1,8,2,12,3,9,4,10,11,5,6,7],
                 [1,8,2,12,3,9,4,10,5,6,11,7],
                 [1,8,2,10,3,9,4,12,5,6,7,11],
                 [1,8,2,10,3,9,4,5,6,11,12,7],
                 [1,8,2,10,3,9,4,12,5,11,6,7],
                 [8,1,2,12,3,4,5,7,6,9,10,11],
                 [8,1,2,12,3,4,5,7,6,11,9,10],
                 [8,1,2,3,4,11,5,7,6,9,12,10],
                 [8,1,2,11,3,4,5,7,12,6,9,10],
                 [8,1,2,11,3,4,5,7,6,9,12,10],
                 [8,1,11,2,3,4,5,7,6,10,12,9],
                 [8,1,2,3,11,4,5,7,6,10,12,9],
                 [8,1,2,3,4,12,5,7,6,10,11,9],
                 [8,1,2,12,3,4,5,7,6,10,11,9],
                 [8,1,2,12,3,11,4,10,5,7,6,9],
                 [8,12,1,2,3,11,4,10,5,7,6,9],
                 [8,1,2,11,12,3,4,10,5,7,6,9],
                 [8,12,1,11,2,3,4,10,5,7,6,9],
                 [8,11,1,2,12,3,4,10,5,7,6,9],
                 [11,8,1,2,3,10,12,4,5,7,6,9],
                 [8,1,11,2,3,10,12,4,5,7,6,9],
                 [8,1,2,12,3,10,11,4,5,7,6,9],
                 [8,12,1,2,3,10,11,4,5,7,6,9],
                 [8,1,2,10,3,12,4,11,5,7,6,9],
                 [8,1,2,10,3,11,12,4,5,7,6,9],
                 [8,12,1,11,2,10,3,4,5,7,6,9],
                 [11,8,1,10,12,2,3,4,5,7,6,9],
                 [11,8,1,10,2,3,12,4,5,7,6,9],
                 [8,12,1,10,11,2,3,4,5,7,6,9],
                 [8,12,1,10,2,3,11,4,5,7,6,9],
                 [8,10,1,2,3,12,4,11,5,7,6,9],
                 [8,10,1,2,3,11,12,4,5,7,6,9],
                 [8,10,1,12,2,11,3,4,5,7,6,9],
                 [8,10,1,11,12,2,3,4,5,7,6,9],
                 [8,10,1,11,2,3,12,4,5,7,6,9],
                 [10,8,1,2,3,12,4,9,5,7,6,11],
                 [10,8,1,2,3,11,4,9,5,7,12,6],
                 [10,8,1,11,2,3,4,9,5,7,12,6],
                 [8,1,10,2,3,12,4,9,5,7,6,11],
                 [8,1,10,2,3,11,4,9,5,7,12,6],
                 [8,1,11,2,10,3,4,9,5,7,12,6],
                 [8,1,2,12,10,3,4,9,5,7,11,6],
                 [8,1,2,12,3,11,4,9,5,7,10,6],
                 [8,12,1,2,3,11,4,9,5,7,10,6],
                 [8,1,2,11,12,3,4,9,5,7,10,6],
                 [8,12,1,11,2,3,4,9,5,7,10,6],
                 [8,11,1,2,12,3,4,9,5,7,10,6],
                 [8,1,2,12,3,9,4,11,5,7,6,10],
                 [8,12,1,2,3,9,4,11,5,7,6,10],
                 [8,1,2,11,3,9,12,4,5,7,6,10],
                 [8,11,1,2,3,9,12,4,5,7,6,10],
                 [8,1,11,2,3,9,4,10,5,7,12,6],
                 [8,1,2,12,3,9,4,10,5,7,11,6],
                 [8,1,2,10,3,9,4,12,5,7,6,11],
                 [8,1,2,10,3,9,4,11,5,7,12,6],
                 [8,10,1,2,3,9,4,12,5,7,6,11],
                 [8,10,1,2,3,9,4,11,5,7,12,6],
                 [10,8,1,11,2,9,3,4,5,7,12,6],
                 [8,1,2,9,10,3,4,12,5,7,6,11],
                 [8,1,2,9,10,3,4,11,5,7,12,6],
                 [8,1,2,9,11,3,10,4,5,7,12,6],
                 [8,1,2,9,3,12,10,4,5,7,11,6],
                 [8,1,2,9,3,12,4,11,5,7,10,6],
                 [8,1,2,9,3,11,12,4,5,7,10,6],
                 [8,12,1,11,2,9,3,4,5,7,10,6],
                 [8,12,1,9,2,3,4,11,5,7,6,10],
                 [8,12,1,9,2,11,3,4,5,7,6,10],
                 [8,11,1,9,12,2,3,4,5,7,6,10],
                 [8,11,1,9,2,3,12,4,5,7,6,10],
                 [8,10,1,9,2,3,4,12,5,7,6,11],
                 [8,10,1,9,2,12,3,4,5,7,6,11],
                 [8,10,1,9,2,3,4,11,5,7,12,6],
                 [8,10,1,9,2,11,3,4,5,7,12,6],
                 [8,9,10,1,2,3,4,12,5,7,6,11],
                 [8,9,10,1,2,12,3,4,5,7,6,11],
                 [8,9,10,1,2,3,4,11,5,7,12,6],
                 [8,9,10,1,2,11,3,4,5,7,12,6],
                 [8,9,11,1,10,2,3,4,5,7,12,6],
                 [8,9,11,1,2,3,10,4,5,7,12,6],
                 [8,9,1,11,12,2,3,4,5,7,10,6],
                 [8,9,1,11,2,3,12,4,5,7,10,6],
                 [10,9,1,11,8,2,3,4,5,7,12,6],
                 [9,1,8,2,10,3,4,12,5,7,6,11],
                 [9,1,8,2,10,3,4,11,5,7,12,6],
                 [9,1,8,2,11,3,10,4,5,7,12,6],
                 [9,1,8,2,3,12,10,4,5,7,11,6],
                 [9,1,8,2,3,12,4,11,5,7,10,6],
                 [9,1,8,2,3,11,12,4,5,7,10,6],
                 [9,12,1,11,8,2,3,4,5,7,10,6],
                 [1,11,8,2,9,3,12,4,5,7,6,10],
                 [11,1,8,2,9,3,4,10,5,7,12,6],
                 [1,10,8,2,9,3,4,12,5,7,6,11],
                 [1,10,8,2,9,3,4,11,5,7,12,6],
                 [10,1,8,2,3,12,9,4,5,7,6,11],
                 [10,1,8,2,3,11,9,4,5,7,12,6],
                 [11,1,8,2,10,3,9,4,5,7,12,6],
                 [1,11,8,2,12,3,9,4,5,7,10,6],
                 [1,11,8,2,3,4,5,7,9,6,12,10],
                 [1,11,8,2,12,3,4,10,5,7,9,6],
                 [1,10,8,2,3,12,4,11,5,7,9,6],
                 [1,10,8,2,3,11,12,4,5,7,9,6],
                 [1,2,8,3,4,11,5,7,6,9,12,10],
                 [1,2,8,3,11,4,5,7,6,10,12,9],
                 [1,2,8,3,4,12,5,7,6,10,11,9],
                 [1,11,12,2,8,3,4,10,5,7,6,9],
                 [11,1,2,10,8,3,12,4,5,7,6,9],
                 [1,10,2,12,8,3,4,11,5,7,6,9],
                 [1,10,2,11,8,3,12,4,5,7,6,9],
                 [10,1,2,12,8,3,4,9,5,7,6,11],
                 [10,1,2,11,8,3,4,9,5,7,12,6],
                 [11,1,10,2,8,3,4,9,5,7,12,6],
                 [1,11,12,2,8,3,4,9,5,7,10,6],
                 [1,11,2,9,8,3,12,4,5,7,6,10],
                 [11,1,2,9,8,3,4,10,5,7,12,6],
                 [1,10,2,9,8,3,4,12,5,7,6,11],
                 [1,10,2,9,8,3,4,11,5,7,12,6],
                 [1,9,10,2,8,3,4,12,5,7,6,11],
                 [1,9,10,2,8,3,4,11,5,7,12,6],
                 [1,9,11,2,8,3,10,4,5,7,12,6],
                 [1,9,2,12,8,3,10,4,5,7,11,6],
                 [1,9,2,12,8,3,4,11,5,7,10,6],
                 [1,9,2,11,8,3,12,4,5,7,10,6],
                 [9,1,10,2,3,12,8,4,5,7,6,11],
                 [9,1,10,2,3,11,8,4,5,7,12,6],
                 [9,1,11,2,10,3,8,4,5,7,12,6],
                 [9,1,2,12,10,3,8,4,5,7,11,6],
                 [9,1,2,12,3,11,8,4,5,7,10,6],
                 [9,12,1,2,3,11,8,4,5,7,10,6],
                 [9,1,2,11,12,3,8,4,5,7,10,6],
                 [9,12,1,11,2,3,8,4,5,7,10,6],
                 [9,11,1,2,12,3,8,4,5,7,10,6],
                 [1,10,9,2,3,12,8,4,5,7,6,11],
                 [1,10,9,2,3,11,8,4,5,7,12,6],
                 [10,1,2,12,9,3,8,4,5,7,6,11],
                 [10,1,2,11,9,3,8,4,5,7,12,6],
                 [11,1,10,2,9,3,8,4,5,7,12,6],
                 [1,11,12,2,9,3,8,4,5,7,10,6],
                 [1,2,3,11,8,4,5,7,9,6,12,10],
                 [1,11,2,3,8,4,5,7,9,6,12,10],
                 [1,11,12,2,3,10,8,4,5,7,9,6],
                 [11,1,2,10,12,3,8,4,5,7,9,6],
                 [1,10,2,12,3,11,8,4,5,7,9,6],
                 [1,10,2,11,12,3,8,4,5,7,9,6],
                 [1,11,12,2,3,4,5,7,8,6,9,10],
                 [11,1,2,3,4,10,5,7,8,6,12,9],
                 [1,2,11,3,4,10,5,7,8,6,12,9],
                 [1,2,3,12,4,10,5,7,8,6,11,9],
                 [1,2,3,10,4,12,5,7,8,6,9,11],
                 [1,2,3,10,4,11,5,7,8,6,12,9],
                 [11,1,2,10,3,4,5,7,8,6,12,9],
                 [1,10,2,3,4,12,5,7,8,6,9,11],
                 [1,10,2,12,3,4,5,7,8,6,9,11],
                 [1,10,2,3,4,11,5,7,8,6,12,9],
                 [1,10,2,11,3,4,5,7,8,6,12,9],
                 [1,2,3,11,4,9,5,7,8,6,12,10],
                 [1,11,2,3,4,9,5,7,8,6,12,10],
                 [1,11,12,2,3,10,4,9,5,7,8,6],
                 [1,10,2,12,3,11,4,9,5,7,8,6],
                 [1,10,2,11,12,3,4,9,5,7,8,6],
                 [10,1,2,12,3,9,4,11,5,7,8,6],
                 [10,12,1,2,3,9,4,11,5,7,8,6],
                 [10,1,2,11,3,9,12,4,5,7,8,6],
                 [1,11,12,2,3,9,10,4,5,7,8,6],
                 [1,11,2,9,3,4,5,7,8,6,12,10],
                 [1,10,2,9,3,12,4,11,5,7,8,6],
                 [1,10,2,9,3,11,12,4,5,7,8,6],
                 [10,12,1,9,2,3,4,11,5,7,8,6],
                 [10,12,1,9,2,11,3,4,5,7,8,6],
                 [10,11,1,9,12,2,3,4,5,7,8,6],
                 [10,11,1,9,2,3,12,4,5,7,8,6],
                 [1,9,10,2,3,12,4,11,5,7,8,6],
                 [1,9,10,2,3,11,12,4,5,7,8,6],
                 [1,9,11,2,10,3,12,4,5,7,8,6],
                 [1,9,2,12,10,3,11,4,5,7,8,6],
                 [1,9,2,12,3,11,10,4,5,7,8,6],
                 [1,9,2,11,12,3,10,4,5,7,8,6],
                 [1,2,3,12,4,7,5,6,8,11,9,10],
                 [11,1,2,3,4,7,5,6,8,10,12,9],
                 [1,2,11,3,4,7,5,6,8,10,12,9],
                 [1,2,3,12,4,7,5,6,8,10,11,9],
                 [11,1,2,3,4,7,5,10,6,8,12,9],
                 [1,2,11,3,4,7,5,10,6,8,12,9],
                 [1,2,3,12,4,7,5,10,6,8,11,9],
                 [1,2,3,10,4,7,5,12,6,8,9,11],
                 [1,2,3,10,4,7,5,11,6,8,12,9],
                 [1,10,2,3,4,7,5,12,6,8,9,11],
                 [1,10,2,3,4,7,5,12,6,11,8,9],
                 [1,10,2,3,4,7,5,11,12,6,8,9],
                 [1,10,2,3,4,7,5,11,6,8,12,9],
                 [10,1,2,3,4,7,5,12,6,9,8,11],
                 [10,1,2,3,4,7,5,11,6,9,12,8],
                 [1,2,10,3,4,7,5,12,6,9,8,11],
                 [1,2,10,3,4,7,5,11,6,9,12,8],
                 [11,1,2,3,4,7,10,5,6,9,12,8],
                 [1,2,11,3,4,7,10,5,6,9,12,8],
                 [1,2,3,12,4,7,10,5,6,9,11,8],
                 [1,2,3,12,4,7,5,11,6,9,10,8],
                 [1,2,3,11,4,7,12,5,6,9,10,8],
                 [1,11,2,3,4,7,12,5,6,9,10,8],
                 [1,2,3,12,4,7,5,9,6,11,8,10],
                 [1,2,3,11,4,7,5,9,12,6,8,10],
                 [1,2,3,11,4,7,5,9,6,8,12,10],
                 [1,11,2,3,4,7,5,9,12,6,8,10],
                 [1,11,2,3,4,7,5,9,6,8,12,10],
                 [11,1,2,3,4,7,5,9,6,10,12,8],
                 [1,2,11,3,4,7,5,9,6,10,12,8],
                 [1,2,3,12,4,7,5,9,6,10,11,8],
                 [1,10,2,12,3,11,4,7,5,9,6,8],
                 [1,10,2,11,12,3,4,7,5,9,6,8],
                 [10,1,2,12,3,9,4,7,5,11,6,8],
                 [10,12,1,2,3,9,4,7,5,11,6,8],
                 [10,1,2,11,3,9,4,7,12,5,6,8],
                 [1,2,3,9,4,7,11,5,10,6,12,8],
                 [1,2,3,9,4,7,5,12,10,6,11,8],
                 [1,2,3,9,4,7,5,12,6,11,10,8],
                 [1,2,3,9,4,7,5,11,12,6,10,8],
                 [1,12,2,11,3,9,4,7,5,6,10,8],
                 [1,11,12,2,3,9,4,7,5,6,10,8],
                 [1,12,2,9,3,11,4,7,5,6,8,10],
                 [1,11,2,9,12,3,4,7,5,6,8,10],
                 [1,10,2,9,3,12,4,7,5,11,6,8],
                 [1,10,2,9,3,11,4,7,12,5,6,8],
                 [10,12,1,9,2,3,4,7,5,11,6,8],
                 [10,11,1,9,2,3,4,7,12,5,6,8],
                 [1,9,10,2,3,12,4,7,5,11,6,8],
                 [1,9,10,2,3,11,4,7,12,5,6,8],
                 [1,9,11,2,10,3,4,7,12,5,6,8],
                 [1,9,2,12,10,3,4,7,11,5,6,8],
                 [1,9,2,12,3,11,4,7,10,5,6,8],
                 [1,9,2,11,12,3,4,7,10,5,6,8],
                 [1,9,2,3,4,7,11,5,10,6,12,8],
                 [1,9,2,3,4,7,5,12,10,6,11,8],
                 [1,9,2,3,4,7,5,12,6,11,10,8],
                 [1,9,2,3,4,7,5,11,12,6,10,8],
                 [1,9,2,12,3,11,4,7,5,6,10,8],
                 [1,9,2,11,12,3,4,7,5,6,10,8],
                 [9,1,10,2,3,12,4,7,5,8,6,11],
                 [9,1,10,2,3,11,4,7,5,8,12,6],
                 [9,1,11,2,10,3,4,7,5,8,12,6],
                 [9,1,2,12,10,3,4,7,5,8,11,6],
                 [9,1,2,12,3,11,4,7,5,8,10,6],
                 [9,12,1,2,3,11,4,7,5,8,10,6],
                 [9,1,2,11,12,3,4,7,5,8,10,6],
                 [9,12,1,11,2,3,4,7,5,8,10,6],
                 [9,11,1,2,12,3,4,7,5,8,10,6],
                 [1,10,9,2,3,12,4,7,5,8,6,11],
                 [1,10,9,2,3,11,4,7,5,8,12,6],
                 [10,1,2,11,9,3,4,7,5,8,12,6],
                 [1,2,3,11,4,7,5,8,9,6,12,10],
                 [1,11,2,3,4,7,5,8,9,6,12,10],
                 [1,10,2,11,12,3,4,7,5,8,9,6],
                 [1,2,3,8,4,7,5,11,6,9,12,10],
                 [1,2,3,8,4,7,11,5,6,10,12,9],
                 [1,2,3,8,4,7,5,12,6,10,11,9],
                 [1,10,2,9,3,8,4,7,5,12,6,11],
                 [1,10,2,9,3,8,4,7,5,11,12,6],
                 [1,9,10,2,3,8,4,7,5,12,6,11],
                 [1,9,10,2,3,8,4,7,5,11,12,6],
                 [1,9,11,2,3,8,4,7,10,5,12,6],
                 [1,9,2,12,3,8,4,7,10,5,11,6],
                 [1,9,2,12,3,8,4,7,5,11,10,6],
                 [1,9,2,11,3,8,4,7,12,5,10,6],
                 [9,1,2,8,10,3,4,7,5,12,6,11],
                 [9,1,2,8,10,3,4,7,5,11,12,6],
                 [9,1,2,8,11,3,4,7,10,5,12,6],
                 [9,1,2,8,3,12,4,7,10,5,11,6],
                 [9,1,2,8,3,12,4,7,5,11,10,6],
                 [9,1,2,8,3,11,4,7,12,5,10,6],
                 [1,10,2,8,9,3,4,7,5,12,6,11],
                 [1,10,2,8,9,3,4,7,5,11,12,6],
                 [10,1,2,8,3,12,4,7,9,5,6,11],
                 [10,1,2,8,3,11,4,7,9,5,12,6],
                 [1,10,2,8,3,12,4,7,5,11,9,6],
                 [1,8,2,3,4,7,5,11,6,9,12,10],
                 [1,8,2,3,4,7,11,5,6,10,12,9],
                 [1,8,2,3,4,7,5,12,6,10,11,9],
                 [1,8,2,12,3,11,4,7,5,10,6,9],
                 [1,8,2,11,12,3,4,7,5,10,6,9],
                 [1,8,11,2,3,10,4,7,12,5,6,9],
                 [1,8,2,12,3,10,4,7,11,5,6,9],
                 [1,8,2,10,3,12,4,7,5,11,6,9],
                 [1,8,2,10,3,11,4,7,12,5,6,9],
                 [1,8,10,2,3,12,4,7,5,9,6,11],
                 [1,8,10,2,3,11,4,7,5,9,12,6],
                 [1,8,11,2,10,3,4,7,5,9,12,6],
                 [1,8,2,12,10,3,4,7,5,9,11,6],
                 [1,8,2,12,3,11,4,7,5,9,10,6],
                 [1,8,2,11,12,3,4,7,5,9,10,6],
                 [1,8,2,12,3,9,4,7,5,11,6,10],
                 [1,8,2,11,3,9,4,7,12,5,6,10],
                 [1,8,11,2,3,9,4,7,5,10,12,6],
                 [1,8,2,12,3,9,4,7,5,10,11,6],
                 [1,8,2,10,3,9,4,7,5,12,6,11],
                 [1,8,2,10,3,9,4,7,5,11,12,6],
                 [1,8,2,9,10,3,4,7,5,12,6,11],
                 [1,8,2,9,10,3,4,7,5,11,12,6],
                 [1,8,2,9,11,3,4,7,10,5,12,6],
                 [1,8,2,9,3,12,4,7,10,5,11,6],
                 [1,8,2,9,3,12,4,7,5,11,10,6],
                 [1,8,2,9,3,11,4,7,12,5,10,6],
                 [8,1,2,12,3,7,4,5,6,9,10,11],
                 [8,1,2,12,3,7,4,5,6,11,9,10],
                 [8,1,2,11,3,7,4,5,6,9,12,10],
                 [8,1,11,2,3,7,4,5,6,10,12,9],
                 [8,1,2,12,3,7,4,5,6,10,11,9],
                 [8,1,2,12,3,7,4,11,5,10,6,9],
                 [8,1,2,11,3,7,12,4,5,10,6,9],
                 [8,1,11,2,3,7,4,10,12,5,6,9],
                 [8,1,2,12,3,7,4,10,11,5,6,9],
                 [8,1,2,10,3,7,4,12,5,11,6,9],
                 [8,1,2,10,3,7,4,11,12,5,6,9],
                 [8,12,1,11,2,10,3,7,4,5,6,9],
                 [11,8,1,10,12,2,3,7,4,5,6,9],
                 [8,12,1,10,11,2,3,7,4,5,6,9],
                 [8,10,1,2,3,7,4,12,5,6,9,11],
                 [8,10,1,2,3,7,4,11,5,6,12,9],
                 [8,10,1,12,2,11,3,7,4,5,6,9],
                 [8,10,1,11,12,2,3,7,4,5,6,9],
                 [8,1,10,2,3,7,4,12,5,9,6,11],
                 [8,1,10,2,3,7,4,11,5,9,12,6],
                 [8,1,11,2,3,7,10,4,5,9,12,6],
                 [8,1,2,12,3,7,10,4,5,9,11,6],
                 [8,1,2,12,3,7,4,11,5,9,10,6],
                 [8,1,2,11,3,7,12,4,5,9,10,6],
                 [8,1,2,12,3,7,4,9,5,11,6,10],
                 [8,1,2,11,3,7,4,9,12,5,6,10],
                 [8,1,11,2,3,7,4,9,5,10,12,6],
                 [8,1,2,12,3,7,4,9,5,10,11,6],
                 [8,1,2,10,3,7,4,9,5,12,6,11],
                 [8,1,2,10,3,7,4,9,5,11,12,6],
                 [8,10,1,12,2,11,3,7,4,9,5,6],
                 [8,10,1,11,12,2,3,7,4,9,5,6],
                 [10,8,1,12,2,9,3,7,4,11,5,6],
                 [10,8,1,11,2,9,3,7,12,4,5,6],
                 [10,8,1,11,2,9,3,7,4,5,12,6],
                 [8,1,2,9,3,7,10,4,5,12,6,11],
                 [8,1,2,9,3,7,10,4,5,11,12,6],
                 [8,1,2,9,3,7,11,4,10,5,12,6],
                 [8,1,2,9,3,7,4,12,10,5,11,6],
                 [8,1,2,9,3,7,4,12,5,11,10,6],
                 [8,1,2,9,3,7,4,11,12,5,10,6],
                 [8,12,1,11,2,9,3,7,4,5,10,6],
                 [8,12,1,9,2,11,3,7,4,5,6,10],
                 [8,11,1,9,12,2,3,7,4,5,6,10],
                 [8,10,1,9,2,12,3,7,4,5,6,11],
                 [8,10,1,9,2,12,3,7,4,11,5,6],
                 [8,10,1,9,2,11,3,7,12,4,5,6],
                 [8,10,1,9,2,11,3,7,4,5,12,6],
                 [9,1,8,2,3,7,10,4,5,12,6,11],
                 [9,1,8,2,3,7,10,4,5,11,12,6],
                 [9,1,8,2,3,7,11,4,10,5,12,6],
                 [9,1,8,2,3,7,4,12,10,5,11,6],
                 [9,1,8,2,3,7,4,12,5,11,10,6],
                 [9,12,1,11,8,2,3,7,4,5,10,6],
                 [1,11,8,2,3,7,4,5,9,6,12,10],
                 [1,2,3,7,8,4,5,11,6,9,12,10],
                 [1,2,3,7,8,4,11,5,6,10,12,9],
                 [1,2,3,7,8,4,5,12,6,10,11,9],
                 [1,9,10,2,3,7,8,4,5,12,6,11],
                 [1,9,10,2,3,7,8,4,5,11,12,6],
                 [1,9,11,2,3,7,8,4,10,5,12,6],
                 [1,9,2,12,3,7,8,4,10,5,11,6],
                 [1,9,2,12,3,7,8,4,5,11,10,6],
                 [1,9,2,11,3,7,8,4,12,5,10,6],
                 [9,1,11,2,3,7,10,4,8,5,12,6],
                 [9,1,2,12,3,7,10,4,8,5,11,6],
                 [9,1,2,12,3,7,4,11,8,5,10,6],
                 [9,12,1,2,3,7,4,11,8,5,10,6],
                 [9,1,2,11,3,7,12,4,8,5,10,6],
                 [9,11,1,2,3,7,12,4,8,5,10,6],
                 [1,2,3,7,4,11,8,5,9,6,12,10],
                 [1,2,3,7,11,4,5,10,8,6,12,9],
                 [1,2,3,7,4,12,5,10,8,6,11,9],
                 [1,2,3,7,4,10,5,12,8,6,9,11],
                 [1,2,3,7,4,10,5,11,8,6,12,9],
                 [11,1,2,10,3,7,4,5,8,6,12,9],
                 [1,10,2,12,3,7,4,5,8,6,9,11],
                 [1,10,2,11,3,7,4,5,8,6,12,9],
                 [1,2,3,7,4,11,5,9,8,6,12,10],
                 [10,12,1,2,3,7,4,9,5,11,8,6],
                 [1,11,2,9,3,7,4,5,8,6,12,10],
                 [10,12,1,9,2,11,3,7,4,5,8,6],
                 [10,11,1,9,12,2,3,7,4,5,8,6],
                 [1,9,2,12,3,7,10,4,11,5,8,6],
                 [1,9,2,12,3,7,4,11,10,5,8,6],
                 [11,1,2,7,3,4,5,10,6,8,12,9],
                 [11,1,2,7,3,10,4,5,6,8,12,9],
                 [1,10,2,7,3,4,5,12,6,8,9,11],
                 [1,10,2,7,3,12,4,5,6,8,9,11],
                 [1,10,2,7,3,4,5,11,6,8,12,9],
                 [1,10,2,7,3,11,4,5,6,8,12,9],
                 [1,11,2,7,3,4,5,9,6,8,12,10],
                 [1,12,2,7,3,9,4,11,5,6,8,10],
                 [1,11,2,7,3,9,12,4,5,6,8,10],
                 [1,11,2,7,3,9,4,5,12,6,8,10],
                 [1,11,2,7,3,9,4,5,6,8,12,10],
                 [11,1,2,7,3,9,4,5,6,10,12,8],
                 [10,12,1,9,2,7,3,4,5,11,6,8],
                 [10,12,1,9,2,7,3,11,4,5,6,8],
                 [9,12,1,11,2,7,3,4,5,8,10,6],
                 [1,11,2,7,3,4,5,8,9,6,12,10],
                 [9,12,1,11,2,7,3,8,4,5,10,6],
                 [1,11,2,7,3,8,4,5,9,6,12,10],
                 [1,8,2,7,3,10,4,9,5,12,6,11],
                 [1,8,2,7,3,10,4,9,5,11,12,6],
                 [1,8,2,7,3,9,10,4,5,11,12,6],
                 [1,8,2,7,3,9,11,4,10,5,12,6],
                 [1,8,2,7,3,9,4,12,10,5,11,6],
                 [1,8,2,7,3,9,4,12,5,11,10,6],
                 [10,8,1,7,2,12,3,9,4,5,6,11],
                 [10,8,1,7,2,12,3,9,4,11,5,6],
                 [10,8,1,7,2,11,3,9,12,4,5,6],
                 [10,8,1,7,2,11,3,9,4,5,12,6],
                 [8,12,1,7,2,11,3,9,4,5,10,6],
                 [8,11,1,7,12,2,3,9,4,5,10,6],
                 [1,7,8,2,3,9,10,4,5,11,12,6],
                 [1,7,8,2,3,9,11,4,10,5,12,6],
                 [1,7,8,2,3,9,4,12,10,5,11,6],
                 [1,7,8,2,3,9,4,12,5,11,10,6],
                 [9,12,1,7,2,11,8,3,4,5,10,6],
                 [9,11,1,7,12,2,8,3,4,5,10,6],
                 [1,7,9,2,8,3,11,4,10,5,12,6],
                 [1,7,9,2,8,3,4,12,10,5,11,6],
                 [1,7,9,2,8,3,4,12,5,11,10,6],
                 [1,7,2,12,8,3,9,4,5,11,6,10],
                 [1,7,2,11,8,3,9,4,12,5,6,10],
                 [1,7,11,2,8,3,9,4,5,10,12,6],
                 [1,7,2,12,8,3,9,4,5,10,11,6],
                 [1,7,10,2,8,3,4,12,9,5,6,11],
                 [1,7,10,2,8,3,4,11,9,5,12,6],
                 [1,7,11,2,8,3,10,4,9,5,12,6],
                 [1,7,2,12,8,3,10,4,9,5,11,6],
                 [1,7,2,12,8,3,4,11,9,5,10,6],
                 [1,7,2,11,8,3,12,4,9,5,10,6],
                 [1,7,2,12,8,3,4,5,9,6,10,11],
                 [1,7,2,11,8,3,4,5,9,6,12,10],
                 [1,7,2,12,8,3,4,11,5,10,9,6],
                 [1,7,2,11,8,3,12,4,5,10,9,6],
                 [1,7,11,2,8,3,4,10,12,5,9,6],
                 [1,7,2,12,8,3,4,10,11,5,9,6],
                 [1,7,2,10,8,3,4,12,5,11,9,6],
                 [1,7,2,10,8,3,4,11,12,5,9,6],
                 [1,7,2,12,3,11,8,4,5,10,6,9],
                 [1,7,2,11,12,3,8,4,5,10,6,9],
                 [1,7,11,2,3,10,8,4,12,5,6,9],
                 [1,7,2,12,3,10,8,4,11,5,6,9],
                 [1,7,2,10,3,12,8,4,5,11,6,9],
                 [1,7,2,10,3,11,8,4,12,5,6,9],
                 [1,7,10,2,3,11,8,4,5,9,12,6],
                 [1,7,11,2,10,3,8,4,5,9,12,6],
                 [1,7,2,12,10,3,8,4,5,9,11,6],
                 [1,7,2,12,3,11,8,4,5,9,10,6],
                 [1,7,2,11,12,3,8,4,5,9,10,6],
                 [1,7,2,12,3,9,8,4,5,11,6,10],
                 [1,7,2,11,3,9,8,4,12,5,6,10],
                 [1,7,11,2,3,9,8,4,5,10,12,6],
                 [1,7,2,12,3,9,8,4,5,10,11,6],
                 [10,9,1,7,2,12,3,4,8,5,6,11],
                 [10,9,1,7,2,11,3,4,8,5,12,6],
                 [9,12,1,7,2,3,4,11,8,5,10,6],
                 [9,12,1,7,2,11,3,4,8,5,10,6],
                 [9,11,1,7,12,2,3,4,8,5,10,6],
                 [9,11,1,7,2,3,12,4,8,5,10,6],
                 [1,7,2,12,9,3,4,11,8,5,6,10],
                 [1,7,2,11,9,3,12,4,8,5,6,10],
                 [1,7,11,2,9,3,4,10,8,5,12,6],
                 [1,7,2,12,9,3,4,10,8,5,11,6],
                 [1,7,11,2,10,3,9,4,8,5,12,6],
                 [1,7,2,12,10,3,9,4,8,5,11,6],
                 [1,7,2,12,3,11,9,4,8,5,10,6],
                 [1,7,2,11,12,3,9,4,8,5,10,6],
                 [1,7,2,12,3,4,8,5,9,6,10,11],
                 [1,7,2,3,4,11,8,5,9,6,12,10],
                 [1,7,2,11,3,4,8,5,9,6,12,10],
                 [1,7,2,12,3,11,4,10,8,5,9,6],
                 [1,7,2,11,12,3,4,10,8,5,9,6],
                 [1,7,2,12,3,10,11,4,8,5,9,6],
                 [1,7,2,12,3,4,5,11,8,6,9,10],
                 [1,7,2,12,3,11,4,5,8,6,9,10],
                 [1,7,11,2,3,4,5,10,8,6,12,9],
                 [1,7,2,3,11,4,5,10,8,6,12,9],
                 [1,7,2,3,4,12,5,10,8,6,11,9],
                 [1,7,2,12,3,4,5,10,8,6,11,9],
                 [1,7,11,2,3,10,4,5,8,6,12,9],
                 [1,7,2,12,3,10,4,5,8,6,11,9],
                 [1,7,2,10,3,12,4,5,8,6,9,11],
                 [1,7,2,10,3,11,4,5,8,6,12,9],
                 [1,7,2,3,4,11,5,9,8,6,12,10],
                 [1,7,2,11,3,4,5,9,8,6,12,10],
                 [1,7,2,12,3,11,4,10,5,9,8,6],
                 [1,7,2,12,3,10,11,4,5,9,8,6],
                 [1,7,2,12,10,3,4,9,11,5,8,6],
                 [1,7,2,12,3,9,4,5,8,6,10,11],
                 [1,7,2,11,3,9,4,5,8,6,12,10],
                 [1,7,2,12,3,9,4,11,5,10,8,6],
                 [1,7,2,12,3,9,4,10,11,5,8,6],
                 [10,12,1,7,2,9,3,11,4,5,8,6],
                 [8,7,1,2,3,11,4,6,5,9,12,10],
                 [8,7,1,11,2,3,4,6,5,9,12,10],
                 [8,7,11,1,2,3,4,6,5,10,12,9],
                 [8,7,1,2,11,3,4,6,5,10,12,9],
                 [8,7,1,2,3,12,4,6,5,10,11,9],
                 [8,12,7,1,2,11,3,10,4,6,5,9],
                 [8,11,7,1,12,2,3,10,4,6,5,9],
                 [11,8,7,1,2,10,12,3,4,6,5,9],
                 [8,12,7,1,2,10,11,3,4,6,5,9],
                 [8,12,7,10,11,1,2,3,4,6,5,9],
                 [8,10,7,1,2,12,3,11,4,6,5,9],
                 [8,10,7,1,2,11,12,3,4,6,5,9],
                 [8,10,7,12,1,11,2,3,4,6,5,9],
                 [10,8,7,1,2,12,3,9,4,6,5,11],
                 [10,8,7,1,2,11,3,9,4,6,12,5],
                 [8,12,7,1,2,11,3,9,4,6,10,5],
                 [8,11,7,1,12,2,3,9,4,6,10,5],
                 [8,12,7,1,2,9,3,11,4,6,5,10],
                 [8,11,7,1,2,9,12,3,4,6,5,10],
                 [8,10,7,1,2,9,3,11,4,6,12,5],
                 [8,12,7,9,1,11,2,3,4,6,5,10],
                 [8,10,7,9,1,11,2,3,4,6,12,5],
                 [8,9,10,7,1,11,2,3,4,6,12,5],
                 [8,9,7,12,1,11,2,3,4,6,10,5],
                 [9,7,8,1,10,2,3,12,4,6,5,11],
                 [9,7,8,1,10,2,3,11,4,6,12,5],
                 [9,7,8,1,11,2,10,3,4,6,12,5],
                 [9,7,8,1,2,12,10,3,4,6,11,5],
                 [9,7,8,1,2,12,3,11,4,6,10,5],
                 [9,7,8,1,2,11,12,3,4,6,10,5],
                 [7,12,8,1,9,2,3,11,4,6,5,10],
                 [7,11,8,1,9,2,12,3,4,6,5,10],
                 [7,10,8,1,9,2,3,12,4,6,5,11],
                 [7,10,8,1,9,2,3,11,4,6,12,5],
                 [10,7,8,1,2,11,9,3,4,6,12,5],
                 [7,12,8,1,2,11,9,3,4,6,10,5],
                 [7,12,8,1,2,11,3,10,4,6,9,5],
                 [7,11,8,1,12,2,3,10,4,6,9,5],
                 [11,7,8,1,2,10,12,3,4,6,9,5],
                 [7,12,8,1,2,10,11,3,4,6,9,5],
                 [7,10,8,1,2,12,3,11,4,6,9,5],
                 [7,10,8,1,2,11,12,3,4,6,9,5],
                 [7,1,8,2,3,11,4,6,5,9,12,10],
                 [7,1,8,2,11,3,4,6,5,10,12,9],
                 [7,1,8,2,3,12,4,6,5,10,11,9],
                 [7,12,1,11,8,2,3,10,4,6,5,9],
                 [11,7,1,10,8,2,12,3,4,6,5,9],
                 [7,12,1,10,8,2,11,3,4,6,5,9],
                 [7,10,1,11,8,2,12,3,4,6,5,9],
                 [10,7,1,11,8,2,3,9,4,6,12,5],
                 [7,12,1,11,8,2,3,9,4,6,10,5],
                 [7,12,1,9,8,2,3,11,4,6,5,10],
                 [7,11,1,9,8,2,12,3,4,6,5,10],
                 [7,10,1,9,8,2,3,12,4,6,5,11],
                 [7,10,1,9,8,2,3,11,4,6,12,5],
                 [7,9,10,1,8,2,3,12,4,6,5,11],
                 [7,9,10,1,8,2,3,11,4,6,12,5],
                 [7,9,11,1,8,2,10,3,4,6,12,5],
                 [7,9,1,11,8,2,12,3,4,6,10,5],
                 [9,7,10,1,2,12,8,3,4,6,5,11],
                 [9,7,10,1,2,11,8,3,4,6,12,5],
                 [9,7,11,1,10,2,8,3,4,6,12,5],
                 [9,7,1,12,2,11,8,3,4,6,10,5],
                 [9,12,7,1,2,11,8,3,4,6,10,5],
                 [9,7,1,11,12,2,8,3,4,6,10,5],
                 [9,11,7,1,12,2,8,3,4,6,10,5],
                 [7,12,9,1,2,11,8,3,4,6,5,10],
                 [7,11,9,1,12,2,8,3,4,6,5,10],
                 [7,10,9,1,2,12,8,3,4,6,5,11],
                 [7,10,9,1,2,11,8,3,4,6,12,5],
                 [10,7,1,11,9,2,8,3,4,6,12,5],
                 [7,12,1,11,9,2,8,3,4,6,10,5],
                 [7,1,2,11,8,3,4,6,9,5,12,10],
                 [7,12,1,11,2,10,8,3,4,6,9,5],
                 [11,7,1,10,12,2,8,3,4,6,9,5],
                 [7,12,1,10,11,2,8,3,4,6,9,5],
                 [7,10,1,12,2,11,8,3,4,6,9,5],
                 [7,10,1,11,12,2,8,3,4,6,9,5],
                 [7,12,1,11,2,3,4,6,8,5,9,10],
                 [7,1,11,2,3,10,4,6,8,5,12,9],
                 [7,1,2,12,3,10,4,6,8,5,11,9],
                 [7,1,2,10,3,12,4,6,8,5,9,11],
                 [7,1,2,10,3,11,4,6,8,5,12,9],
                 [7,10,1,2,3,12,4,6,8,5,9,11],
                 [7,10,1,2,3,11,4,6,8,5,12,9],
                 [7,10,1,11,2,3,4,6,8,5,12,9],
                 [7,1,2,11,3,9,4,6,8,5,12,10],
                 [7,12,1,11,2,10,3,9,4,6,8,5],
                 [11,7,1,10,12,2,3,9,4,6,8,5],
                 [7,12,1,10,11,2,3,9,4,6,8,5],
                 [7,10,1,12,2,11,3,9,4,6,8,5],
                 [7,10,1,11,12,2,3,9,4,6,8,5],
                 [10,7,1,12,2,9,3,11,4,6,8,5],
                 [10,7,1,11,2,9,12,3,4,6,8,5],
                 [11,7,10,1,2,9,12,3,4,6,8,5],
                 [7,12,10,1,2,9,11,3,4,6,8,5],
                 [7,12,1,11,2,9,10,3,4,6,8,5],
                 [7,12,1,9,2,11,3,10,4,6,8,5],
                 [7,11,1,9,12,2,3,10,4,6,8,5],
                 [11,7,1,9,2,10,12,3,4,6,8,5],
                 [7,12,1,9,2,10,11,3,4,6,8,5],
                 [7,10,1,9,2,12,3,11,4,6,8,5],
                 [7,10,1,9,2,11,12,3,4,6,8,5],
                 [10,12,7,9,1,2,3,11,4,6,8,5],
                 [10,12,7,9,1,11,2,3,4,6,8,5],
                 [7,9,10,1,2,12,3,11,4,6,8,5],
                 [7,9,10,1,2,11,12,3,4,6,8,5],
                 [7,9,11,1,10,2,12,3,4,6,8,5],
                 [7,9,1,12,10,2,11,3,4,6,8,5],
                 [7,9,1,12,2,11,10,3,4,6,8,5],
                 [7,9,1,11,12,2,10,3,4,6,8,5],
                 [11,1,7,2,3,10,4,6,5,8,12,9],
                 [1,10,7,2,3,12,4,6,5,8,9,11],
                 [1,10,7,2,3,11,4,6,5,8,12,9],
                 [10,1,7,2,3,12,4,6,5,9,8,11],
                 [10,1,7,2,3,11,4,6,5,9,12,8],
                 [11,1,7,2,10,3,4,6,5,9,12,8],
                 [1,11,7,2,12,3,4,6,5,9,10,8],
                 [1,11,7,2,3,9,4,6,5,8,12,10],
                 [11,1,7,2,3,9,4,6,5,10,12,8],
                 [10,12,1,9,7,2,3,11,4,6,5,8],
                 [1,9,7,2,11,3,4,6,10,5,12,8],
                 [1,9,7,2,3,12,4,6,10,5,11,8],
                 [9,12,1,11,7,2,3,8,4,6,10,5],
                 [1,11,7,2,3,8,4,6,9,5,12,10],
                 [1,8,7,2,3,11,4,6,5,9,12,10],
                 [1,8,7,2,11,3,4,6,5,10,12,9],
                 [1,8,7,2,3,12,4,6,5,10,11,9],
                 [8,1,11,2,7,3,4,6,5,10,12,9],
                 [8,1,2,12,7,3,4,6,5,10,11,9],
                 [8,12,1,11,2,10,7,3,4,6,5,9],
                 [11,8,1,10,12,2,7,3,4,6,5,9],
                 [8,12,1,10,11,2,7,3,4,6,5,9],
                 [8,10,1,12,2,11,7,3,4,6,5,9],
                 [8,10,1,11,12,2,7,3,4,6,5,9],
                 [8,12,1,11,2,9,7,3,4,6,10,5],
                 [8,12,1,9,2,11,7,3,4,6,5,10],
                 [8,11,1,9,12,2,7,3,4,6,5,10],
                 [9,12,1,11,8,2,7,3,4,6,10,5],
                 [1,11,8,2,7,3,4,6,9,5,12,10],
                 [11,1,2,10,7,3,4,6,8,5,12,9],
                 [1,10,2,12,7,3,4,6,8,5,9,11],
                 [1,10,2,11,7,3,4,6,8,5,12,9],
                 [1,11,2,9,7,3,4,6,8,5,12,10],
                 [10,12,1,9,2,11,7,3,4,6,8,5],
                 [1,11,2,3,4,6,7,5,12,8,9,10],
                 [1,11,2,3,4,6,7,5,8,9,12,10],
                 [11,1,2,3,4,6,7,5,8,10,12,9],
                 [1,2,11,3,4,6,7,5,8,10,12,9],
                 [1,2,3,12,4,6,7,5,8,10,11,9],
                 [10,1,2,12,3,9,4,6,7,5,8,11],
                 [10,1,2,11,3,9,4,6,7,5,12,8],
                 [11,1,10,2,3,9,4,6,7,5,12,8],
                 [1,12,2,11,3,9,4,6,7,5,10,8],
                 [1,11,12,2,3,9,4,6,7,5,10,8],
                 [1,12,2,9,3,11,4,6,7,5,8,10],
                 [1,11,2,9,12,3,4,6,7,5,8,10],
                 [11,1,2,9,3,10,4,6,7,5,12,8],
                 [1,10,2,9,3,12,4,6,7,5,8,11],
                 [1,10,2,9,3,11,4,6,7,5,12,8],
                 [1,9,10,2,3,12,4,6,7,5,8,11],
                 [1,9,10,2,3,11,4,6,7,5,12,8],
                 [1,9,11,2,10,3,4,6,7,5,12,8],
                 [1,9,2,12,10,3,4,6,7,5,11,8],
                 [1,9,2,12,3,11,4,6,7,5,10,8],
                 [1,9,2,11,12,3,4,6,7,5,10,8],
                 [11,1,2,10,3,8,4,6,7,5,12,9],
                 [1,10,2,12,3,8,4,6,7,5,9,11],
                 [1,10,2,11,3,8,4,6,7,5,12,9],
                 [1,11,2,9,3,8,4,6,7,5,12,10],
                 [11,9,10,1,2,8,12,3,4,6,7,5],
                 [9,12,10,1,2,8,11,3,4,6,7,5],
                 [9,12,1,11,2,8,10,3,4,6,7,5],
                 [1,11,2,8,9,3,4,6,7,5,12,10],
                 [1,8,11,2,3,10,4,6,7,5,12,9],
                 [1,8,2,12,3,10,4,6,7,5,11,9],
                 [1,8,2,10,3,12,4,6,7,5,9,11],
                 [1,8,2,10,3,11,4,6,7,5,12,9],
                 [1,2,3,6,11,4,5,7,8,10,12,9],
                 [1,2,3,6,4,12,5,7,8,10,11,9],
                 [1,12,2,11,3,6,4,5,7,10,8,9],
                 [1,11,12,2,3,6,4,5,7,10,8,9],
                 [1,2,3,6,11,4,5,10,7,8,12,9],
                 [1,2,3,6,4,12,5,10,7,8,11,9],
                 [10,1,2,12,3,6,4,5,7,9,8,11],
                 [10,1,2,11,3,6,4,5,7,9,12,8],
                 [11,1,10,2,3,6,4,5,7,9,12,8],
                 [1,11,12,2,3,6,4,5,7,9,10,8],
                 [10,1,2,12,3,6,4,9,5,7,8,11],
                 [10,1,2,11,3,6,4,9,5,7,12,8],
                 [11,1,10,2,3,6,4,9,5,7,12,8],
                 [1,12,2,11,3,6,4,9,5,7,10,8],
                 [1,11,12,2,3,6,4,9,5,7,10,8],
                 [1,12,2,9,3,6,4,11,5,7,8,10],
                 [1,11,2,9,3,6,12,4,5,7,8,10],
                 [11,1,2,9,3,6,4,5,7,10,12,8],
                 [11,1,2,9,3,6,4,10,5,7,12,8],
                 [1,10,2,9,3,6,4,12,5,7,8,11],
                 [1,10,2,9,3,6,4,11,5,7,12,8],
                 [1,9,10,2,3,6,4,12,5,7,8,11],
                 [1,9,10,2,3,6,4,11,5,7,12,8],
                 [1,9,11,2,3,6,10,4,5,7,12,8],
                 [1,9,2,12,3,6,10,4,5,7,11,8],
                 [1,9,11,2,3,6,4,5,10,7,12,8],
                 [1,9,2,12,3,6,4,5,10,7,11,8],
                 [1,9,2,12,3,6,4,11,5,7,10,8],
                 [1,9,2,11,3,6,12,4,5,7,10,8],
                 [9,1,10,2,3,6,4,12,5,8,7,11],
                 [9,1,10,2,3,6,4,11,5,8,12,7],
                 [9,1,11,2,3,6,10,4,5,8,12,7],
                 [9,1,2,12,3,6,10,4,5,8,11,7],
                 [9,1,2,12,3,6,4,11,5,8,10,7],
                 [9,12,1,2,3,6,4,11,5,8,10,7],
                 [9,1,2,11,3,6,12,4,5,8,10,7],
                 [9,11,1,2,3,6,12,4,5,8,10,7],
                 [1,12,9,2,3,6,4,11,5,8,7,10],
                 [1,11,9,2,3,6,12,4,5,8,7,10],
                 [11,1,9,2,3,6,4,10,5,8,12,7],
                 [1,10,9,2,3,6,4,12,5,8,7,11],
                 [1,10,9,2,3,6,4,11,5,8,12,7],
                 [10,1,2,12,3,6,9,4,5,8,7,11],
                 [10,1,2,11,3,6,9,4,5,8,12,7],
                 [11,1,10,2,3,6,9,4,5,8,12,7],
                 [1,12,2,11,3,6,9,4,5,8,10,7],
                 [1,11,12,2,3,6,9,4,5,8,10,7],
                 [1,2,3,6,4,11,5,8,9,7,12,10],
                 [1,12,2,11,3,6,4,10,5,8,9,7],
                 [1,11,12,2,3,6,4,10,5,8,9,7],
                 [11,1,2,10,3,6,12,4,5,8,9,7],
                 [1,12,2,10,3,6,11,4,5,8,9,7],
                 [1,10,2,12,3,6,4,11,5,8,9,7],
                 [1,10,2,11,3,6,12,4,5,8,9,7],
                 [1,11,12,2,3,6,4,8,5,10,7,9],
                 [11,1,2,10,3,6,4,8,12,5,7,9],
                 [11,1,2,10,3,6,4,8,5,7,12,9],
                 [1,10,2,12,3,6,4,8,5,7,9,11],
                 [1,10,2,12,3,6,4,8,5,11,7,9],
                 [1,10,2,11,3,6,4,8,12,5,7,9],
                 [1,10,2,11,3,6,4,8,5,7,12,9],
                 [10,1,2,12,3,6,4,8,5,9,7,11],
                 [10,1,2,11,3,6,4,8,5,9,12,7],
                 [11,1,10,2,3,6,4,8,5,9,12,7],
                 [1,11,12,2,3,6,4,8,5,9,10,7],
                 [1,11,2,9,3,6,4,8,12,5,7,10],
                 [11,1,2,9,3,6,4,8,5,10,12,7],
                 [1,9,11,2,3,6,4,8,10,5,12,7],
                 [1,9,2,12,3,6,4,8,10,5,11,7],
                 [1,9,2,12,3,6,4,8,5,11,10,7],
                 [1,9,2,11,3,6,4,8,12,5,10,7],
                 [11,9,10,1,2,8,3,6,12,4,5,7],
                 [9,12,10,1,2,8,3,6,11,4,5,7],
                 [9,12,1,11,2,8,3,6,10,4,5,7],
                 [9,1,2,8,3,6,11,4,10,5,12,7],
                 [9,1,2,8,3,6,4,12,10,5,11,7],
                 [9,1,2,8,3,6,4,12,5,11,10,7],
                 [9,1,2,8,3,6,4,11,12,5,10,7],
                 [1,11,2,8,3,6,9,4,12,5,7,10],
                 [11,1,2,8,3,6,9,4,5,10,12,7],
                 [10,1,2,8,3,6,4,12,9,5,7,11],
                 [10,1,2,8,3,6,4,11,9,5,12,7],
                 [11,1,2,8,3,6,10,4,9,5,12,7],
                 [1,11,2,8,3,6,12,4,9,5,10,7],
                 [1,11,2,8,3,6,4,5,9,7,12,10],
                 [1,11,2,8,3,6,12,4,5,10,9,7],
                 [11,1,2,8,3,6,4,10,12,5,9,7],
                 [1,10,2,8,3,6,4,12,5,11,9,7],
                 [1,10,2,8,3,6,4,11,12,5,9,7],
                 [1,8,2,11,3,6,4,5,7,9,12,10],
                 [1,8,11,2,3,6,4,10,5,7,12,9],
                 [1,8,2,12,3,6,4,10,5,7,11,9],
                 [1,8,2,10,3,6,4,12,5,7,9,11],
                 [1,8,2,10,3,6,4,12,5,11,7,9],
                 [1,8,2,10,3,6,4,11,12,5,7,9],
                 [1,8,2,10,3,6,4,11,5,7,12,9],
                 [1,8,10,2,3,6,4,12,5,9,7,11],
                 [1,8,10,2,3,6,4,11,5,9,12,7],
                 [1,8,2,11,3,6,4,9,12,5,7,10],
                 [1,8,11,2,3,6,4,9,5,10,12,7],
                 [1,8,2,9,3,6,11,4,10,5,12,7],
                 [1,8,2,9,3,6,4,12,10,5,11,7],
                 [1,8,2,9,3,6,4,12,5,11,10,7],
                 [8,1,11,2,3,6,4,7,5,10,12,9],
                 [8,1,2,12,3,6,4,7,5,10,11,9],
                 [8,12,1,11,2,10,3,6,4,7,5,9],
                 [11,8,1,10,12,2,3,6,4,7,5,9],
                 [8,12,1,10,11,2,3,6,4,7,5,9],
                 [8,10,1,11,12,2,3,6,4,7,5,9],
                 [8,12,1,11,2,9,3,6,4,7,10,5],
                 [8,12,1,9,2,11,3,6,4,7,5,10],
                 [8,11,1,9,12,2,3,6,4,7,5,10],
                 [1,10,2,12,3,6,4,7,8,5,9,11],
                 [1,10,2,11,3,6,4,7,8,5,12,9],
                 [1,10,2,7,3,6,4,12,5,8,9,11],
                 [10,1,2,7,3,6,4,12,5,9,8,11],
                 [10,1,2,7,3,6,4,11,5,9,12,8],
                 [11,1,2,7,3,6,10,4,5,9,12,8],
                 [1,11,2,7,3,6,12,4,5,9,10,8],
                 [11,1,2,7,3,6,4,9,5,10,12,8],
                 [1,9,2,7,3,6,11,4,10,5,12,8],
                 [1,9,2,7,3,6,4,12,10,5,11,8],
                 [1,8,2,7,3,6,11,4,5,10,12,9],
                 [1,8,2,7,3,6,4,12,5,10,11,9],
                 [11,8,1,7,2,10,3,6,12,4,5,9],
                 [8,12,1,7,2,10,3,6,11,4,5,9],
                 [8,12,1,7,2,9,3,6,4,11,5,10],
                 [8,11,1,7,2,9,3,6,12,4,5,10],
                 [1,7,8,2,3,6,11,4,5,10,12,9],
                 [1,7,8,2,3,6,4,12,5,10,11,9],
                 [9,12,1,7,2,11,3,6,8,4,10,5],
                 [9,11,1,7,12,2,3,6,8,4,10,5],
                 [1,7,11,2,3,6,4,10,8,5,12,9],
                 [1,7,2,12,3,6,4,10,8,5,11,9],
                 [1,7,2,10,3,6,4,12,8,5,9,11],
                 [7,1,2,6,8,3,4,12,5,10,11,9],
                 [7,12,1,11,2,6,8,3,4,10,5,9],
                 [11,7,1,10,2,6,8,3,12,4,5,9],
                 [7,12,1,10,2,6,8,3,11,4,5,9],
                 [7,10,1,11,2,6,8,3,12,4,5,9],
                 [7,12,1,11,2,6,8,3,4,9,10,5],
                 [7,12,1,9,2,6,8,3,4,11,5,10],
                 [7,11,1,9,2,6,8,3,12,4,5,10],
                 [10,12,7,9,1,11,2,6,8,3,4,5],
                 [7,9,10,1,2,6,8,3,4,12,5,11],
                 [7,9,10,1,2,6,8,3,4,11,12,5],
                 [7,9,11,1,2,6,8,3,10,4,12,5],
                 [7,9,1,11,2,6,8,3,12,4,10,5],
                 [9,7,10,1,2,6,3,12,8,4,5,11],
                 [9,7,10,1,2,6,3,11,8,4,12,5],
                 [9,7,11,1,2,6,10,3,8,4,12,5],
                 [9,7,1,11,2,6,12,3,8,4,10,5],
                 [7,12,1,11,2,6,3,10,8,4,9,5],
                 [11,7,1,10,2,6,12,3,8,4,9,5],
                 [7,12,1,10,2,6,11,3,8,4,9,5],
                 [7,10,1,11,2,6,12,3,8,4,9,5],
                 [10,1,2,6,7,3,4,11,5,9,12,8],
                 [11,1,2,6,7,3,10,4,5,9,12,8],
                 [1,11,2,6,7,3,12,4,5,9,10,8],
                 [11,1,2,6,7,3,4,9,5,10,12,8],
                 [1,9,2,6,7,3,11,4,10,5,12,8],
                 [8,1,2,6,3,12,7,4,5,10,11,9],
                 [8,12,1,11,2,6,3,10,7,4,5,9],
                 [11,8,1,10,2,6,12,3,7,4,5,9],
                 [8,12,1,10,2,6,11,3,7,4,5,9],
                 [8,10,1,11,2,6,12,3,7,4,5,9],
                 [8,12,1,11,2,6,3,9,7,4,10,5],
                 [8,11,1,9,2,6,12,3,7,4,5,10],
                 [1,10,2,6,3,12,7,4,8,5,9,11],
                 [1,11,2,6,3,4,7,5,12,8,9,10],
                 [11,1,2,6,3,4,7,5,8,10,12,9],
                 [10,1,2,6,3,12,4,9,7,5,8,11],
                 [11,1,2,6,10,3,4,9,7,5,12,8],
                 [1,11,2,6,12,3,4,9,7,5,10,8],
                 [1,11,2,6,3,9,12,4,7,5,8,10],
                 [11,1,2,6,3,9,4,10,7,5,12,8],
                 [1,9,2,6,3,12,10,4,7,5,11,8],
                 [1,9,2,6,3,12,4,11,7,5,10,8],
                 [1,9,2,6,3,11,12,4,7,5,10,8],
                 [1,10,2,6,3,12,4,8,7,5,9,11],
                 [1,8,2,6,3,12,4,10,7,5,11,9],
                 [1,6,11,2,3,4,5,7,8,10,12,9],
                 [1,6,2,3,11,4,5,7,8,10,12,9],
                 [1,6,2,12,3,4,5,7,8,10,11,9],
                 [1,6,2,9,3,12,10,4,5,7,11,8],
                 [1,6,2,9,3,12,4,11,5,7,10,8],
                 [1,6,2,9,3,11,12,4,5,7,10,8],
                 [1,6,2,12,3,10,4,8,5,7,11,9],
                 [1,6,2,10,3,12,4,8,5,7,9,11],
                 [9,11,1,6,12,2,3,8,10,4,5,7],
                 [1,6,9,2,3,8,11,4,10,5,12,7],
                 [1,6,2,8,3,12,4,10,5,7,11,9],
                 [8,11,1,6,2,9,12,3,4,7,5,10],
                 [1,6,2,12,3,10,4,7,8,5,11,9],
                 [1,6,2,10,3,12,4,7,8,5,9,11],
                 [1,6,2,12,3,7,4,10,5,8,11,9],
                 [6,9,10,1,2,12,3,5,4,7,8,11],
                 [6,9,1,11,12,2,3,5,4,7,10,8],
                 [9,6,10,1,2,12,3,5,4,8,7,11],
                 [9,6,1,11,12,2,3,5,4,8,10,7],
                 [6,1,2,11,3,5,4,8,9,7,12,10],
                 [6,12,1,11,2,10,3,5,4,8,9,7],
                 [11,6,1,10,12,2,3,5,4,8,9,7],
                 [6,12,1,10,11,2,3,5,4,8,9,7],
                 [6,10,1,11,12,2,3,5,4,8,9,7],
                 [6,12,1,11,2,8,3,5,4,10,7,9],
                 [6,8,1,11,12,2,3,5,4,10,7,9],
                 [6,8,11,1,2,10,3,5,12,4,7,9],
                 [6,8,1,10,2,12,3,5,4,7,9,11],
                 [6,8,1,10,2,12,3,5,4,11,7,9],
                 [6,8,1,10,2,11,3,5,12,4,7,9],
                 [6,8,10,1,2,12,3,5,4,9,7,11],
                 [6,8,1,11,12,2,3,5,4,9,10,7],
                 [6,8,1,9,2,12,3,5,10,4,11,7],
                 [6,8,1,9,2,12,3,5,4,11,10,7],
                 [6,8,1,9,2,11,3,5,12,4,10,7],
                 [6,8,1,7,2,12,3,5,4,10,11,9],
                 [1,11,12,2,3,5,6,4,7,9,10,8],
                 [11,8,1,10,2,5,12,3,4,7,6,9],
                 [5,8,1,11,2,4,6,3,7,9,12,10],
                 [5,8,11,1,2,4,6,3,7,10,12,9],
                 [8,10,5,7,1,11,2,4,6,3,12,9],
                 [1,11,2,4,5,3,6,8,9,7,12,10],
                 [7,10,1,4,2,11,3,6,8,5,12,9]];

export {tile_sets, t2_data, s1_data, s2_data, s3_data, p2_data, h1_data, h2_data, o1_data};
